import { cn } from "~/design-system/lib";
import { IconProps } from "~/design-system/types";

export * from "./AnimatedEyeIcon";
export * from "./LogoImage";
export * from "./PortalCloseIcon";
export * from "./SocialMediaIcons";

export function IkhtebarIcon(props: IconProps) {
  return (
    <svg
      width="38"
      height="39"
      viewBox="0 0 38 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.3125 36.125C25.6684 36.125 24.0613 35.6375 22.6943 34.7241C21.3273 33.8107 20.2619 32.5125 19.6328 30.9936C19.0036 29.4746 18.839 27.8033 19.1597 26.1908C19.4805 24.5783 20.2722 23.0972 21.4347 21.9347C22.5972 20.7722 24.0783 19.9805 25.6908 19.6597C27.3033 19.339 28.9746 19.5036 30.4936 20.1328C32.0125 20.7619 33.3107 21.8273 34.2241 23.1943C35.1375 24.5613 35.625 26.1684 35.625 27.8125C35.6219 30.0162 34.7451 32.1286 33.1869 33.6869C31.6286 35.2451 29.5162 36.1219 27.3125 36.125ZM27.3125 21.875C26.1382 21.875 24.9902 22.2232 24.0138 22.8757C23.0374 23.5281 22.2764 24.4554 21.827 25.5403C21.3776 26.6253 21.26 27.8191 21.4891 28.9709C21.7182 30.1226 22.2837 31.1806 23.1141 32.011C23.9444 32.8413 25.0024 33.4068 26.1542 33.6359C27.3059 33.865 28.4998 33.7474 29.5847 33.298C30.6696 32.8486 31.5969 32.0876 32.2494 31.1112C32.9018 30.1348 33.25 28.9868 33.25 27.8125C33.2481 26.2384 32.622 24.7292 31.5089 23.6161C30.3958 22.5031 28.8866 21.8769 27.3125 21.875Z"
        fill="#23AFB6"
      />
      <path
        d="M30.875 29.6959L28.5 27.3209V24.25H26.125V28.3041L29.1959 31.375L30.875 29.6959ZM9.5 19.5H16.625V21.875H9.5V19.5ZM9.5 12.375H23.75V14.75H9.5V12.375Z"
        fill="#23AFB6"
      />
      <path
        d="M30.875 5.25C30.875 4.62011 30.6248 4.01602 30.1794 3.57062C29.734 3.12522 29.1299 2.875 28.5 2.875H4.75001C4.12012 2.875 3.51603 3.12522 3.07063 3.57062C2.62523 4.01602 2.37501 4.62011 2.37501 5.25V20.6875C2.37223 23.0558 3.01455 25.3802 4.23301 27.411C5.45147 29.4418 7.20005 31.1024 9.29101 32.2146L15.4375 35.4921V32.8L10.4096 30.1186C8.6992 29.2082 7.26879 27.8495 6.27177 26.188C5.27474 24.5266 4.74869 22.6251 4.75001 20.6875V5.25H28.5V15.9375H30.875V5.25Z"
        fill="#86B74D"
      />
    </svg>
  );
}

export function UniversalIcon({ color = "#151518", ...props }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 21C11.2613 21 10.0947 20.7633 9.00001 20.29C7.90534 19.816 6.95201 19.1727 6.14001 18.36C5.32801 17.5473 4.68467 16.594 4.21001 15.5C3.73534 14.406 3.49867 13.2393 3.50001 12C3.50001 10.7573 3.73667 9.58967 4.21001 8.497C4.68401 7.40367 5.32734 6.45133 6.14001 5.64C6.95267 4.82867 7.90601 4.18533 9.00001 3.71C10.0947 3.23667 11.2613 3 12.5 3C13.7427 3 14.9103 3.23667 16.003 3.71C17.0963 4.184 18.049 4.82733 18.861 5.64C19.673 6.45267 20.316 7.405 20.79 8.497C21.2633 9.59033 21.5 10.758 21.5 12C21.5 13.2387 21.2633 14.4053 20.79 15.5C20.316 16.5947 19.6727 17.548 18.86 18.36C18.0473 19.172 17.095 19.8153 16.003 20.29C14.911 20.7647 13.7433 21.0013 12.5 21ZM12.5 20.008C13.0867 19.254 13.5707 18.5137 13.952 17.787C14.3327 17.0603 14.6423 16.247 14.881 15.347H10.119C10.3837 16.2977 10.6997 17.1363 11.067 17.863C11.435 18.5897 11.9127 19.3047 12.5 20.008ZM11.227 19.858C10.7603 19.308 10.3343 18.628 9.94901 17.818C9.56367 17.0087 9.27701 16.1847 9.08901 15.346H5.25401C5.82734 16.5893 6.63967 17.6093 7.69101 18.406C8.74301 19.202 9.92167 19.686 11.227 19.858ZM13.773 19.858C15.0783 19.686 16.257 19.202 17.309 18.406C18.3603 17.6093 19.1727 16.5893 19.746 15.346H15.912C15.6587 16.1973 15.3397 17.0277 14.955 17.837C14.5697 18.647 14.1757 19.3213 13.773 19.858ZM4.84601 14.347H8.88101C8.80501 13.9363 8.75167 13.5363 8.72101 13.147C8.68901 12.7583 8.67301 12.376 8.67301 12C8.67301 11.624 8.68867 11.2417 8.72001 10.853C8.75134 10.4643 8.80467 10.0643 8.88001 9.653H4.84701C4.73834 9.99967 4.65334 10.3773 4.59201 10.786C4.53067 11.194 4.50001 11.5987 4.50001 12C4.50001 12.4013 4.53034 12.8063 4.59101 13.215C4.65167 13.6237 4.73667 14.0007 4.84601 14.346M9.88101 14.346H15.119C15.195 13.936 15.2483 13.5427 15.279 13.166C15.311 12.79 15.327 12.4013 15.327 12C15.327 11.5987 15.3113 11.21 15.28 10.834C15.2487 10.458 15.1953 10.0647 15.12 9.654H9.88001C9.80467 10.064 9.75134 10.4573 9.72001 10.834C9.68867 11.21 9.67301 11.5987 9.67301 12C9.67301 12.4013 9.68867 12.79 9.72001 13.166C9.75134 13.542 9.80567 13.9353 9.88101 14.346ZM16.12 14.346H20.154C20.2627 14 20.3477 13.623 20.409 13.215C20.4697 12.8063 20.5 12.4013 20.5 12C20.5 11.5987 20.4697 11.1937 20.409 10.785C20.3483 10.3763 20.2633 9.99933 20.154 9.654H16.119C16.195 10.064 16.2483 10.4637 16.279 10.853C16.311 11.2423 16.327 11.6247 16.327 12C16.327 12.3753 16.3113 12.7577 16.28 13.147C16.2487 13.5363 16.1953 13.9363 16.12 14.347M15.912 8.654H19.746C19.16 7.38467 18.3573 6.36467 17.338 5.594C16.3187 4.82333 15.1303 4.333 13.773 4.123C14.2397 4.737 14.6593 5.43933 15.032 6.23C15.4047 7.02 15.698 7.828 15.912 8.654ZM10.119 8.654H14.881C14.617 7.71533 14.2913 6.86667 13.904 6.108C13.5167 5.34933 13.0487 4.644 12.5 3.992C11.9513 4.64333 11.4833 5.34867 11.096 6.108C10.7087 6.86733 10.3823 7.716 10.119 8.654ZM5.25501 8.654H9.08901C9.30301 7.82867 9.59634 7.02067 9.96901 6.23C10.3417 5.43933 10.7613 4.737 11.228 4.123C9.85867 4.33367 8.66734 4.827 7.65401 5.603C6.64067 6.38033 5.84067 7.397 5.25401 8.653"
        fill={color}
      />
    </svg>
  );
}

export function SearchIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="11.7659"
        cy="11.7659"
        r="8.98856"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0176 18.4844L21.5416 21.9992"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MapPinIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="9"
        r="2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CompareIcon({ color = "#666666", ...props }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H13M17 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V7M20 17V18C20 18.5304 19.7893 19.0391 19.4142 19.4142C19.0391 19.7893 18.5304 20 18 20H17M20 11V13M12 2V22"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function BagIcon({ color = "#08080C", ...props }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.4904 23.25H7.50042C5.78042 23.25 4.49043 22.79 3.69043 21.88C2.89043 20.97 2.58042 19.65 2.79042 17.94L3.69043 10.44C3.95043 8.23 4.51043 6.25 8.41043 6.25H15.6104C19.5004 6.25 20.0604 8.23 20.3304 10.44L21.2304 17.94C21.4304 19.65 21.1304 20.98 20.3304 21.88C19.5004 22.79 18.2204 23.25 16.4904 23.25ZM8.40042 7.75C5.52042 7.75 5.38042 8.88999 5.17042 10.61L4.27043 18.11C4.12043 19.38 4.30042 20.31 4.81042 20.88C5.32042 21.45 6.22042 21.74 7.50042 21.74H16.4904C17.7704 21.74 18.6704 21.45 19.1804 20.88C19.6904 20.31 19.8704 19.38 19.7204 18.11L18.8204 10.61C18.6104 8.87999 18.4804 7.75 15.5904 7.75H8.40042Z"
        fill={color}
      />
      <path
        d="M16 9.25C15.59 9.25 15.25 8.91 15.25 8.5V5C15.25 3.92 14.58 3.25 13.5 3.25H10.5C9.42 3.25 8.75 3.92 8.75 5V8.5C8.75 8.91 8.41 9.25 8 9.25C7.59 9.25 7.25 8.91 7.25 8.5V5C7.25 3.09 8.59 1.75 10.5 1.75H13.5C15.41 1.75 16.75 3.09 16.75 5V8.5C16.75 8.91 16.41 9.25 16 9.25Z"
        fill={color}
      />
      <path
        d="M20.41 18.2812H8C7.59 18.2812 7.25 17.9412 7.25 17.5312C7.25 17.1213 7.59 16.7812 8 16.7812H20.41C20.82 16.7812 21.16 17.1213 21.16 17.5312C21.16 17.9412 20.82 18.2812 20.41 18.2812Z"
        fill={color}
      />
    </svg>
  );
}

export function CartIconV2(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.31344 6.8453C5.29852 6.68028 5.31815 6.51396 5.37107 6.35694C5.42398 6.19992 5.50903 6.05564 5.62078 5.9333C5.73254 5.81097 5.86855 5.71325 6.02016 5.64638C6.17176 5.57951 6.33564 5.54496 6.50133 5.54492H20.964C21.1427 5.545 21.319 5.58519 21.48 5.66252C21.641 5.73985 21.7826 5.85236 21.8944 5.99173C22.0061 6.13111 22.0851 6.29379 22.1256 6.46778C22.166 6.64177 22.1669 6.82262 22.1281 6.99699L20.9061 12.5053C20.6959 13.4519 20.1691 14.2985 19.4127 14.9052C18.6563 15.5119 17.7156 15.8425 16.7459 15.8423H10.019C8.95533 15.8424 7.93009 15.4446 7.14482 14.7271C6.35955 14.0096 5.87103 13.0244 5.7753 11.965L5.31344 6.8453ZM7.06034 7.24922L7.47279 11.8116C7.53025 12.4475 7.8236 13.0389 8.29513 13.4695C8.76665 13.9 9.38221 14.1385 10.0207 14.138H16.7476C17.3293 14.1379 17.8935 13.9394 18.3471 13.5753C18.8008 13.2112 19.1167 12.7033 19.2427 12.1355L20.3283 7.24922H7.06034Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.78906 2.68418C1.78906 2.45818 1.87884 2.24143 2.03865 2.08162C2.19846 1.92181 2.41521 1.83203 2.64121 1.83203H5.63056C5.839 1.83224 6.04014 1.90885 6.19591 2.04735C6.35169 2.18585 6.4513 2.37664 6.47589 2.58363L7.16102 8.37996C7.18746 8.60461 7.12358 8.83056 6.98343 9.00811C6.84328 9.18565 6.63833 9.30025 6.41368 9.3267C6.18904 9.35314 5.96309 9.28926 5.78554 9.14911C5.60799 9.00895 5.49339 8.80401 5.46695 8.57936L4.87214 3.53463H2.64121C2.41521 3.53463 2.19846 3.44485 2.03865 3.28504C1.87884 3.12523 1.78906 2.91019 1.78906 2.68418ZM9.45842 20.2947C9.68442 20.2947 9.90117 20.2049 10.061 20.0451C10.2208 19.8853 10.3106 19.6686 10.3106 19.4426C10.3106 19.2166 10.2208 18.9998 10.061 18.84C9.90117 18.6802 9.68442 18.5904 9.45842 18.5904C9.23242 18.5904 9.01567 18.6802 8.85586 18.84C8.69605 18.9998 8.60627 19.2166 8.60627 19.4426C8.60627 19.6686 8.69605 19.8853 8.85586 20.0451C9.01567 20.2049 9.23242 20.2947 9.45842 20.2947ZM9.45842 21.999C9.79414 21.999 10.1266 21.9329 10.4367 21.8044C10.7469 21.676 11.0287 21.4876 11.2661 21.2503C11.5035 21.0129 11.6918 20.7311 11.8203 20.4209C11.9487 20.1107 12.0149 19.7783 12.0149 19.4426C12.0149 19.1069 11.9487 18.7744 11.8203 18.4643C11.6918 18.1541 11.5035 17.8723 11.2661 17.6349C11.0287 17.3975 10.7469 17.2092 10.4367 17.0807C10.1266 16.9523 9.79414 16.8861 9.45842 16.8861C8.78041 16.8861 8.13016 17.1555 7.65073 17.6349C7.17131 18.1143 6.90197 18.7646 6.90197 19.4426C6.90197 20.1206 7.17131 20.7708 7.65073 21.2503C8.13016 21.7297 8.78041 21.999 9.45842 21.999ZM17.2334 20.2947C17.4594 20.2947 17.6762 20.2049 17.836 20.0451C17.9958 19.8853 18.0856 19.6686 18.0856 19.4426C18.0856 19.2166 17.9958 18.9998 17.836 18.84C17.6762 18.6802 17.4594 18.5904 17.2334 18.5904C17.0074 18.5904 16.7907 18.6802 16.6309 18.84C16.4711 18.9998 16.3813 19.2166 16.3813 19.4426C16.3813 19.6686 16.4711 19.8853 16.6309 20.0451C16.7907 20.2049 17.0074 20.2947 17.2334 20.2947ZM17.2334 21.999C17.5692 21.999 17.9016 21.9329 18.2118 21.8044C18.5219 21.676 18.8037 21.4876 19.0411 21.2503C19.2785 21.0129 19.4668 20.7311 19.5953 20.4209C19.7238 20.1107 19.7899 19.7783 19.7899 19.4426C19.7899 19.1069 19.7238 18.7744 19.5953 18.4643C19.4668 18.1541 19.2785 17.8723 19.0411 17.6349C18.8037 17.3975 18.5219 17.2092 18.2118 17.0807C17.9016 16.9523 17.5692 16.8861 17.2334 16.8861C16.5554 16.8861 15.9052 17.1555 15.4258 17.6349C14.9463 18.1143 14.677 18.7646 14.677 19.4426C14.677 20.1206 14.9463 20.7708 15.4258 21.2503C15.9052 21.7297 16.5554 21.999 17.2334 21.999Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function NotificationIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9969 2.51367C7.56259 2.51367 5.63592 6.52891 5.63592 9.1832C5.63592 11.167 5.92354 10.5832 4.82544 13.0032C3.48449 16.4518 8.87687 17.8613 11.9969 17.8613C15.1159 17.8613 20.5083 16.4518 19.1683 13.0032C18.0702 10.5832 18.3578 11.167 18.3578 9.1832C18.3578 6.52891 16.4302 2.51367 11.9969 2.51367Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3075 20.5117C13.0132 21.9574 10.9942 21.9746 9.6875 20.5117"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function UserIconV2({ color = "#666666", ...props }: IconProps) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white" />
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#F6F6F6" />
      <path
        d="M20 20.75C16.83 20.75 14.25 18.17 14.25 15C14.25 11.83 16.83 9.25 20 9.25C23.17 9.25 25.75 11.83 25.75 15C25.75 18.17 23.17 20.75 20 20.75ZM20 10.75C17.66 10.75 15.75 12.66 15.75 15C15.75 17.34 17.66 19.25 20 19.25C22.34 19.25 24.25 17.34 24.25 15C24.25 12.66 22.34 10.75 20 10.75Z"
        fill={color}
      />
      <path
        d="M28.5901 30.75C28.1801 30.75 27.8401 30.41 27.8401 30C27.8401 26.55 24.3202 23.75 20.0002 23.75C15.6802 23.75 12.1602 26.55 12.1602 30C12.1602 30.41 11.8202 30.75 11.4102 30.75C11.0002 30.75 10.6602 30.41 10.6602 30C10.6602 25.73 14.8502 22.25 20.0002 22.25C25.1502 22.25 29.3401 25.73 29.3401 30C29.3401 30.41 29.0001 30.75 28.5901 30.75Z"
        fill={color}
      />
    </svg>
  );
}

export function UserIconMobile(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.0007 10.6243C7.35898 10.6243 5.20898 8.47435 5.20898 5.83268C5.20898 3.19102 7.35898 1.04102 10.0007 1.04102C12.6423 1.04102 14.7923 3.19102 14.7923 5.83268C14.7923 8.47435 12.6423 10.6243 10.0007 10.6243ZM10.0007 2.29102C8.05065 2.29102 6.45898 3.88268 6.45898 5.83268C6.45898 7.78268 8.05065 9.37435 10.0007 9.37435C11.9507 9.37435 13.5423 7.78268 13.5423 5.83268C13.5423 3.88268 11.9507 2.29102 10.0007 2.29102Z"
        fill="currentColor"
      />
      <path
        d="M17.1585 18.9583C16.8168 18.9583 16.5335 18.675 16.5335 18.3333C16.5335 15.4583 13.6001 13.125 10.0001 13.125C6.40013 13.125 3.4668 15.4583 3.4668 18.3333C3.4668 18.675 3.18346 18.9583 2.8418 18.9583C2.50013 18.9583 2.2168 18.675 2.2168 18.3333C2.2168 14.775 5.70846 11.875 10.0001 11.875C14.2918 11.875 17.7835 14.775 17.7835 18.3333C17.7835 18.675 17.5001 18.9583 17.1585 18.9583Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ProfileIcon(props: IconProps) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.8008 7.5C13.8008 9.15685 12.4576 10.5 10.8008 10.5C9.14393 10.5 7.80078 9.15685 7.80078 7.5C7.80078 5.84315 9.14393 4.5 10.8008 4.5C12.4576 4.5 13.8008 5.84315 13.8008 7.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9525 16.5008C15.9525 14.1788 13.6425 12.3008 10.7985 12.3008C7.95453 12.3008 5.64453 14.1788 5.64453 16.5008"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowChevronDownIcon({
  color = "#9994AE",
  strokeWidth = "1.5",
  ...props
}: IconProps) {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.5834 4.95801L7.50008 9.04134L3.41675 4.95801"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowChevronUpIcon({ color = "#9994AE", ...props }: IconProps) {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.5834 9.95801L7.50008 5.04134L3.41675 9.95801"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowChevronRightIcon({ ...props }: IconProps) {
  return (
    <svg
      width="9"
      height="13"
      viewBox="0 0 9 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.72925 0.958659L7.27091 6.50033L1.72925 12.042"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowChevronLeftIcon({
  color = "#010000",
  className,
  ...props
}: IconProps) {
  return (
    <svg
      width="9"
      height="13"
      viewBox="0 0 9 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("rotate-180", className)}
      {...props}
    >
      <path
        d="M1.72925 0.958659L7.27091 6.50033L1.72925 12.042"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowLeftIcon({ color = "#010000", ...props }: IconProps) {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.146447 3.64645C-0.0488157 3.84171 -0.0488157 4.15829 0.146447 4.35355L3.32843 7.53553C3.52369 7.7308 3.84027 7.7308 4.03553 7.53553C4.2308 7.34027 4.2308 7.02369 4.03553 6.82843L1.20711 4L4.03553 1.17157C4.2308 0.976312 4.2308 0.659729 4.03553 0.464467C3.84027 0.269205 3.52369 0.269205 3.32843 0.464467L0.146447 3.64645ZM13.5 3.5L0.5 3.5L0.5 4.5L13.5 4.5L13.5 3.5Z"
        fill={color}
      />
    </svg>
  );
}

export function ArrowRightIcon({ color = "#010000", ...props }: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 8H15M15 8L8 1M15 8L8 15"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowUpIcon({ color = "#010000", ...props }: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 15V1M8 1L1 8M8 1L15 8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CalenderIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M19.5 4H16.5V2.5C16.5 2.36739 16.4473 2.24021 16.3536 2.14645C16.2598 2.05268 16.1326 2 16 2C15.8674 2 15.7402 2.05268 15.6464 2.14645C15.5527 2.24021 15.5 2.36739 15.5 2.5V4H8.5V2.5C8.5 2.36739 8.44732 2.24021 8.35355 2.14645C8.25979 2.05268 8.13261 2 8 2C7.86739 2 7.74021 2.05268 7.64645 2.14645C7.55268 2.24021 7.5 2.36739 7.5 2.5V4H4.5C3.8372 4.00079 3.20178 4.26444 2.73311 4.73311C2.26444 5.20178 2.00079 5.8372 2 6.5V19.5C2.00079 20.1628 2.26444 20.7982 2.73311 21.2669C3.20178 21.7356 3.8372 21.9992 4.5 22H19.5C20.163 22 20.7989 21.7366 21.2678 21.2678C21.7366 20.7989 22 20.163 22 19.5V6.5C22 5.83696 21.7366 5.20107 21.2678 4.73223C20.7989 4.26339 20.163 4 19.5 4ZM21 19.5C21 19.8978 20.842 20.2794 20.5607 20.5607C20.2794 20.842 19.8978 21 19.5 21H4.5C4.10218 21 3.72064 20.842 3.43934 20.5607C3.15804 20.2794 3 19.8978 3 19.5V11H21V19.5ZM21 10H3V6.5C3 5.672 3.67 5 4.5 5H7.5V6.5C7.5 6.63261 7.55268 6.75979 7.64645 6.85355C7.74021 6.94732 7.86739 7 8 7C8.13261 7 8.25979 6.94732 8.35355 6.85355C8.44732 6.75979 8.5 6.63261 8.5 6.5V5H15.5V6.5C15.5 6.63261 15.5527 6.75979 15.6464 6.85355C15.7402 6.94732 15.8674 7 16 7C16.1326 7 16.2598 6.94732 16.3536 6.85355C16.4473 6.75979 16.5 6.63261 16.5 6.5V5H19.5C19.8978 5 20.2794 5.15804 20.5607 5.43934C20.842 5.72064 21 6.10218 21 6.5V10Z" />
    </svg>
  );
}

export function UploadIcon(props: IconProps) {
  return (
    <svg
      width="36"
      height="35"
      viewBox="0 0 36 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.0013 32.0827C26.0555 32.0827 32.5846 25.5535 32.5846 17.4993C32.5846 9.4452 26.0555 2.91602 18.0013 2.91602C9.94715 2.91602 3.41797 9.4452 3.41797 17.4993C3.41797 25.5535 9.94715 32.0827 18.0013 32.0827Z"
        stroke="#004987"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0013 11.666V23.3327M18.0013 11.666C16.9805 11.666 15.073 14.5739 14.3555 15.3118M18.0013 11.666C19.0221 11.666 20.9296 14.5739 21.6471 15.3118"
        stroke="#004987"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TrashIcon(props: IconProps) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" fill="white" />
      <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#E0E0E0" />
      <path
        d="M31.3248 21.4668C31.3248 21.4668 30.7818 28.2018 30.4668 31.0388C30.3168 32.3938 29.4798 33.1878 28.1088 33.2128C25.4998 33.2598 22.8878 33.2628 20.2798 33.2078C18.9608 33.1808 18.1378 32.3768 17.9908 31.0458C17.6738 28.1838 17.1338 21.4668 17.1338 21.4668"
        stroke="#FF7474"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.708 18.2383H15.75"
        stroke="#FF7474"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.4406 18.239C28.6556 18.239 27.9796 17.684 27.8256 16.915L27.5826 15.699C27.4326 15.138 26.9246 14.75 26.3456 14.75H22.1126C21.5336 14.75 21.0256 15.138 20.8756 15.699L20.6326 16.915C20.4786 17.684 19.8026 18.239 19.0176 18.239"
        stroke="#FF7474"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ToastErrorIcon(props: IconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="32" height="32" rx="16" fill="#FFBCBC" />
      <mask
        id="mask0_879_4283"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="24"
        height="24"
      >
        <rect x="4" y="4" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_879_4283)">
        <path
          d="M12.4 21L16 17.4L19.6 21L21 19.6L17.4 16L21 12.4L19.6 11L16 14.6L12.4 11L11 12.4L14.6 16L11 19.6L12.4 21ZM16 26C14.6167 26 13.3167 25.7373 12.1 25.212C10.8833 24.6873 9.825 23.975 8.925 23.075C8.025 22.175 7.31267 21.1167 6.788 19.9C6.26267 18.6833 6 17.3833 6 16C6 14.6167 6.26267 13.3167 6.788 12.1C7.31267 10.8833 8.025 9.825 8.925 8.925C9.825 8.025 10.8833 7.31233 12.1 6.787C13.3167 6.26233 14.6167 6 16 6C17.3833 6 18.6833 6.26233 19.9 6.787C21.1167 7.31233 22.175 8.025 23.075 8.925C23.975 9.825 24.6873 10.8833 25.212 12.1C25.7373 13.3167 26 14.6167 26 16C26 17.3833 25.7373 18.6833 25.212 19.9C24.6873 21.1167 23.975 22.175 23.075 23.075C22.175 23.975 21.1167 24.6873 19.9 25.212C18.6833 25.7373 17.3833 26 16 26Z"
          fill="#F04248"
        />
      </g>
    </svg>
  );
}

export function ToastSuccessIcon(props: IconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="32" height="32" rx="16" fill="#C1FFD9" />
      <mask
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="24"
        height="24"
      >
        <rect x="4" y="4" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_879_4249)">
        <path
          d="M14.6 20.6L21.65 13.55L20.25 12.15L14.6 17.8L11.75 14.95L10.35 16.35L14.6 20.6ZM16 26C14.6167 26 13.3167 25.7373 12.1 25.212C10.8833 24.6873 9.825 23.975 8.925 23.075C8.025 22.175 7.31267 21.1167 6.788 19.9C6.26267 18.6833 6 17.3833 6 16C6 14.6167 6.26267 13.3167 6.788 12.1C7.31267 10.8833 8.025 9.825 8.925 8.925C9.825 8.025 10.8833 7.31233 12.1 6.787C13.3167 6.26233 14.6167 6 16 6C17.3833 6 18.6833 6.26233 19.9 6.787C21.1167 7.31233 22.175 8.025 23.075 8.925C23.975 9.825 24.6873 10.8833 25.212 12.1C25.7373 13.3167 26 14.6167 26 16C26 17.3833 25.7373 18.6833 25.212 19.9C24.6873 21.1167 23.975 22.175 23.075 23.075C22.175 23.975 21.1167 24.6873 19.9 25.212C18.6833 25.7373 17.3833 26 16 26Z"
          fill="#00DF80"
        />
      </g>
    </svg>
  );
}

export function ToastCloseIcon(props: IconProps) {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.16346 11.1381C0.999182 11.3014 0.906891 11.5236 0.906891 11.7559C0.906891 11.9883 0.999182 12.2117 1.16346 12.377C1.32774 12.5423 1.55055 12.636 1.78287 12.6375C2.01519 12.6389 2.238 12.5481 2.40228 12.3848L6.73815 8.07629L11.074 12.4397C11.2383 12.605 11.4611 12.6987 11.6934 12.7002C11.9257 12.7016 12.1486 12.6108 12.3128 12.4475C12.4771 12.2843 12.5694 12.062 12.5694 11.8297C12.5694 11.5974 12.4771 11.374 12.3128 11.2087L7.97697 6.84529L12.3128 2.53676C12.4771 2.37352 12.5694 2.15129 12.5694 1.91896C12.5694 1.68664 12.4771 1.46324 12.3128 1.29792C12.1486 1.1326 11.9257 1.0389 11.6934 1.03743C11.4611 1.03596 11.2383 1.12684 11.074 1.29008L6.73815 5.5986L2.40228 1.23522C2.238 1.0699 2.01519 0.976196 1.78287 0.974726C1.55055 0.973256 1.32774 1.06414 1.16346 1.22738C0.999182 1.39062 0.906892 1.61285 0.906892 1.84518C0.906892 2.07751 0.999182 2.3009 1.16346 2.46622L5.49933 6.82961L1.16346 11.1381Z"
        fill="#969A9C"
      />
    </svg>
  );
}

export function PlusIcon({ color = "#ffffff", ...props }: IconProps) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 9H17"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9 17L9 1"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function HeartIcon({ color = "#201F1D", ...props }: IconProps) {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.39264 13.6153C2.1357 9.691 3.60467 5.2056 7.72459 3.87837C9.89173 3.17903 12.2838 3.59137 14.0854 4.94672C15.7899 3.62886 18.2698 3.18372 20.4346 3.87837C24.5545 5.2056 26.0328 9.691 24.7771 13.6153C22.8208 19.8356 14.0854 24.6267 14.0854 24.6267C14.0854 24.6267 5.41453 19.9082 3.39264 13.6153Z"
        stroke={color}
        strokeWidth="1.75714"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NewRequestIcon(props: IconProps) {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="34.7246"
        cy="35.2332"
        r="34"
        fill="#004987"
        fillOpacity="0.11"
        stroke="#004987"
      />
      <g clipPath="url(#clip0_1_14030)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.4219 19.8582C23.2947 19.8582 22.2137 20.3059 21.4167 21.103C20.6196 21.9 20.1719 22.981 20.1719 24.1082V45.3582C20.1719 46.4853 20.6196 47.5663 21.4167 48.3634C22.2137 49.1604 23.2947 49.6082 24.4219 49.6082H31.3281C31.7508 49.6082 32.1562 49.4402 32.4551 49.1414C32.754 48.8425 32.9219 48.4371 32.9219 48.0144C32.9219 47.5917 32.754 47.1863 32.4551 46.8875C32.1562 46.5886 31.7508 46.4207 31.3281 46.4207H24.4219C24.1401 46.4207 23.8698 46.3087 23.6706 46.1095C23.4713 45.9102 23.3594 45.6399 23.3594 45.3582V24.1082C23.3594 23.8264 23.4713 23.5561 23.6706 23.3569C23.8698 23.1576 24.1401 23.0457 24.4219 23.0457H37.1719C37.4537 23.0457 37.7239 23.1576 37.9232 23.3569C38.1224 23.5561 38.2344 23.8264 38.2344 24.1082V35.2644C38.2344 35.6871 38.4023 36.0925 38.7012 36.3914C39.0001 36.6902 39.4054 36.8582 39.8281 36.8582C40.2508 36.8582 40.6562 36.6902 40.9551 36.3914C41.254 36.0925 41.4219 35.6871 41.4219 35.2644V27.0067L46.0756 29.4292C46.1379 29.4612 46.1931 29.5053 46.2383 29.5588C46.2834 29.6123 46.3175 29.6743 46.3387 29.741C46.3598 29.8078 46.3675 29.878 46.3614 29.9478C46.3553 30.0175 46.3354 30.0854 46.303 30.1474L44.025 34.5292C43.8456 34.9022 43.8184 35.3305 43.9492 35.7233C44.08 36.1161 44.3584 36.4426 44.7257 36.6337C45.093 36.8247 45.5201 36.8654 45.9169 36.7471C46.3136 36.6288 46.6487 36.3607 46.8512 35.9997L49.1314 31.6179C49.5864 30.7429 49.6753 29.723 49.3784 28.7825C49.0815 27.8421 48.4232 27.058 47.5483 26.6029L41.3602 23.3814C41.189 22.3948 40.675 21.5004 39.9087 20.8558C39.1424 20.2113 38.1732 19.8579 37.1719 19.8582H24.4219ZM37.1719 45.3582C37.1719 44.9355 37.3398 44.5301 37.6387 44.2312C37.9376 43.9323 38.3429 43.7644 38.7656 43.7644H41.9531V40.5769C41.9531 40.1542 42.121 39.7488 42.4199 39.45C42.7188 39.1511 43.1242 38.9832 43.5469 38.9832C43.9696 38.9832 44.3749 39.1511 44.6738 39.45C44.9727 39.7488 45.1406 40.1542 45.1406 40.5769V43.7644H48.3281C48.7508 43.7644 49.1562 43.9323 49.4551 44.2312C49.754 44.5301 49.9219 44.9355 49.9219 45.3582C49.9219 45.7808 49.754 46.1862 49.4551 46.4851C49.1562 46.784 48.7508 46.9519 48.3281 46.9519H45.1406V50.1394C45.1406 50.5621 44.9727 50.9675 44.6738 51.2664C44.3749 51.5652 43.9696 51.7332 43.5469 51.7332C43.1242 51.7332 42.7188 51.5652 42.4199 51.2664C42.121 50.9675 41.9531 50.5621 41.9531 50.1394V46.9519H38.7656C38.3429 46.9519 37.9376 46.784 37.6387 46.4851C37.3398 46.1862 37.1719 45.7808 37.1719 45.3582Z"
          fill="#004987"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_14030">
          <rect
            width="34"
            height="34"
            fill="white"
            transform="translate(18.0469 17.7332)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function FollowUpIcon(props: IconProps) {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="34.6719"
        cy="35.2332"
        r="34"
        fill="#004987"
        fillOpacity="0.11"
        stroke="#004987"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.3066 21.9832H26.4941V47.4832H23.3066V21.9832ZM33.7956 22.8119L31.2754 24.1082V45.3582L33.7956 46.6544L48.6706 36.0294V33.4369L33.7956 22.8119ZM45.0029 34.7332L34.4629 42.262V27.2043L45.0029 34.7332Z"
        fill="#004987"
      />
    </svg>
  );
}

export function SealCheckIcon({ fill, ...props }: IconProps) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M18.4095 8.54766C18.0895 8.21379 17.7589 7.86926 17.6261 7.54852C17.503 7.25074 17.4964 6.81023 17.4891 6.3443C17.4776 5.57484 17.4645 4.70367 16.8804 4.11961C16.2963 3.53555 15.4219 3.52242 14.6557 3.51094C14.1898 3.50355 13.7534 3.49699 13.4515 3.37395C13.1307 3.24105 12.7862 2.91047 12.4523 2.59055C11.9077 2.06883 11.2908 1.47656 10.5 1.47656C9.70922 1.47656 9.09234 2.06883 8.54766 2.59055C8.21379 2.91047 7.86926 3.24105 7.54852 3.37395C7.25074 3.49699 6.81023 3.50355 6.3443 3.51094C5.57484 3.52242 4.70367 3.53555 4.11961 4.11961C3.53555 4.70367 3.52242 5.57812 3.51094 6.3443C3.50355 6.81023 3.49699 7.24664 3.37395 7.54852C3.24105 7.86926 2.91047 8.21379 2.59055 8.54766C2.06883 9.09234 1.47656 9.70922 1.47656 10.5C1.47656 11.2908 2.06883 11.9077 2.59055 12.4523C2.91047 12.7862 3.24105 13.1307 3.37395 13.4515C3.49699 13.7493 3.50355 14.1898 3.51094 14.6557C3.52242 15.4252 3.53555 16.2963 4.11961 16.8804C4.70367 17.4645 5.57812 17.4776 6.3443 17.4891C6.81023 17.4964 7.24664 17.503 7.54852 17.6261C7.86926 17.7589 8.21379 18.0895 8.54766 18.4095C9.09234 18.9312 9.70922 19.5234 10.5 19.5234C11.2908 19.5234 11.9077 18.9312 12.4523 18.4095C12.7862 18.0895 13.1307 17.7589 13.4515 17.6261C13.7493 17.503 14.1898 17.4964 14.6557 17.4891C15.4252 17.4776 16.2963 17.4645 16.8804 16.8804C17.4645 16.2963 17.4776 15.4252 17.4891 14.6557C17.4964 14.1898 17.503 13.7534 17.6261 13.4515C17.7589 13.1307 18.0895 12.7862 18.4095 12.4523C18.9312 11.9077 19.5234 11.2908 19.5234 10.5C19.5234 9.70922 18.9312 9.09234 18.4095 8.54766ZM17.6991 11.7715C17.316 12.1702 16.9198 12.5836 16.7147 13.0758C16.5195 13.5466 16.5112 14.1028 16.503 14.6409C16.494 15.2512 16.4842 15.8829 16.1831 16.1848C15.8821 16.4866 15.2496 16.4957 14.6393 16.5047C14.1012 16.5129 13.545 16.5211 13.0741 16.7163C12.582 16.9198 12.1718 17.316 11.769 17.7007C11.3384 18.1109 10.8929 18.5407 10.4984 18.5407C10.1038 18.5407 9.65836 18.1133 9.22688 17.7007C8.8282 17.3176 8.41477 16.9214 7.92258 16.7163C7.45172 16.5211 6.89555 16.5129 6.35742 16.5047C5.74711 16.4957 5.11547 16.4858 4.81359 16.1848C4.51172 15.8837 4.5027 15.2512 4.49367 14.6409C4.48547 14.1028 4.47727 13.5466 4.28203 13.0758C4.07859 12.5836 3.68238 12.1734 3.29766 11.7707C2.88832 11.34 2.46094 10.8946 2.46094 10.5C2.46094 10.1054 2.88832 9.66 3.30094 9.22852C3.68402 8.82984 4.08023 8.41641 4.28531 7.92422C4.48055 7.45336 4.48875 6.89719 4.49695 6.35906C4.50598 5.74875 4.51582 5.11711 4.81687 4.81523C5.11793 4.51336 5.75039 4.50434 6.3607 4.49531C6.89883 4.48711 7.455 4.47891 7.92586 4.28367C8.41805 4.08023 8.8282 3.68402 9.23098 3.2993C9.66 2.88832 10.1054 2.46094 10.5 2.46094C10.8946 2.46094 11.34 2.88832 11.7715 3.30094C12.1702 3.68402 12.5836 4.08023 13.0758 4.28531C13.5466 4.48055 14.1028 4.48875 14.6409 4.49695C15.2512 4.50598 15.8829 4.51582 16.1848 4.81687C16.4866 5.11793 16.4957 5.75039 16.5047 6.3607C16.5129 6.89883 16.5211 7.455 16.7163 7.92586C16.9198 8.41805 17.316 8.8282 17.7007 9.23098C18.1109 9.66164 18.5407 10.1071 18.5407 10.5016C18.5407 10.8962 18.1117 11.34 17.6991 11.7715ZM14.1291 8.18344C14.2212 8.27572 14.273 8.40082 14.273 8.53125C14.273 8.66168 14.2212 8.78678 14.1291 8.87906L9.53531 13.4728C9.44303 13.565 9.31793 13.6168 9.1875 13.6168C9.05707 13.6168 8.93197 13.565 8.83969 13.4728L6.87094 11.5041C6.784 11.4108 6.73667 11.2874 6.73892 11.1598C6.74117 11.0323 6.79282 10.9107 6.883 10.8205C6.97318 10.7303 7.09483 10.6787 7.22234 10.6764C7.34985 10.6742 7.47326 10.7215 7.56656 10.8084L9.1875 12.4286L13.4334 8.18344C13.5257 8.09127 13.6508 8.0395 13.7812 8.0395C13.9117 8.0395 14.0368 8.09127 14.1291 8.18344Z" />
    </svg>
  );
}

export function RepairIcon({ fill, ...props }: IconProps) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_382_24071)">
        <path d="M15.0622 0.719339C15.0923 0.689184 15.1146 0.652257 15.1274 0.611666C15.1402 0.571075 15.143 0.528009 15.1356 0.486093C15.1283 0.444177 15.111 0.404639 15.0852 0.370806C15.0594 0.336974 15.0258 0.309838 14.9873 0.291683C14.3938 0.0110313 13.7278 -0.0788224 13.0811 0.0344809C12.4344 0.147784 11.8387 0.458679 11.3759 0.924402C10.4738 1.83231 10.1588 3.25818 10.5795 4.45031L4.44945 10.5804C4.10892 10.4603 3.75018 10.3999 3.38908 10.4019C2.47852 10.4019 1.59558 10.7642 0.96711 11.3964C0.505654 11.8557 0.193756 12.4437 0.0723158 13.0833C-0.0491248 13.7229 0.0255605 14.3843 0.286578 14.9807C0.303678 15.0207 0.330346 15.0558 0.364227 15.083C0.398109 15.1101 0.438162 15.1286 0.48085 15.1366C0.523538 15.1446 0.567547 15.142 0.608991 15.129C0.650436 15.116 0.68804 15.093 0.718485 15.062L2.57308 13.1979C2.69527 13.0746 2.89236 13.0582 2.99436 13.1617L3.79495 13.9995C3.9113 14.1169 3.90598 14.2981 3.78327 14.4219L1.93558 16.2812C1.90567 16.3114 1.88342 16.3483 1.87071 16.3888C1.858 16.4294 1.8552 16.4723 1.86254 16.5142C1.86987 16.556 1.88714 16.5955 1.91288 16.6293C1.93862 16.6631 1.97209 16.6902 2.01048 16.7084C2.4402 16.914 2.91055 17.0208 3.38695 17.0207C4.22208 17.0207 5.01523 16.685 5.62192 16.0751C6.52398 15.1677 6.83902 13.7419 6.41773 12.5497L12.5478 6.41912C12.8885 6.53932 13.2475 6.59971 13.6087 6.59762C14.5193 6.59762 15.4022 6.23531 16.0307 5.60312C16.4922 5.14385 16.8041 4.55586 16.9255 3.91623C17.0469 3.27661 16.9723 2.61521 16.7112 2.01878C16.6941 1.97885 16.6675 1.94374 16.6336 1.91656C16.5997 1.88938 16.5597 1.87096 16.517 1.86293C16.4743 1.85489 16.4303 1.85749 16.3888 1.8705C16.3474 1.8835 16.3098 1.90651 16.2793 1.9375L14.4247 3.80165C14.3674 3.85691 14.2905 3.88735 14.2109 3.88635C14.1312 3.88536 14.0552 3.85302 13.9992 3.79634L13.2029 3C13.1744 2.97276 13.1517 2.94005 13.1362 2.90382C13.1207 2.8676 13.1127 2.82861 13.1126 2.7892C13.1126 2.7498 13.1205 2.71079 13.1359 2.67453C13.1513 2.63826 13.1739 2.60549 13.2023 2.57818L15.0622 0.719339ZM12.8267 3.37559L13.6231 4.17193C13.9413 4.49175 14.4864 4.49334 14.8014 4.17671L16.358 2.61271C16.4813 3.07224 16.4812 3.55617 16.3577 4.01565C16.2342 4.47513 15.9917 4.89389 15.6546 5.22965C15.1249 5.7625 14.3801 6.06743 13.6093 6.06743C13.2464 6.06743 12.9027 5.99943 12.5877 5.86556C12.539 5.84482 12.4852 5.8391 12.4332 5.84914C12.3813 5.85917 12.3335 5.8845 12.296 5.92187L5.92102 12.2969C5.88377 12.3342 5.85847 12.3818 5.84835 12.4335C5.83822 12.4853 5.84373 12.5389 5.86417 12.5875C6.29077 13.6022 6.03098 14.9117 5.24633 15.7011C4.9081 16.0439 4.48243 16.2874 4.01554 16.4052C3.54865 16.523 3.0584 16.5106 2.59805 16.3694L4.16045 14.7969C4.49036 14.4649 4.49567 13.9501 4.17586 13.6292L3.3758 12.7915C3.06714 12.4807 2.51836 12.4998 2.19748 12.8244L0.640922 14.3884C0.51757 13.9289 0.517646 13.4449 0.641145 12.9855C0.764643 12.526 1.00719 12.1072 1.3443 11.7715C1.87395 11.2386 2.61877 10.9337 3.38961 10.9337C3.75245 10.9337 4.09617 11.0017 4.4112 11.1356C4.4599 11.1563 4.51367 11.162 4.56564 11.152C4.6176 11.1419 4.66539 11.1166 4.70286 11.0792L11.0779 4.70425C11.1151 4.66692 11.1404 4.61935 11.1505 4.5676C11.1607 4.51585 11.1551 4.46226 11.1347 4.41365C10.7081 3.39896 10.9679 2.0889 11.7525 1.29946C12.0906 0.95701 12.516 0.713676 12.9826 0.595862C13.4492 0.478048 13.9391 0.490253 14.3992 0.631152L12.8267 2.20418C12.749 2.28062 12.6872 2.37178 12.6451 2.47234C12.6029 2.5729 12.5812 2.68085 12.5812 2.78989C12.5812 2.89893 12.6029 3.00687 12.6451 3.10743C12.6872 3.20799 12.749 3.29915 12.8267 3.37559Z" />
        <path d="M15.5175 16.2812C15.4584 16.338 15.3796 16.3697 15.2976 16.3695C15.2156 16.3693 15.1369 16.3372 15.0781 16.2801L9.74971 10.9676C9.69893 10.9222 9.63268 10.898 9.56459 10.9C9.4965 10.9019 9.43176 10.9299 9.38369 10.9782C9.33563 11.0265 9.3079 11.0913 9.30622 11.1594C9.30453 11.2275 9.32902 11.2937 9.37465 11.3443L14.7026 16.6557C14.8619 16.8156 15.0734 16.9038 15.2986 16.9038C15.5239 16.9038 15.7353 16.8156 15.8979 16.652L16.657 15.8588C16.7346 15.7822 16.7961 15.6909 16.8381 15.5903C16.8801 15.4897 16.9017 15.3818 16.9017 15.2728C16.9016 15.1637 16.8799 15.0558 16.8378 14.9552C16.7957 14.8547 16.7341 14.7635 16.6565 14.6869L11.344 9.3744C11.2939 9.32602 11.2268 9.29924 11.1572 9.29985C11.0875 9.30045 11.0209 9.32839 10.9716 9.37764C10.9224 9.42689 10.8944 9.49351 10.8938 9.56315C10.8932 9.6328 10.92 9.6999 10.9684 9.75L16.2804 15.062C16.402 15.1842 16.402 15.3616 16.2766 15.488L15.5175 16.2812ZM3.10962 1.67128L1.51587 0.0775273C1.46605 0.0277303 1.3985 -0.000244141 1.32807 -0.000244141C1.25763 -0.000244141 1.19008 0.0277303 1.14027 0.0775273L0.0777714 1.14003C0.0279744 1.18984 0 1.25739 0 1.32782C0 1.39826 0.0279744 1.46581 0.0777714 1.51562L1.67152 3.10937C1.72126 3.15924 1.78877 3.18731 1.85921 3.18741C1.92964 3.18751 1.99723 3.15963 2.04712 3.1099L2.3903 2.76618L6.45224 6.82812C6.47671 6.85352 6.50599 6.8738 6.53838 6.88776C6.57076 6.90173 6.60561 6.9091 6.64088 6.90946C6.67614 6.90981 6.71113 6.90314 6.74379 6.88983C6.77645 6.87652 6.80614 6.85684 6.83111 6.83194C6.85609 6.80703 6.87585 6.77741 6.88925 6.74478C6.90265 6.71216 6.90942 6.67719 6.90917 6.64192C6.90891 6.60665 6.90164 6.57179 6.88776 6.53936C6.87389 6.50694 6.8537 6.4776 6.82837 6.45306L2.7659 2.39059L3.10908 2.0474C3.13386 2.02276 3.15352 1.99348 3.16696 1.96123C3.1804 1.92897 3.18734 1.89439 3.18739 1.85945C3.18744 1.82451 3.18059 1.78991 3.16725 1.75762C3.1539 1.72533 3.13432 1.69599 3.10962 1.67128ZM1.85905 2.54625L0.640896 1.32809L1.3278 0.641184L2.54596 1.85934L1.85905 2.54625Z" />
      </g>
      <defs>
        <clipPath id="clip0_382_24071">
          <rect width="17" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function RepairHandIcon({ fill, ...props }: IconProps) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_382_24080)">
        <path d="M2.59219 0.180479C2.03437 0.492199 2.26406 1.05001 3.36328 2.16564C4.44609 3.24845 4.67578 3.78985 4.23281 4.23282C3.80625 4.65939 3.26484 4.4297 2.14922 3.36329C0.557812 1.8211 0 1.95235 0 3.88829C0 5.08595 0.410156 6.0211 1.24687 6.69376C2.05078 7.36642 2.93672 7.61251 4.13437 7.49767C4.97109 7.43204 5.08594 7.44845 5.47969 7.8586C5.85703 8.25235 5.88984 8.3836 5.79141 9.18751C5.66016 10.3688 5.39766 10.8774 4.23281 12.075C3.44531 12.8953 3.19922 13.0594 2.85469 12.9938C2.51016 12.9281 2.24766 13.125 1.3125 14.0602C-0.344531 15.7008 -0.360937 15.6188 2.59219 18.5719C5.57812 21.5578 5.59453 21.5578 7.18594 19.9664C7.98984 19.1625 8.20312 18.8344 8.20312 18.4406C8.20312 18.0305 8.43281 17.7188 9.41719 16.7508C10.6148 15.6024 10.6477 15.5859 11.3039 15.6844C11.6648 15.7336 12.1898 15.7008 12.4852 15.6024C12.9281 15.4547 13.0594 15.4711 13.3055 15.6844C13.5352 15.8977 13.568 16.1109 13.5023 16.8328C13.4203 17.5711 13.4531 17.7352 13.6992 17.8172C14.0766 17.9649 14.2078 17.7024 14.3391 16.6031L14.4539 15.6844L11.993 13.207C9.67969 10.8609 9.56484 10.7297 9.7125 10.3031C9.86016 9.87657 9.89297 9.86017 10.3195 10.0734C10.5656 10.2047 11.025 10.3524 11.3531 10.418C11.7961 10.5 11.993 10.6477 12.1406 11.0086C12.2555 11.2547 12.5508 11.5664 12.8133 11.6813C13.1414 11.8289 13.2891 12.0094 13.2891 12.2719C13.2891 12.7313 13.9781 13.4531 14.4047 13.4531C14.5687 13.4531 14.9133 13.6828 15.1922 13.9617C15.6352 14.4211 15.7172 14.4539 16.4062 14.3391C17.9648 14.093 18.9492 14.4211 19.6875 15.4547C20.1633 16.0945 20.4586 17.2266 20.2617 17.5547C20.1961 17.6695 19.7531 17.3578 19.1133 16.7508C18.2437 15.9141 17.9812 15.75 17.4891 15.75C16.3734 15.75 15.75 16.3242 15.75 17.325C15.75 17.9156 16.0125 18.3422 16.9312 19.2938C17.5875 19.9828 17.7023 20.1469 17.4727 20.2453C16.8328 20.475 15.2578 19.7531 14.8148 19.0313C14.6344 18.7195 14.4047 18.5391 14.1586 18.5391C13.6336 18.5391 13.6664 18.9984 14.2734 19.7203C14.9625 20.5406 15.9633 21 17.1281 21C19.0641 21 19.2281 20.3602 17.6367 18.818C16.5539 17.768 16.3242 17.2102 16.7672 16.7672C17.2266 16.3078 17.7844 16.5539 18.8672 17.6367C20.4094 19.1953 21 19.0477 21 17.1117C20.9836 14.7984 19.3758 13.3219 17.0297 13.4859C15.4875 13.6008 15.4055 13.4203 16.4883 12.2883C17.2758 11.468 17.3906 11.2547 17.3906 10.6805C17.3906 9.92579 16.9641 9.35157 16.4062 9.35157C16.1602 9.35157 16.0781 9.23673 16.0781 8.94142C16.0781 8.46564 15.4219 7.71095 15.0117 7.71095C14.8477 7.71095 14.7656 7.54689 14.7656 7.16954C14.7656 6.5297 14.2078 5.90626 13.65 5.90626C13.3875 5.90626 13.2891 5.80782 13.2891 5.56173C13.2891 5.38126 13.0758 5.00392 12.8133 4.74142C12.1242 4.05235 11.3531 4.08517 10.5164 4.83985C9.99141 5.31564 9.81094 5.39767 9.36797 5.31564C9.03984 5.25001 8.72812 5.29923 8.46562 5.46329C8.10469 5.70938 8.05547 5.69298 7.74375 5.36485C7.48125 5.06954 7.43203 4.85626 7.49766 4.13439C7.74375 1.77188 6.16875 1.14441e-05 3.83906 1.14441e-05C3.31406 1.14441e-05 2.73984 0.0820427 2.59219 0.180479ZM4.51172 0.836729C5.43047 1.09923 6.02109 1.55861 6.43125 2.3461C6.71016 2.92032 6.75937 3.19923 6.67734 4.20001C6.57891 5.33204 6.57891 5.36485 7.05469 5.82423L7.54687 6.30001L6.93984 6.92345L6.33281 7.54689L5.82422 7.0547C5.34844 6.59532 5.29922 6.57892 4.16719 6.67735C3.24844 6.74298 2.8875 6.71017 2.39531 6.48048C1.62422 6.10314 0.885937 5.11876 0.738281 4.26563C0.557812 3.18282 0.7875 3.16642 1.80469 4.1836C2.60859 4.98751 2.85469 5.13517 3.49453 5.20079C4.16719 5.28282 4.29844 5.2336 4.75781 4.79064C5.61094 3.93751 5.39766 2.96954 4.03594 1.65704C3.05156 0.689074 3.18281 0.475792 4.51172 0.836729ZM12.2719 5.28282C12.6 5.61095 12.5016 5.97189 11.9273 6.5297L11.3859 7.0547L10.9102 6.56251L10.4344 6.07032L10.9102 5.57814C11.4023 5.06954 11.9437 4.9547 12.2719 5.28282ZM11.7469 8.59688C12.4031 9.36798 12.4359 9.48282 11.9109 9.61407C11.3203 9.76173 10.8937 9.56485 9.99141 8.76095C9.54844 8.3672 9.10547 8.03907 9.00703 8.03907C8.74453 8.03907 8.62969 8.54767 8.82656 8.87579C9.12187 9.35157 9.05625 9.81095 8.58047 10.6805C8.18672 11.3695 8.15391 11.5172 8.35078 11.6484C8.49844 11.7305 8.71172 11.7305 8.85938 11.6484C9.07266 11.5336 9.48281 11.8617 10.7133 13.0922C11.5828 13.9781 12.3047 14.7492 12.3047 14.8149C12.3047 14.8805 11.8125 14.9297 11.2219 14.9297H10.1391L8.925 16.1109L7.71094 17.2922L6.90703 16.5047C6.36562 15.9797 6.00469 15.7336 5.84062 15.7992C5.36484 15.9797 5.56172 16.3734 6.59531 17.3906L7.6125 18.375L6.64453 19.3594L5.69297 20.3274L3.82266 18.5883C1.91953 16.8164 0.984375 15.832 0.984375 15.6188C0.984375 15.5531 1.39453 15.0938 1.88672 14.6016L2.77266 13.7156L3.77344 14.6672C4.31484 15.1922 4.85625 15.5859 4.97109 15.5367C5.39766 15.4055 5.26641 14.8805 4.61016 14.2078L3.9375 13.5188L4.85625 12.6328C6.08672 11.4024 6.41484 10.8445 6.5625 9.56485C6.69375 8.49845 6.72656 8.46564 7.89141 7.28439L9.07266 6.08673L10.1391 7.02188C10.7133 7.53048 11.4352 8.23595 11.7469 8.59688ZM13.8797 6.98907C14.1586 7.39923 14.1422 7.41564 13.5352 8.03907L12.9281 8.66251L12.4523 8.13751L11.9766 7.62892L12.5508 7.08751C13.2398 6.44767 13.5187 6.43126 13.8797 6.98907ZM15.225 9.12189C15.2578 9.53204 15.143 9.74532 14.5359 10.3031C13.7648 11.0086 13.3383 11.1399 12.9937 10.7953C12.6492 10.4508 12.7805 10.1227 13.5844 9.30235C14.1586 8.71173 14.4539 8.53126 14.7656 8.56407C15.0937 8.59688 15.1922 8.71173 15.225 9.12189ZM15.832 11.6484C14.7984 12.682 14.2406 12.8789 14.1422 12.2063C14.1094 11.9766 14.4047 11.5828 15.0937 10.9102L16.1109 9.9586L16.4555 10.3195L16.8 10.6641L15.832 11.6484Z" />
      </g>
      <defs>
        <clipPath id="clip0_382_24080">
          <rect width="21" height="21" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function MentainanceIcon({ fill, ...props }: IconProps) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M14.1102 1.96875H16.7352C16.7961 1.96875 16.8558 1.98569 16.9076 2.01768C16.9594 2.04967 17.0013 2.09544 17.0286 2.14988L18.013 4.11862C18.0358 4.16425 18.0477 4.21459 18.0477 4.26562C18.0477 4.31666 18.0358 4.367 18.013 4.41263L17.0634 6.31181V10.5H18.704C18.791 10.5 18.8745 10.5346 18.936 10.5961C18.9975 10.6576 19.0321 10.7411 19.0321 10.8281V15.4219C19.0321 15.8959 18.9388 16.3652 18.7574 16.8031C18.576 17.241 18.3101 17.6389 17.975 17.9741C17.6398 18.3092 17.2419 18.5751 16.804 18.7565C16.3661 18.9379 15.8967 19.0312 15.4227 19.0312C14.9488 19.0312 14.4794 18.9379 14.0415 18.7565C13.6036 18.5751 13.2057 18.3092 12.8705 17.9741C12.5354 17.6389 12.2695 17.241 12.0881 16.8031C11.9067 16.3652 11.8134 15.8959 11.8134 15.4219V10.8281C11.8134 10.7411 11.8479 10.6576 11.9095 10.5961C11.971 10.5346 12.0545 10.5 12.1415 10.5H13.7821V6.31181L12.8325 4.41263C12.8097 4.367 12.7978 4.31666 12.7978 4.26562C12.7978 4.21459 12.8097 4.16425 12.8325 4.11862L13.8169 2.14988C13.8442 2.09544 13.8861 2.04967 13.9379 2.01768C13.9897 1.98569 14.0494 1.96875 14.1102 1.96875ZM16.4071 10.5V6.23438C16.4071 6.18334 16.419 6.133 16.4419 6.08738L17.3521 4.26562L16.5325 2.625H14.313L13.4927 4.26562L14.4036 6.08738C14.4265 6.133 14.4384 6.18334 14.4384 6.23438V10.5H16.4071ZM12.4696 11.1562V13.125H18.3759V11.1562H12.4696ZM12.4696 13.7812V15.4219C12.4696 15.8097 12.546 16.1937 12.6944 16.552C12.8428 16.9103 13.0603 17.2358 13.3346 17.51C13.6088 17.7843 13.9343 18.0018 14.2926 18.1502C14.6509 18.2986 15.0349 18.375 15.4227 18.375C15.8106 18.375 16.1946 18.2986 16.5529 18.1502C16.9111 18.0018 17.2367 17.7843 17.5109 17.51C17.7851 17.2358 18.0027 16.9103 18.1511 16.552C18.2995 16.1937 18.3759 15.8097 18.3759 15.4219V13.7812H12.4696ZM5.10453 2.35069C5.14951 2.38062 5.18641 2.42121 5.21194 2.46883C5.23747 2.51646 5.25084 2.56965 5.25087 2.62369V5.90625C5.25087 6.25435 5.38915 6.58819 5.63529 6.83433C5.88143 7.08047 6.21527 7.21875 6.56337 7.21875C6.91147 7.21875 7.24531 7.08047 7.49145 6.83433C7.73759 6.58819 7.87587 6.25435 7.87587 5.90625V2.62369C7.87594 2.56972 7.88932 2.51661 7.91482 2.46906C7.94033 2.4215 7.97716 2.38097 8.02207 2.35105C8.06698 2.32113 8.11858 2.30275 8.17229 2.29753C8.226 2.29232 8.28017 2.30043 8.32999 2.32116C9.15007 2.6628 9.85353 3.23483 10.3552 3.96802C10.8569 4.70121 11.1353 5.5641 11.1567 6.45224C11.178 7.34038 10.9415 8.21567 10.4757 8.97215C10.0099 9.72864 9.3348 10.3339 8.53212 10.7146V17.0625C8.53212 17.5846 8.3247 18.0854 7.95549 18.4546C7.58627 18.8238 7.08551 19.0312 6.56337 19.0312C6.04122 19.0312 5.54047 18.8238 5.17125 18.4546C4.80204 18.0854 4.59462 17.5846 4.59462 17.0625V10.7139C3.79194 10.3332 3.11683 9.72798 2.65102 8.9715C2.18522 8.21501 1.94869 7.33972 1.97008 6.45158C1.99147 5.56345 2.26985 4.70055 2.77153 3.96737C3.27321 3.23418 3.97667 2.66214 4.79674 2.3205C4.84666 2.29973 4.90094 2.29162 4.95475 2.29689C5.00856 2.30215 5.05958 2.32063 5.10453 2.35069ZM4.59462 3.15131C3.95858 3.51853 3.43787 4.05626 3.0913 4.70378C2.74474 5.35131 2.58611 6.08283 2.63335 6.81574C2.68058 7.54866 2.93178 8.25377 3.3586 8.85146C3.78541 9.44914 4.37083 9.91559 5.04874 10.1981C5.10863 10.223 5.15979 10.2651 5.19576 10.3191C5.23174 10.373 5.25091 10.4365 5.25087 10.5013V17.0625C5.25087 17.4106 5.38915 17.7444 5.63529 17.9906C5.88143 18.2367 6.21527 18.375 6.56337 18.375C6.91147 18.375 7.24531 18.2367 7.49145 17.9906C7.73759 17.7444 7.87587 17.4106 7.87587 17.0625V10.5013C7.87583 10.4365 7.895 10.373 7.93098 10.3191C7.96695 10.2651 8.01811 10.223 8.07799 10.1981C8.75574 9.91551 9.34099 9.44907 9.76768 8.85145C10.1944 8.25383 10.4455 7.54883 10.4927 6.81604C10.54 6.08325 10.3814 5.35185 10.035 4.7044C9.68852 4.05695 9.16798 3.51924 8.53212 3.15197V5.90625C8.53212 6.42839 8.3247 6.92915 7.95549 7.29837C7.58627 7.66758 7.08551 7.875 6.56337 7.875C6.04122 7.875 5.54047 7.66758 5.17125 7.29837C4.80204 6.92915 4.59462 6.42839 4.59462 5.90625V3.15131Z" />
    </svg>
  );
}

export function ContentIcon({ fill, ...props }: IconProps) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15.7375 16.0342C16.1377 16.275 16.5954 16.4035 17.0625 16.4062C17.7584 16.4054 18.4256 16.1285 18.9177 15.6364C19.4098 15.1444 19.6866 14.4772 19.6875 13.7812C19.6839 13.5542 19.6508 13.3285 19.5891 13.1099L17.9904 14.7092C17.8694 14.8345 17.7245 14.9345 17.5644 15.0033C17.4043 15.0721 17.232 15.1083 17.0578 15.1098C16.8835 15.1113 16.7107 15.0781 16.5494 15.0121C16.3881 14.9461 16.2415 14.8487 16.1183 14.7255C15.9951 14.6022 15.8976 14.4557 15.8316 14.2944C15.7656 14.1331 15.7324 13.9602 15.7339 13.786C15.7354 13.6117 15.7716 13.4395 15.8404 13.2793C15.9092 13.1192 16.0092 12.9744 16.1346 12.8533L17.7338 11.254C17.5152 11.1925 17.2896 11.1597 17.0625 11.1562C16.3666 11.1571 15.6994 11.434 15.2073 11.9261C14.7152 12.4181 14.4384 13.0853 14.4375 13.7812C14.4398 14.2486 14.5683 14.7066 14.8096 15.1069L11.1562 18.7589L12.0842 19.6875L15.7375 16.0342Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0625 2.625H14.4375V1.3125H13.125V2.625H7.875V1.3125H6.5625V2.625H3.9375C3.5894 2.625 3.25556 2.76328 3.00942 3.00942C2.76328 3.25556 2.625 3.5894 2.625 3.9375V17.0625C2.625 17.4106 2.76328 17.7444 3.00942 17.9906C3.25556 18.2367 3.5894 18.375 3.9375 18.375H9.1875V17.0625H3.9375V3.9375H6.5625V5.25H7.875V3.9375H13.125V5.25H14.4375V3.9375H17.0625V9.1875H18.375V3.9375C18.375 3.5894 18.2367 3.25556 17.9906 3.00942C17.7444 2.76328 17.4106 2.625 17.0625 2.625Z"
      />
    </svg>
  );
}

export function AddUnitIcon(props: IconProps) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#DDDDDD" />
      <g clipPath="url(#clip0_382_24498)">
        <path
          d="M14.25 21C14.25 21.1989 14.329 21.3897 14.4697 21.5303C14.6103 21.671 14.8011 21.75 15 21.75C15.1989 21.75 15.3897 21.671 15.5303 21.5303C15.671 21.3897 15.75 21.1989 15.75 21V15.75H21C21.1989 15.75 21.3897 15.671 21.5303 15.5303C21.671 15.3897 21.75 15.1989 21.75 15C21.75 14.8011 21.671 14.6103 21.5303 14.4697C21.3897 14.329 21.1989 14.25 21 14.25H15.75V9C15.75 8.80109 15.671 8.61032 15.5303 8.46967C15.3897 8.32902 15.1989 8.25 15 8.25C14.8011 8.25 14.6103 8.32902 14.4697 8.46967C14.329 8.61032 14.25 8.80109 14.25 9V14.25H9C8.80109 14.25 8.61032 14.329 8.46967 14.4697C8.32902 14.6103 8.25 14.8011 8.25 15C8.25 15.1989 8.32902 15.3897 8.46967 15.5303C8.61032 15.671 8.80109 15.75 9 15.75H14.25V21Z"
          fill="#09244B"
        />
      </g>
      <defs>
        <clipPath id="clip0_382_24498">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function RemoveUnitIcon(props: IconProps) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <rect
          x="0.5"
          y="0.5"
          width="29"
          height="29"
          rx="14.5"
          stroke="#DDDDDD"
        />
        <g clipPath="url(#clip0_382_24504)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.25 15C8.25 14.8011 8.32902 14.6103 8.46967 14.4697C8.61032 14.329 8.80109 14.25 9 14.25H21C21.1989 14.25 21.3897 14.329 21.5303 14.4697C21.671 14.6103 21.75 14.8011 21.75 15C21.75 15.1989 21.671 15.3897 21.5303 15.5303C21.3897 15.671 21.1989 15.75 21 15.75H9C8.80109 15.75 8.61032 15.671 8.46967 15.5303C8.32902 15.3897 8.25 15.1989 8.25 15Z"
            fill="#09244B"
          />
        </g>
      </g>
    </svg>
  );
}

export function MenuIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 6H20M4 12H20H7M4 18H14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PhoneIcon({ color = "#7A7986", ...props }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        id="Stroke 1"
        d="M14.3535 3.36719C18.0545 3.77819 20.9785 6.69819 21.3935 10.3992"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Stroke 3"
        d="M14.3535 6.91016C16.1245 7.25416 17.5085 8.63916 17.8535 10.4102"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Stroke 5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0315 13.3396C15.0205 17.3275 15.9254 12.7139 18.4653 15.252C20.9138 17.6999 22.3222 18.1904 19.2188 21.2919C18.8302 21.6042 16.3613 25.3614 7.68447 16.6869C-0.993406 8.01119 2.76157 5.53963 3.07394 5.15114C6.18377 2.04103 6.66682 3.45657 9.11539 5.90452C11.6541 8.44368 7.04254 9.3516 11.0315 13.3396Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EnvolpeIcon({ color = "#7A7986", ...props }: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        id="Stroke 1"
        d="M17.9033 9.71875L13.46 13.3318C12.6205 13.9978 11.4394 13.9978 10.5999 13.3318L6.11914 9.71875"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Stroke 3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9089 21.8671C19.9502 21.8756 22 19.3767 22 16.3055V9.4372C22 6.36601 19.9502 3.86719 16.9089 3.86719H7.09114C4.04979 3.86719 2 6.36601 2 9.4372V16.3055C2 19.3767 4.04979 21.8756 7.09114 21.8671H16.9089Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TruckIcon({ color = "#00953B", ...props }: IconProps) {
  return (
    <svg
      width="34"
      height="24"
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 0.375V2.5H20.1875V18.4375H13.6467C13.1729 16.6111 11.5302 15.25 9.5625 15.25C7.59475 15.25 5.95213 16.6111 5.47825 18.4375H4.25V13.125H2.125V20.5625H5.47825C5.95213 22.3889 7.59475 23.75 9.5625 23.75C11.5302 23.75 13.1729 22.3889 13.6467 20.5625H22.4783C22.9521 22.3889 24.5947 23.75 26.5625 23.75C28.5303 23.75 30.1729 22.3889 30.6467 20.5625H34V11.8967L33.9331 11.7299L31.8081 5.35494L31.5775 4.625H22.3125V0.375H0ZM1.0625 4.625V6.75H10.625V4.625H1.0625ZM22.3125 6.75H30.0486L31.875 12.1953V18.4375H30.6467C30.1729 16.6111 28.5303 15.25 26.5625 15.25C24.5947 15.25 22.9521 16.6111 22.4783 18.4375H22.3125V6.75ZM2.125 8.875V11H8.5V8.875H2.125ZM9.5625 17.375C10.7493 17.375 11.6875 18.3132 11.6875 19.5C11.6875 20.6868 10.7493 21.625 9.5625 21.625C8.37569 21.625 7.4375 20.6868 7.4375 19.5C7.4375 18.3132 8.37569 17.375 9.5625 17.375ZM26.5625 17.375C27.7493 17.375 28.6875 18.3132 28.6875 19.5C28.6875 20.6868 27.7493 21.625 26.5625 21.625C25.3757 21.625 24.4375 20.6868 24.4375 19.5C24.4375 18.3132 25.3757 17.375 26.5625 17.375Z"
        fill={color}
      />
    </svg>
  );
}

export function MoneyIcon({ color = "#00953B", ...props }: IconProps) {
  return (
    <svg
      width="30"
      height="32"
      viewBox="0 0 30 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.8285 7.24768L18.3249 0.933594L1.7655 14.1624L0.8475 14.1525V14.1667H0.125V31.1667H29.875V14.1667H28.5122L25.8007 6.23476L22.8285 7.24768ZM25.5187 14.1667H11.3124L21.8935 10.5598L24.0497 9.86993L25.5187 14.1667ZM20.0292 8.20251L9.10667 11.9255L17.7568 5.01501L20.0292 8.20251ZM2.95833 25.7394V19.5911C3.55642 19.38 4.09967 19.0377 4.54827 18.5894C4.99686 18.141 5.33942 17.598 5.55083 17H24.4492C24.6604 17.5982 25.0029 18.1416 25.4515 18.5902C25.9001 19.0388 26.4434 19.3813 27.0417 19.5925V25.7408C26.4434 25.9521 25.9001 26.2946 25.4515 26.7432C25.0029 27.1918 24.6604 27.7351 24.4492 28.3333H5.55367C5.34143 27.7351 4.99828 27.1917 4.54928 26.7429C4.10027 26.2942 3.55674 25.9513 2.95833 25.7394Z"
        fill={color}
      />
    </svg>
  );
}

export function PhoneNumbersIcon({ color = "#00953B", ...props }: IconProps) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29 6.7505H23.049C22.9877 6.7505 22.927 6.73845 22.8704 6.71502C22.8137 6.6916 22.7623 6.65727 22.719 6.61401C22.6758 6.57075 22.6415 6.51942 22.6183 6.46294C22.595 6.40647 22.5832 6.34598 22.5834 6.28495C22.5841 6.17262 22.6247 6.06415 22.6982 5.97889L26.9427 1.1509C26.9839 1.10302 27.035 1.06471 27.0926 1.03864C27.1503 1.01257 27.2129 0.99939 27.2762 1.00002C27.5188 1.00002 27.7158 1.19831 27.7158 1.43971V8.66661M19.0059 8.66446H13.8736V7.576C13.8741 7.20362 13.9835 6.83943 14.1885 6.52789C14.3934 6.21635 14.6851 5.97092 15.0278 5.82155L17.8863 4.57791C18.2819 4.4065 18.606 4.1046 18.8039 3.72309C19.0019 3.34159 19.0617 2.90382 18.9732 2.48358C18.8846 2.06333 18.6533 1.68631 18.318 1.41607C17.9828 1.14582 17.5641 0.998886 17.1327 1.00002H15.7987C15.4007 1.00046 15.0125 1.12356 14.6876 1.35242C14.3626 1.58128 14.1168 1.90466 13.984 2.27815M16.0954 28.0734C17.218 28.7929 18.5543 29.1082 19.8819 28.9671C21.2096 28.8259 22.4488 28.2367 23.3934 27.2975L24.2163 26.4784C24.5813 26.1112 24.786 25.6156 24.786 25.099C24.786 24.5825 24.5813 24.0868 24.2163 23.7196L20.7514 20.2926C20.3861 19.9306 19.8917 19.7274 19.3762 19.7274C18.8608 19.7274 18.3664 19.9306 18.0011 20.2926C17.6322 20.6559 17.1341 20.8596 16.6152 20.8596C16.0962 20.8596 15.5981 20.6559 15.2292 20.2926L9.70701 14.7964C9.34201 14.4292 9.13729 13.9335 9.13729 13.417C9.13729 12.9005 9.34201 12.4048 9.70701 12.0376C10.0707 11.674 10.2748 11.1819 10.2748 10.6689C10.2748 10.1559 10.0707 9.66382 9.70701 9.30028L6.37205 5.85172C6.0031 5.48844 5.50507 5.28468 4.98609 5.28468C4.4671 5.28468 3.96907 5.48844 3.60013 5.85172L2.77721 6.67075C1.81658 7.59763 1.20439 8.82438 1.04281 10.1463C0.881224 11.4681 1.18002 12.8052 1.88933 13.9343C5.66422 19.5151 10.4882 24.3163 16.0954 28.0734Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CardIcon({ color = "#00953B", ...props }: IconProps) {
  return (
    <svg
      width="30"
      height="22"
      viewBox="0 0 30 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.1609 14.0356C19.9193 14.0356 19.6877 14.1315 19.5169 14.3023C19.3461 14.4731 19.2502 14.7048 19.2502 14.9463C19.2502 15.1878 19.3461 15.4195 19.5169 15.5903C19.6877 15.7611 19.9193 15.857 20.1609 15.857H24.4109C24.6524 15.857 24.8841 15.7611 25.0549 15.5903C25.2256 15.4195 25.3216 15.1878 25.3216 14.9463C25.3216 14.7048 25.2256 14.4731 25.0549 14.3023C24.8841 14.1315 24.6524 14.0356 24.4109 14.0356H20.1609ZM0.433594 4.62486C0.433594 3.41718 0.913344 2.25896 1.7673 1.405C2.62126 0.551039 3.77948 0.0712891 4.98717 0.0712891H25.018C26.2257 0.0712891 27.3839 0.551039 28.2379 1.405C29.0918 2.25896 29.5716 3.41718 29.5716 4.62486V17.3749C29.5716 18.5825 29.0918 19.7408 28.2379 20.5947C27.3839 21.4487 26.2257 21.9284 25.018 21.9284H4.98838C3.7807 21.9284 2.62248 21.4487 1.76852 20.5947C0.914558 19.7408 0.434808 18.5825 0.434808 17.3749L0.433594 4.62486ZM4.98717 1.89272C4.26256 1.89272 3.56762 2.18057 3.05525 2.69294C2.54287 3.20532 2.25502 3.90025 2.25502 4.62486V5.53557H27.7502V4.62486C27.7502 3.90025 27.4623 3.20532 26.9499 2.69294C26.4376 2.18057 25.7426 1.89272 25.018 1.89272H4.98717ZM2.25502 17.3749C2.25502 18.0995 2.54287 18.7944 3.05525 19.3068C3.56762 19.8192 4.26256 20.107 4.98717 20.107H25.018C25.7426 20.107 26.4376 19.8192 26.9499 19.3068C27.4623 18.7944 27.7502 18.0995 27.7502 17.3749V7.357H2.25624L2.25502 17.3749Z"
        fill={color}
      />
    </svg>
  );
}

export function LockIcon(props: IconProps) {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.51953 6.40972V3.93056C3.51953 3.05387 3.86779 2.21309 4.48771 1.59317C5.10762 0.973263 5.9484 0.625 6.82509 0.625C7.70177 0.625 8.54256 0.973263 9.16247 1.59317C9.78238 2.21309 10.1306 3.05387 10.1306 3.93056V6.40972"
        stroke="currentColor"
        strokeWidth="1.0625"
        strokeLinecap="round"
      />
      <path
        d="M1.04102 6.40967H12.6105V13.8472C12.6105 14.2855 12.4363 14.7059 12.1264 15.0159C11.8164 15.3258 11.396 15.4999 10.9577 15.4999H2.69379C2.25545 15.4999 1.83506 15.3258 1.5251 15.0159C1.21515 14.7059 1.04102 14.2855 1.04102 13.8472V6.40967Z"
        stroke="currentColor"
        strokeWidth="1.0625"
        strokeLinecap="round"
      />
      <path
        d="M8.89062 10.955H8.89889V10.9632H8.89062V10.955Z"
        stroke="currentColor"
        strokeWidth="1.0625"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function AirConditionerIcon(props: IconProps) {
  return (
    <svg
      width="22"
      height="15"
      viewBox="0 0 22 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.72085 14.897C8.65575 14.7904 8.65575 14.7787 8.76495 14.5292C8.89628 14.2274 8.95784 13.899 8.94492 13.5692C8.932 13.2395 8.84494 12.9171 8.6904 12.6268C8.38733 12.0515 8.31222 11.3805 8.48041 10.7509C8.63475 10.1892 8.84789 9.96434 9.04109 10.1583C9.13559 10.2649 9.13349 10.2852 8.94449 10.8106C8.86329 11.0776 8.83512 11.3582 8.86161 11.6363C8.88811 11.9144 8.96874 12.1844 9.09884 12.4306C9.28191 12.7867 9.38263 13.1804 9.39337 13.5819C9.4041 13.9834 9.32456 14.3821 9.16079 14.7477C9.05579 14.9449 9.03164 14.9769 8.91719 14.9897C8.87828 15.0006 8.83681 14.9968 8.80037 14.9792C8.76393 14.9616 8.73496 14.9313 8.71875 14.8938L8.72085 14.897ZM10.8418 14.9396C10.7483 14.8437 10.7672 14.7456 10.8922 14.4355C10.973 14.227 11.015 14.0051 11.0161 13.781C11.0468 13.3731 10.9577 12.9651 10.7599 12.6086C10.5704 12.2429 10.4781 11.8333 10.4921 11.4203C10.4921 10.8404 10.7158 10.1583 10.9195 10.105C10.9488 10.0932 10.9805 10.0885 11.0119 10.0915C11.0433 10.0945 11.0736 10.105 11.1002 10.1222C11.1269 10.1393 11.1491 10.1627 11.1652 10.1903C11.1812 10.2179 11.1906 10.2489 11.1925 10.2809C11.1724 10.4141 11.1346 10.5438 11.0801 10.6667C10.9805 10.9113 10.9423 11.1772 10.9688 11.4405C10.9324 11.7187 10.98 12.0015 11.1053 12.2516C11.3449 12.6392 11.4712 13.0879 11.4697 13.5455C11.515 13.9666 11.4356 14.3918 11.2418 14.7669C11.1494 14.9439 11.1106 14.9801 11.0035 14.9939C10.9728 15 10.9411 14.9986 10.911 14.9899C10.8809 14.9812 10.8532 14.9654 10.8302 14.9439L10.8418 14.9396ZM12.926 14.9396C12.8546 14.8639 12.8766 14.7488 13.031 14.3353C13.1066 14.1292 13.1422 13.9103 13.136 13.6904C13.144 13.3187 13.056 12.9512 12.8808 12.6246C12.7914 12.4299 12.7167 12.2286 12.6572 12.0224C12.5748 11.6322 12.5748 11.2286 12.6572 10.8383C12.7116 10.5779 12.8189 10.3318 12.9722 10.1157C13.0218 10.0864 13.0807 10.078 13.1364 10.0921C13.1921 10.1062 13.2401 10.1418 13.2704 10.1914C13.3344 10.2916 13.3323 10.3097 13.2032 10.6369C13.0858 10.919 13.032 11.2241 13.0456 11.53C13.0592 11.8359 13.14 12.1349 13.2819 12.4051C13.4893 12.791 13.5939 13.2253 13.5853 13.6649C13.601 13.9294 13.5653 14.1945 13.4804 14.4451C13.3491 14.8511 13.2452 14.9993 13.0887 14.9993C13.058 15.0018 13.0272 14.9976 12.9983 14.9867C12.9695 14.9758 12.9434 14.9586 12.9218 14.9364L12.926 14.9396ZM0.621402 8.79088C0.572792 8.74183 0.536744 8.68146 0.516406 8.61502C0.498906 7.3403 0.495406 6.06558 0.505906 4.79086L0.516406 1.06049L0.652901 0.783377C0.800906 0.463322 1.06385 0.212809 1.38788 0.083134C1.61152 7.14687e-08 1.66087 0 11.0035 0C20.3461 0 20.3975 7.14687e-08 20.6212 0.083134C20.9446 0.21204 21.2075 0.461331 21.3562 0.78018L21.4895 1.05729L21.5 4.79086C21.5 6.84149 21.5 8.56599 21.4874 8.61502C21.4671 8.68146 21.431 8.74183 21.3824 8.79088C21.3005 8.87401 21.2018 8.87401 11.0014 8.87401C0.800947 8.87401 0.7033 8.85909 0.621402 8.77596V8.79088ZM1.52962 7.19215C1.54222 6.23291 1.54957 6.17429 1.64092 5.98351C1.71083 5.84872 1.81346 5.73426 1.93911 5.65097L2.13231 5.51775H19.8988L20.0899 5.65097C20.2117 5.73657 20.3105 5.85158 20.3776 5.98564C20.47 6.17429 20.4773 6.23291 20.4826 7.19535L20.4973 8.20255H20.8207V4.72904C20.8207 0.975224 20.8207 1.08927 20.6044 0.88463L20.5057 0.788707L20.4805 1.07861C20.4832 1.25874 20.4335 1.43568 20.3377 1.58732C20.2419 1.73897 20.1042 1.8586 19.9419 1.93126C19.8075 1.98882 18.8425 1.99628 11.0087 1.99628C3.17492 1.99628 2.2142 2.01333 2.07561 1.95791C1.91288 1.88646 1.77515 1.76688 1.68038 1.61478C1.58561 1.46268 1.53819 1.28512 1.54432 1.10525L1.52017 0.818549L1.41518 0.914473C1.19153 1.11591 1.19678 1.0072 1.19678 4.75142V8.22706H1.51912L1.52962 7.19215ZM9.85166 4.98377C9.81837 4.96644 9.78997 4.9408 9.76913 4.90925C9.7483 4.87771 9.73571 4.8413 9.73256 4.80345C9.72941 4.76561 9.7358 4.72757 9.75112 4.69293C9.76645 4.65828 9.79021 4.62816 9.82016 4.60541C9.89891 4.54785 10.0701 4.53719 11.0014 4.53719C12.2288 4.53719 12.2907 4.54998 12.2666 4.80258C12.2445 5.02107 12.1668 5.036 11.0066 5.036C10.6227 5.05967 10.2374 5.04289 9.85691 4.9859L9.85166 4.98377ZM17.7926 4.89531C17.7747 4.86828 17.7632 4.83746 17.759 4.80522C17.7547 4.77298 17.7577 4.74017 17.7678 4.70931C17.778 4.67844 17.7949 4.65034 17.8174 4.62716C17.8399 4.60398 17.8673 4.58633 17.8976 4.57556C18.0845 4.47537 18.285 4.78873 18.1317 4.94327C18.1061 4.96337 18.0768 4.97804 18.0455 4.98641C18.0142 4.99479 17.9816 4.99669 17.9496 4.99202C17.9176 4.98735 17.8868 4.97619 17.8591 4.95921C17.8314 4.94223 17.8073 4.91978 17.7884 4.89318L17.7926 4.89531ZM18.8614 4.90277C18.8297 4.86214 18.8137 4.8112 18.8164 4.75945C18.819 4.70771 18.8401 4.65871 18.8757 4.62161C18.9114 4.58452 18.9591 4.56187 19.01 4.55791C19.0609 4.55395 19.1115 4.56894 19.1523 4.60008C19.1816 4.61631 19.2068 4.63922 19.2259 4.66699C19.245 4.69477 19.2576 4.72666 19.2625 4.76018C19.2675 4.79369 19.2647 4.82791 19.2545 4.86017C19.2442 4.89242 19.2268 4.92183 19.2035 4.94609C19.1802 4.97035 19.1516 4.9888 19.1201 5.00001C19.0886 5.01121 19.055 5.01485 19.0219 5.01066C18.9887 5.00646 18.957 4.99454 18.9292 4.97582C18.9013 4.9571 18.8782 4.9321 18.8614 4.90277ZM19.988 8.01603V7.82951H2.01576V8.20255H19.988V8.01603ZM19.988 7.14205V6.9129H2.01576V7.37121H19.988V7.14205ZM19.988 6.31818C19.9777 6.24966 19.9511 6.18473 19.9105 6.12902C19.8699 6.0733 19.8165 6.02848 19.755 5.99843C19.6909 5.96646 17.3012 5.95153 11.0014 5.95153C4.70157 5.95153 2.31605 5.96646 2.24885 5.99843C2.18835 6.02989 2.13583 6.07511 2.0954 6.13058C2.05496 6.18605 2.02771 6.25025 2.01576 6.31818V6.41197H19.988V6.31818ZM19.8642 1.41541C19.9754 1.30243 19.988 1.27259 19.988 0.979488V0.659742H2.01366V0.979488C2.01366 1.27152 2.02101 1.29923 2.13231 1.41541L2.2562 1.53904H19.735L19.8642 1.41541Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ReceiptIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.666 1.33398H4.33268C3.41221 1.33398 2.66602 2.08018 2.66602 3.00065V13.834C2.66602 14.7545 3.41221 15.5007 4.33268 15.5007H12.666C13.5865 15.5007 14.3327 14.7545 14.3327 13.834V3.00065C14.3327 2.08018 13.5865 1.33398 12.666 1.33398Z"
        stroke="currentColor"
        strokeWidth="1.33333"
      />
      <path
        d="M6 5.5H11M6 8.83333H11M6 12.1667H9.33333"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function LocationIcon(props: IconProps) {
  return (
    <svg
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 0.333252C8.0913 0.333252 9.61742 0.965393 10.7426 2.09061C11.8679 3.21583 12.5 4.74195 12.5 6.33325C12.5 8.38258 11.3827 10.0599 10.2053 11.2633C9.61712 11.858 8.97528 12.3971 8.288 12.8739L8.004 13.0673L7.87067 13.1559L7.61933 13.3159L7.39533 13.4526L7.118 13.6139C6.92976 13.7214 6.71675 13.7779 6.5 13.7779C6.28325 13.7779 6.07024 13.7214 5.882 13.6139L5.60467 13.4526L5.258 13.2393L5.13 13.1559L4.85667 12.9739C4.11522 12.4723 3.4246 11.8993 2.79467 11.2633C1.61733 10.0593 0.5 8.38258 0.5 6.33325C0.5 4.74195 1.13214 3.21583 2.25736 2.09061C3.38258 0.965393 4.9087 0.333252 6.5 0.333252ZM6.5 1.66659C5.26232 1.66659 4.07534 2.15825 3.20017 3.03342C2.325 3.90859 1.83333 5.09557 1.83333 6.33325C1.83333 7.88125 2.68133 9.23992 3.74733 10.3306C4.20569 10.7946 4.70111 11.2204 5.22867 11.6039L5.534 11.8213C5.63267 11.8901 5.72756 11.9541 5.81867 12.0133L6.07867 12.1799L6.30733 12.3193L6.5 12.4319L6.80333 12.2526L7.048 12.0993C7.17822 12.0166 7.31756 11.9239 7.466 11.8213L7.77133 11.6039C8.29889 11.2204 8.79431 10.7946 9.25267 10.3306C10.3187 9.24059 11.1667 7.88125 11.1667 6.33325C11.1667 5.09557 10.675 3.90859 9.79983 3.03342C8.92466 2.15825 7.73768 1.66659 6.5 1.66659ZM6.5 3.66658C7.20724 3.66659 7.88552 3.94754 8.38562 4.44763C8.88572 4.94773 9.16667 5.62601 9.16667 6.33325C9.16667 7.0405 8.88572 7.71877 8.38562 8.21887C7.88552 8.71897 7.20724 8.99992 6.5 8.99992C5.79276 8.99992 5.11448 8.71897 4.61438 8.21887C4.11428 7.71877 3.83333 7.0405 3.83333 6.33325C3.83333 5.62601 4.11428 4.94773 4.61438 4.44763C5.11448 3.94754 5.79276 3.66659 6.5 3.66658ZM6.5 4.99992C6.14638 4.99992 5.80724 5.14039 5.55719 5.39044C5.30714 5.64049 5.16667 5.97963 5.16667 6.33325C5.16667 6.68687 5.30714 7.02601 5.55719 7.27606C5.80724 7.52611 6.14638 7.66658 6.5 7.66658C6.85362 7.66658 7.19276 7.52611 7.44281 7.27606C7.69286 7.02601 7.83333 6.68687 7.83333 6.33325C7.83333 5.97963 7.69286 5.64049 7.44281 5.39044C7.19276 5.14039 6.85362 4.99992 6.5 4.99992Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function WishlistIcon(props: IconProps) {
  return (
    <svg
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.7244 1C11.0884 0.999694 11.4489 1.07207 11.7846 1.21287C12.1203 1.35368 12.4245 1.56009 12.6794 1.82C13.2046 2.35319 13.499 3.07158 13.499 3.82C13.499 4.56842 13.2046 5.28681 12.6794 5.82L7.4994 11.065L2.3194 5.82C1.79419 5.28681 1.49979 4.56842 1.49979 3.82C1.49979 3.07158 1.79419 2.35319 2.3194 1.82C2.57445 1.56028 2.87869 1.35398 3.21435 1.21315C3.55002 1.07232 3.91039 0.999787 4.2744 0.999787C4.63841 0.999787 4.99878 1.07232 5.33444 1.21315C5.67011 1.35398 5.97435 1.56028 6.2294 1.82L7.4994 3.12L8.7644 1.83C9.01852 1.56699 9.32307 1.35793 9.65984 1.21532C9.99661 1.07271 10.3587 0.999476 10.7244 1ZM10.7244 1.34143e-06C10.2272 -0.000420019 9.73494 0.0984289 9.27646 0.290752C8.81797 0.483076 8.4025 0.765002 8.0544 1.12L7.4994 1.68L6.9444 1.12C6.59587 0.765643 6.1803 0.484206 5.72189 0.292097C5.26349 0.0999872 4.77143 0.00104871 4.2744 0.00104871C3.77737 0.00104871 3.28531 0.0999872 2.82691 0.292097C2.3685 0.484206 1.95292 0.765643 1.6044 1.12C0.895338 1.84181 0.498047 2.81318 0.498047 3.825C0.498047 4.83682 0.895338 5.80819 1.6044 6.53L7.4994 12.5L13.3944 6.53C14.1035 5.80819 14.5008 4.83682 14.5008 3.825C14.5008 2.81318 14.1035 1.84181 13.3944 1.12C13.0458 0.765678 12.6302 0.484195 12.1719 0.29192C11.7135 0.0996454 11.2215 0.000415799 10.7244 1.34143e-06Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LogoutIcon(props: IconProps) {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 0H9C9.79565 0 10.5587 0.316071 11.1213 0.87868C11.6839 1.44129 12 2.20435 12 3V7H11V3C11 2.46957 10.7893 1.96086 10.4142 1.58579C10.0391 1.21071 9.53043 1 9 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H9C9.53043 18 10.0391 17.7893 10.4142 17.4142C10.7893 17.0391 11 16.5304 11 16V12H12V16C12 16.7956 11.6839 17.5587 11.1213 18.1213C10.5587 18.6839 9.79565 19 9 19H3C2.20435 19 1.44129 18.6839 0.87868 18.1213C0.316071 17.5587 0 16.7956 0 16V3C0 2.20435 0.316071 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0ZM6 9H17.25L14 5.75L14.66 5L19.16 9.5L14.66 14L14 13.25L17.25 10H6V9Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function EditIcon({ color = "#004987", ...props }: IconProps) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.5 6.49994L18.5 9.49994M13.5 20.4999H21.5M5.5 16.4999L4.5 20.4999L8.5 19.4999L20.086 7.91394C20.4609 7.53889 20.6716 7.03027 20.6716 6.49994C20.6716 5.96961 20.4609 5.461 20.086 5.08594L19.914 4.91394C19.5389 4.539 19.0303 4.32837 18.5 4.32837C17.9697 4.32837 17.4611 4.539 17.086 4.91394L5.5 16.4999Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CloseIcon(props: IconProps) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.81292 17.5615C8.65469 17.7187 8.5658 17.9327 8.5658 18.1565C8.5658 18.3803 8.65469 18.5954 8.81292 18.7547C8.97114 18.9139 9.18573 19.0041 9.40949 19.0055C9.63325 19.007 9.84785 18.9194 10.0061 18.7622L14.1821 14.6125L18.3582 18.815C18.5164 18.9743 18.731 19.0645 18.9548 19.0659C19.1785 19.0673 19.3931 18.9798 19.5513 18.8226C19.7096 18.6654 19.7984 18.4513 19.7984 18.2276C19.7984 18.0038 19.7096 17.7886 19.5513 17.6294L15.3753 13.4268L19.5513 9.27713C19.7096 9.11991 19.7985 8.90587 19.7984 8.6821C19.7985 8.45834 19.7096 8.24318 19.5513 8.08395C19.3931 7.92472 19.1785 7.83448 18.9548 7.83306C18.731 7.83165 18.5164 7.91918 18.3582 8.0764L14.1821 12.2261L10.0061 8.02356C9.84785 7.86434 9.63326 7.77409 9.4095 7.77267C9.18574 7.77126 8.97114 7.85879 8.81292 8.01601C8.6547 8.17324 8.56581 8.38728 8.56581 8.61104C8.56581 8.83481 8.65469 9.04997 8.81292 9.2092L12.989 13.4118L8.81292 17.5615Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CheckIcon({ color = "#54D269", ...props }: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM13.535 6.381L8.585 11.331L6.465 9.21C6.37216 9.11709 6.26192 9.04338 6.14059 8.99307C6.01926 8.94276 5.8892 8.91684 5.75785 8.9168C5.49258 8.9167 5.23814 9.02199 5.0505 9.2095C4.86286 9.39701 4.75739 9.65138 4.7573 9.91665C4.7572 10.1819 4.86249 10.4364 5.05 10.624L7.808 13.382C7.91015 13.4842 8.03144 13.5653 8.16493 13.6206C8.29842 13.6759 8.4415 13.7044 8.586 13.7044C8.7305 13.7044 8.87358 13.6759 9.00707 13.6206C9.14056 13.5653 9.26185 13.4842 9.364 13.382L14.95 7.796C15.1376 7.60836 15.2431 7.35386 15.2431 7.0885C15.2431 6.82314 15.1376 6.56864 14.95 6.381C14.7624 6.19336 14.5079 6.08794 14.2425 6.08794C13.9771 6.08794 13.7226 6.19336 13.535 6.381Z"
        fill={color}
      />
    </svg>
  );
}

export function ClockIcon({ stroke = "#A7A7A7", ...props }: IconProps) {
  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.0006 3C6.01209 3 1.96484 7.03125 1.96484 12C1.96484 16.9688 6.01209 21 11.0006 21C15.989 21 20.0363 16.9688 20.0363 12C20.0363 7.03125 15.989 3 11.0006 3Z"
        stroke={stroke}
        strokeMiterlimit="10"
      />
      <path
        d="M11 6V12.75H15.5179"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TimeIcon(props: IconProps) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 6C1 8.75958 3.24042 11 6 11C8.75958 11 11 8.75958 11 6C11 3.24042 8.75958 1 6 1C3.24042 1 1 3.24042 1 6V6"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 3V6L8 7"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SuccessIcon(props: IconProps) {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.4998 0.989258C31.3157 0.989258 40.0832 9.75672 40.0832 20.5726C40.0832 31.3885 31.3157 40.1559 20.4998 40.1559C9.68396 40.1559 0.916504 31.3885 0.916504 20.5726C0.916504 9.75672 9.68396 0.989258 20.4998 0.989258ZM27.4225 13.4854L17.7288 23.1791L13.5771 19.0255C13.3953 18.8436 13.1794 18.6992 12.9418 18.6007C12.7042 18.5022 12.4495 18.4514 12.1923 18.4513C11.6728 18.4511 11.1745 18.6573 10.8071 19.0245C10.4396 19.3917 10.2331 19.8899 10.2329 20.4094C10.2327 20.9288 10.4389 21.4271 10.8061 21.7946L16.2072 27.1957C16.4072 27.3958 16.6447 27.5546 16.9062 27.6629C17.1676 27.7712 17.4478 27.827 17.7308 27.827C18.0137 27.827 18.2939 27.7712 18.5554 27.6629C18.8168 27.5546 19.0543 27.3958 19.2543 27.1957L30.1936 16.2564C30.5611 15.889 30.7675 15.3906 30.7675 14.8709C30.7675 14.3512 30.5611 13.8528 30.1936 13.4854C29.8261 13.1179 29.3277 12.9115 28.8081 12.9115C28.2884 12.9115 27.79 13.1179 27.4225 13.4854Z"
        fill="#0083C3"
      />
    </svg>
  );
}

export function CopyIcon(props: IconProps) {
  return (
    <svg
      fill="#000000"
      height="13px"
      width="13px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 64.00 64.00"
      enableBackground="new 0 0 64 64"
      xmlSpace="preserve"
      stroke="#000000"
      strokeWidth="1.152"
      {...props}
    >
      <g
        id="SVGRepo_bgCarrier"
        strokeWidth="0"
        transform="translate(0,0), scale(1)"
      ></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g id="Text-files">
          {" "}
          <path d="M53.9791489,9.1429005H50.010849c-0.0826988,0-0.1562004,0.0283995-0.2331009,0.0469999V5.0228 C49.7777481,2.253,47.4731483,0,44.6398468,0h-34.422596C7.3839517,0,5.0793519,2.253,5.0793519,5.0228v46.8432999 c0,2.7697983,2.3045998,5.0228004,5.1378999,5.0228004h6.0367002v2.2678986C16.253952,61.8274002,18.4702511,64,21.1954517,64 h32.783699c2.7252007,0,4.9414978-2.1725998,4.9414978-4.8432007V13.9861002 C58.9206467,11.3155003,56.7043495,9.1429005,53.9791489,9.1429005z M7.1110516,51.8661003V5.0228 c0-1.6487999,1.3938999-2.9909999,3.1062002-2.9909999h34.422596c1.7123032,0,3.1062012,1.3422,3.1062012,2.9909999v46.8432999 c0,1.6487999-1.393898,2.9911003-3.1062012,2.9911003h-34.422596C8.5049515,54.8572006,7.1110516,53.5149002,7.1110516,51.8661003z M56.8888474,59.1567993c0,1.550602-1.3055,2.8115005-2.9096985,2.8115005h-32.783699 c-1.6042004,0-2.9097996-1.2608986-2.9097996-2.8115005v-2.2678986h26.3541946 c2.8333015,0,5.1379013-2.2530022,5.1379013-5.0228004V11.1275997c0.0769005,0.0186005,0.1504021,0.0469999,0.2331009,0.0469999 h3.9682999c1.6041985,0,2.9096985,1.2609005,2.9096985,2.8115005V59.1567993z"></path>{" "}
          <path d="M38.6031494,13.2063999H16.253952c-0.5615005,0-1.0159006,0.4542999-1.0159006,1.0158005 c0,0.5615997,0.4544001,1.0158997,1.0159006,1.0158997h22.3491974c0.5615005,0,1.0158997-0.4542999,1.0158997-1.0158997 C39.6190491,13.6606998,39.16465,13.2063999,38.6031494,13.2063999z"></path>{" "}
          <path d="M38.6031494,21.3334007H16.253952c-0.5615005,0-1.0159006,0.4542999-1.0159006,1.0157986 c0,0.5615005,0.4544001,1.0159016,1.0159006,1.0159016h22.3491974c0.5615005,0,1.0158997-0.454401,1.0158997-1.0159016 C39.6190491,21.7877007,39.16465,21.3334007,38.6031494,21.3334007z"></path>{" "}
          <path d="M38.6031494,29.4603004H16.253952c-0.5615005,0-1.0159006,0.4543991-1.0159006,1.0158997 s0.4544001,1.0158997,1.0159006,1.0158997h22.3491974c0.5615005,0,1.0158997-0.4543991,1.0158997-1.0158997 S39.16465,29.4603004,38.6031494,29.4603004z"></path>{" "}
          <path d="M28.4444485,37.5872993H16.253952c-0.5615005,0-1.0159006,0.4543991-1.0159006,1.0158997 s0.4544001,1.0158997,1.0159006,1.0158997h12.1904964c0.5615025,0,1.0158005-0.4543991,1.0158005-1.0158997 S29.0059509,37.5872993,28.4444485,37.5872993z"></path>{" "}
        </g>{" "}
      </g>
    </svg>
  );
}

export function CompanyNameIcon(props: IconProps) {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="31"
        height="31"
        rx="15.5"
        fill="#0083C3"
        fillOpacity="0.69"
      />
      <rect
        x="0.5"
        y="0.5"
        width="30"
        height="30"
        rx="15"
        stroke="#004987"
        strokeOpacity="0.5"
      />
      <path
        d="M16.8105 21.8321H22.25"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.085 9.34609C16.6667 8.65084 17.7125 8.54889 18.4222 9.1188C18.4614 9.14972 19.7221 10.1291 19.7221 10.1291C20.5017 10.6004 20.744 11.6023 20.262 12.3669C20.2365 12.4079 13.109 21.3234 13.109 21.3234C12.8718 21.6192 12.5119 21.7938 12.1272 21.798L9.39765 21.8323L8.78265 19.2292C8.6965 18.8632 8.78265 18.4788 9.01978 18.183L16.085 9.34609Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7656 11.0006L18.8548 14.141"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AddressIcon(props: IconProps) {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="31"
        height="31"
        rx="15.5"
        fill="#0083C3"
        fillOpacity="0.69"
      />
      <rect
        x="0.5"
        y="0.5"
        width="30"
        height="30"
        rx="15"
        stroke="#004987"
        strokeOpacity="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.375 14.3754C17.375 13.3394 16.5356 12.5 15.5004 12.5C14.4644 12.5 13.625 13.3394 13.625 14.3754C13.625 15.4106 14.4644 16.25 15.5004 16.25C16.5356 16.25 17.375 15.4106 17.375 14.3754Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4996 22.25C14.6008 22.25 9.875 18.4238 9.875 14.4225C9.875 11.29 12.3928 8.75 15.4996 8.75C18.6064 8.75 21.125 11.29 21.125 14.4225C21.125 18.4238 16.3985 22.25 15.4996 22.25Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PaddingIcon(props: IconProps) {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="31" height="31" rx="15.5" fill="#FFF2E9" />
      <rect
        x="0.5"
        y="0.5"
        width="30"
        height="30"
        rx="15"
        stroke="#F39450"
        strokeOpacity="0.36"
        {...props}
      />
      <path
        d="M19.25 23C18.2125 23 17.3282 22.6343 16.5972 21.9028C15.8663 21.1713 15.5005 20.287 15.5 19.25C15.4995 18.213 15.8653 17.3288 16.5972 16.5972C17.3293 15.8658 18.2135 15.5 19.25 15.5C20.2865 15.5 21.171 15.8658 21.9035 16.5972C22.636 17.3288 23.0015 18.213 23 19.25C22.9985 20.287 22.6328 21.1715 21.9028 21.9035C21.1728 22.6355 20.2885 23.001 19.25 23ZM20.5062 21.0312L21.0312 20.5062L19.625 19.1V17H18.875V19.4L20.5062 21.0312ZM10.25 22.25C9.8375 22.25 9.4845 22.1033 9.191 21.8097C8.8975 21.5162 8.7505 21.163 8.75 20.75V10.25C8.75 9.8375 8.897 9.4845 9.191 9.191C9.485 8.8975 9.838 8.7505 10.25 8.75H13.3813C13.5188 8.3125 13.7875 7.95325 14.1875 7.67225C14.5875 7.39125 15.025 7.2505 15.5 7.25C16 7.25 16.447 7.39075 16.841 7.67225C17.235 7.95375 17.5005 8.313 17.6375 8.75H20.75C21.1625 8.75 21.5157 8.897 21.8097 9.191C22.1038 9.485 22.2505 9.838 22.25 10.25V14.9375C22.025 14.775 21.7875 14.6375 21.5375 14.525C21.2875 14.4125 21.025 14.3125 20.75 14.225V10.25H19.25V12.5H11.75V10.25H10.25V20.75H14.225C14.3125 21.025 14.4125 21.2875 14.525 21.5375C14.6375 21.7875 14.775 22.025 14.9375 22.25H10.25ZM15.5 10.25C15.7125 10.25 15.8908 10.178 16.0347 10.034C16.1788 9.89 16.2505 9.712 16.25 9.5C16.2495 9.288 16.1775 9.11 16.034 8.966C15.8905 8.822 15.7125 8.75 15.5 8.75C15.2875 8.75 15.1095 8.822 14.966 8.966C14.8225 9.11 14.7505 9.288 14.75 9.5C14.7495 9.712 14.8215 9.89025 14.966 10.0347C15.1105 10.1792 15.2885 10.251 15.5 10.25Z"
        fill="#F39450"
      />
    </svg>
  );
}

export function CanceledIcon(props: IconProps) {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y="0.75" width="28" height="28" rx="14" fill="#FFEDE9" />
      <rect
        x="0.5"
        y="1.25"
        width="27"
        height="27"
        rx="13.5"
        stroke="#F55157"
        strokeOpacity="0.36"
      />
      <path
        d="M9.33301 19.4166L13.9997 14.75M13.9997 14.75L18.6663 10.0833M13.9997 14.75L9.33301 10.0833M13.9997 14.75L18.6663 19.4166"
        stroke="#F55157"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CompletedIcon(props: IconProps) {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y="0.75" width="28" height="28" rx="14" fill="#E9FFEB" />
      <rect
        x="0.5"
        y="1.25"
        width="27"
        height="27"
        rx="13.5"
        stroke="#46D446"
        strokeOpacity="0.36"
      />
      <path
        d="M12.3674 16.85L18.0174 11.2C18.1508 11.0667 18.3063 11 18.4841 11C18.6619 11 18.8174 11.0667 18.9508 11.2C19.0841 11.3333 19.1508 11.4918 19.1508 11.6753C19.1508 11.8589 19.0841 12.0171 18.9508 12.15L12.8341 18.2833C12.7008 18.4167 12.5452 18.4833 12.3674 18.4833C12.1897 18.4833 12.0341 18.4167 11.9008 18.2833L9.0341 15.4167C8.90077 15.2833 8.83677 15.1251 8.8421 14.942C8.84744 14.7589 8.91699 14.6004 9.05077 14.4667C9.18455 14.3329 9.34299 14.2662 9.5261 14.2667C9.70922 14.2671 9.86744 14.3338 10.0008 14.4667L12.3674 16.85Z"
        fill="#46D446"
      />
    </svg>
  );
}

export function ActiveCheckIcon(props: IconProps) {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="1.23438"
        y="0.5"
        width="30.3562"
        height="30.3562"
        rx="15.1781"
        fill="#0083C3"
      />
      <rect
        x="1.23438"
        y="0.5"
        width="30.3562"
        height="30.3562"
        rx="15.1781"
        stroke="#004987"
      />
      <path
        d="M10.7344 16L14.7344 20L22.2344 12"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function InactiveCheckIcon(props: IconProps) {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="1.23438"
        y="0.5"
        width="30.3562"
        height="30.3562"
        rx="15.1781"
        fill="#DBDBDB"
      />
      <rect
        x="1.23438"
        y="0.5"
        width="30.3562"
        height="30.3562"
        rx="15.1781"
        stroke="#BFC2C9"
      />
      <path
        d="M9.73438 16L13.7344 20L21.2344 12"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function DocumentIcon({ color = "#08080C", ...props }: IconProps) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.5969 13.5194H7.5802"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5969 10.0308H7.5802"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.87603 6.55009H7.5802"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7572 2.2915C13.7572 2.2915 7.35965 2.29484 7.34965 2.29484C5.04965 2.309 3.62549 3.82234 3.62549 6.13067V13.794C3.62549 16.114 5.06049 17.6332 7.38049 17.6332C7.38049 17.6332 13.7772 17.6307 13.788 17.6307C16.088 17.6165 17.513 16.1023 17.513 13.794V6.13067C17.513 3.81067 16.0772 2.2915 13.7572 2.2915Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DeleteIcon({ color = "#FF7878", ...props }: IconProps) {
  return (
    <svg
      width="19"
      height="21"
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.8238 7.96826C16.8238 7.96826 16.2808 14.7033 15.9658 17.5403C15.8158 18.8953 14.9788 19.6893 13.6078 19.7143C10.9988 19.7613 8.38681 19.7643 5.77881 19.7093C4.45981 19.6823 3.63681 18.8783 3.48981 17.5473C3.17281 14.6853 2.63281 7.96826 2.63281 7.96826"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.208 4.73975H1.25"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9386 4.73973C14.1536 4.73973 13.4776 4.18473 13.3236 3.41573L13.0806 2.19973C12.9306 1.63873 12.4226 1.25073 11.8436 1.25073H7.61063C7.03163 1.25073 6.52363 1.63873 6.37363 2.19973L6.13063 3.41573C5.97663 4.18473 5.30063 4.73973 4.51562 4.73973"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function InnovativeDesignIcon(props: IconProps) {
  return (
    <svg
      width="33"
      height="25"
      viewBox="0 0 33 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.3617 1.02422C19.5641 1.28437 19.7086 3.59687 19.7375 7.47031L19.8242 13.5117H20.8359H21.8477L21.9344 8.82891L21.9922 4.14609L23.0039 4.60859L23.9867 5.07109L24.0734 8.10625C24.1602 10.6211 24.2469 11.1992 24.6805 11.4594C25.6344 12.0664 26.1547 11.3438 26.3281 9.20469L26.4727 7.23906L27.2242 8.07734C29.1898 10.2164 30.2305 13.107 30.5484 17.2695L30.7508 20.0156H16.5H2.24922L2.45156 17.2695C2.76953 13.107 3.81016 10.2164 5.77578 8.07734L6.52734 7.23906L6.67188 9.20469C6.84531 11.3438 7.36562 12.0664 8.34844 11.4594C8.75313 11.1992 8.83984 10.6211 8.92656 8.10625L9.01328 5.07109L9.99609 4.60859L11.0078 4.14609L11.0656 8.82891L11.1523 13.5117H12.1641H13.1758L13.2625 7.47031C13.2914 3.59687 13.4359 1.28437 13.6383 1.02422C13.8695 0.764061 14.7367 0.648438 16.5 0.648438C18.2633 0.648438 19.1305 0.764061 19.3617 1.02422Z"
        fill="#77BC43"
      />
      <path
        d="M32.4273 22.7906C32.6875 23.1086 32.7164 23.3688 32.4852 23.7156C32.225 24.1781 30.8375 24.207 16.5 24.207C2.1625 24.207 0.775 24.1781 0.514844 23.7156C0.283594 23.3688 0.3125 23.1086 0.572656 22.7906C0.919531 22.3859 2.68281 22.3281 16.5 22.3281C30.3172 22.3281 32.0805 22.3859 32.4273 22.7906Z"
        fill="#77BC43"
      />
    </svg>
  );
}

export function SteelIcon(props: IconProps) {
  return (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.7762 14.4344L3.3418 28.8688L3.48711 33.1797L3.63242 37.5391L8.13711 37.6844L12.5934 37.8297V40.8328V43.8359L7.9918 48.4375L3.3418 53.0391L3.48711 57.3984L3.63242 61.7578L16.7105 61.9031L29.7887 62L44.223 47.6141L58.609 33.1797L58.5121 28.8203L58.3668 24.4609L53.9105 24.3156L49.4059 24.1703V21.1672V18.1641L54.0074 13.5625L58.6574 8.96094L58.5121 4.60156L58.3668 0.242188L45.2887 0.0968781L32.2105 0L17.7762 14.4344ZM41.1715 15.2578L28.3355 28.0938H18.1637H7.9918L20.8277 15.2578L33.6637 2.42188H43.8355H54.0074L41.1715 15.2578ZM43.2543 20.4406C31.0965 32.6469 30.7574 32.9375 30.6121 31.4359C30.4668 29.9828 31.2902 29.0141 42.9637 17.3406C55.1215 5.13438 55.4605 4.84375 55.6059 6.34531C55.7512 7.79844 54.9277 8.76719 43.2543 20.4406ZM41.6559 29.7891C36.6668 34.7781 35.8434 36.3766 38.023 36.7156C38.7012 36.8125 40.5418 35.3109 44.0777 31.7266L49.1637 26.6406H51.5855H54.0074L41.1715 39.4766L28.3355 52.3125H25.9137H23.4918L27.8027 48.0016C30.709 45.0953 32.0168 43.4484 31.8715 42.8188C31.484 40.7844 29.934 41.5109 25.623 45.8219L21.3121 50.1328V43.9328V37.7812H25.5746H29.7887L38.023 29.5469L46.2574 21.3125L46.4027 23.0563C46.548 24.7516 46.3059 25.1391 41.6559 29.7891ZM43.2543 44.6594C31.0965 56.8656 30.7574 57.1562 30.6121 55.6547C30.4668 54.2016 31.2902 53.2328 42.9637 41.5594C55.1215 29.3531 55.4605 29.0625 55.6059 30.5641C55.7512 32.0172 54.9277 32.9859 43.2543 44.6594ZM27.609 32.9375V35.3109L23.1527 35.4563L18.648 35.6016V45.0469V54.4922L23.1527 54.6375L27.609 54.7828V57.1562V59.5781H16.9527H6.29648V57.1562V54.7828L10.8012 54.6375L15.2574 54.4922V45.0469V35.6016L10.8012 35.4563L6.29648 35.3109V32.9375V30.5156H16.9527H27.609V32.9375ZM12.5934 50.1328V52.3125H10.3168H8.04023L10.1715 50.1328C11.334 48.9219 12.3512 47.9531 12.448 47.9531C12.5449 47.9531 12.5934 48.9219 12.5934 50.1328Z"
        fill="#77BC43"
      />
      <path
        d="M33.1308 38.4594C32.6464 39.7188 33.3245 40.7844 34.487 40.5907C35.3105 40.4938 35.6011 40.1063 35.6011 39.2344C35.6011 38.3625 35.3105 37.975 34.487 37.8782C33.8574 37.7813 33.2761 38.0235 33.1308 38.4594Z"
        fill="#77BC43"
      />
    </svg>
  );
}

export function HVACIcon(props: IconProps) {
  return (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.0629 1.79219C29.0629 3.53594 29.0629 3.53594 28.0941 2.66406C27.1254 1.79219 27.0769 1.79219 25.6722 3.14844L24.2191 4.55313L26.641 7.02344C28.5785 9.00938 29.0629 9.78438 29.0629 11.1406V12.7875L26.8832 10.6562L24.7035 8.525L23.1535 10.075L21.555 11.625L25.3332 15.4031C28.9175 18.9875 29.0629 19.2297 29.0629 21.4094C29.0629 23.3953 28.8691 23.7344 27.5129 24.6063L25.9629 25.6234L23.7347 24.3641C21.5066 23.1047 21.4582 23.0563 20.2957 18.5516C19.666 16.0328 19.0363 13.8047 18.891 13.5625C18.5035 12.9328 15.016 14.0469 15.016 14.7734C15.016 15.1125 15.3066 16.3719 15.6941 17.5828C16.0816 18.8422 16.2754 19.8594 16.13 19.8594C15.9847 19.8594 15.2582 19.4719 14.4832 19.0359C13.4175 18.4062 12.9816 17.6313 12.5457 15.6938C11.7707 12.1578 11.5769 11.9641 9.4941 12.3516C8.04098 12.6422 7.75035 12.9328 7.75035 13.8531C7.75035 15.0156 7.70192 15.0156 6.34567 14.2891C4.94098 13.6109 4.89254 13.6109 3.92379 15.3063C2.9066 17.0016 2.9066 17.0984 3.73004 17.7281C4.21442 18.0672 4.74723 18.4062 4.98942 18.4062C5.71598 18.4062 5.28004 19.375 4.55348 19.375C3.87535 19.375 3.82692 19.7141 4.0691 21.4094C4.26285 22.5234 4.4566 23.4922 4.55348 23.5891C4.60192 23.6375 6.10348 23.3469 7.84723 22.8625C10.6082 22.0875 11.1894 22.0391 12.3035 22.6203C12.9816 22.9594 13.5629 23.4438 13.5629 23.6859C13.5629 23.8797 12.4004 24.3641 10.9957 24.7031L8.38004 25.2844L8.86442 27.3672L9.34879 29.45L14.3863 28.0938L19.4722 26.7375L21.6035 27.9969C23.4925 29.1594 23.7347 29.4984 23.7347 31C23.7347 32.5016 23.4925 32.8406 21.6035 34.0031L19.4722 35.2625L14.3863 33.9062L9.34879 32.55L8.86442 34.6328L8.38004 36.7156L10.9957 37.2969C12.4004 37.6359 13.5629 38.1203 13.5629 38.3141C13.5629 38.5563 12.9816 39.0406 12.3035 39.3797C11.1894 39.9609 10.6082 39.9125 7.84723 39.1375C6.10348 38.6531 4.60192 38.3625 4.55348 38.4109C4.4566 38.5078 4.26285 39.4766 4.0691 40.5906C3.82692 42.2859 3.87535 42.625 4.55348 42.625C5.28004 42.625 5.71598 43.5938 4.98942 43.5938C4.74723 43.5938 4.21442 43.9328 3.73004 44.2719C2.9066 44.9016 2.9066 44.9984 3.92379 46.6938C4.89254 48.3891 4.94098 48.3891 6.34567 47.7109C7.70192 46.9844 7.75035 46.9844 7.75035 48.1469C7.75035 49.0672 8.04098 49.3578 9.4941 49.6484C11.5769 50.0359 11.7707 49.8422 12.5457 46.3063C12.9816 44.3687 13.4175 43.5938 14.4832 42.9641C15.2582 42.5281 15.9847 42.1406 16.13 42.1406C16.2754 42.1406 16.0816 43.1578 15.6941 44.4172C15.3066 45.6281 15.016 46.8875 15.016 47.2266C15.016 47.9531 18.5035 49.0672 18.891 48.4375C19.0363 48.1953 19.666 45.9672 20.2957 43.4484C21.4582 38.9438 21.5066 38.8953 23.7347 37.6359L25.9629 36.3766L27.5129 37.3938C28.8691 38.2656 29.0629 38.6047 29.0629 40.5906C29.0629 42.7703 28.9175 43.0125 25.3332 46.5969L21.555 50.375L23.1535 51.925L24.7035 53.475L26.8832 51.3438L29.0629 49.2125V50.8594C29.0629 52.2156 28.5785 52.9906 26.641 54.9766L24.2191 57.4469L25.6722 58.8516C27.0769 60.2078 27.1254 60.2078 28.0941 59.3359C29.0629 58.4641 29.0629 58.4641 29.0629 60.2078C29.0629 61.9516 29.1113 62 31.0004 62C32.8894 62 32.9379 61.9516 32.9379 60.2078C32.9379 58.4641 32.9379 58.4641 33.9066 59.3359C34.8754 60.2078 34.9238 60.2078 36.3285 58.8516L37.7816 57.4469L35.3597 54.9766C33.4222 52.9906 32.9379 52.2156 32.9379 50.8594V49.2125L35.1175 51.3438L37.2972 53.475L38.8472 51.925L40.4457 50.375L36.6675 46.5969C33.0832 43.0125 32.9379 42.7703 32.9379 40.5906C32.9379 38.6047 33.1316 38.2656 34.4879 37.3938L36.0379 36.3766L38.266 37.6359C40.4941 38.8953 40.5425 38.9438 41.705 43.4484C42.3347 45.9672 42.9644 48.1953 43.1097 48.4375C43.4972 49.0672 46.9847 47.9531 46.9847 47.2266C46.9847 46.8875 46.6941 45.6281 46.3066 44.4172C45.9191 43.1578 45.7254 42.1406 45.8707 42.1406C46.016 42.1406 46.7425 42.5281 47.5175 42.9641C48.5832 43.5938 49.0191 44.3687 49.455 46.3063C50.23 49.8422 50.4238 50.0359 52.5066 49.6C54.1535 49.3094 54.3472 49.1641 54.1535 47.9531L53.9597 46.6453L55.5097 47.5656L57.0597 48.4859L58.0769 46.6938C59.0941 44.9984 59.0941 44.9016 58.2707 44.2719C57.7863 43.9328 57.2535 43.5938 57.0597 43.5938C56.2847 43.5938 56.7207 42.625 57.4472 42.625C58.1254 42.625 58.1738 42.2859 57.9316 40.5906C57.7379 39.4766 57.5441 38.5078 57.4472 38.4109C57.3988 38.3625 55.8972 38.7016 54.2019 39.1859C51.441 39.9609 50.8597 40.0094 49.7457 39.3797C49.0191 39.0406 48.4379 38.5563 48.4379 38.3141C48.4379 38.1203 49.6004 37.6359 51.005 37.2969L53.6207 36.7156L53.1363 34.6328L52.6519 32.55L47.7113 33.9062L42.7222 35.2141L40.4941 34.0031C38.4597 32.8891 38.266 32.5984 38.266 31C38.266 29.4016 38.4597 29.1109 40.4941 27.9969L42.7222 26.7859L47.7113 28.0938L52.6519 29.45L53.1363 27.3672L53.6207 25.2844L51.005 24.7031C49.6004 24.3641 48.4379 23.8797 48.4379 23.6859C48.4379 23.4438 49.0191 22.9594 49.7457 22.6203C50.8597 21.9906 51.441 22.0391 54.2019 22.8141C55.8972 23.2984 57.3988 23.6375 57.4472 23.5891C57.5441 23.4922 57.7379 22.5234 57.9316 21.4094C58.1738 19.7141 58.1254 19.375 57.4472 19.375C56.7207 19.375 56.2847 18.4062 57.0597 18.4062C57.2535 18.4062 57.7863 18.0672 58.2707 17.7281C59.0941 17.0984 59.0941 17.0016 58.0769 15.3063L57.0597 13.5141L55.5097 14.4344L53.9597 15.3547L54.1535 14.0469C54.3472 12.8359 54.1535 12.6906 52.5066 12.4C50.4238 11.9641 50.23 12.1578 49.455 15.6938C49.0191 17.6313 48.5832 18.4062 47.5175 19.0359C46.7425 19.4719 46.016 19.8594 45.8707 19.8594C45.7254 19.8594 45.9191 18.8422 46.3066 17.5828C46.6941 16.3719 46.9847 15.1125 46.9847 14.7734C46.9847 14.0469 43.4972 12.9328 43.1097 13.5625C42.9644 13.8047 42.3347 16.0328 41.705 18.5516C40.5425 23.0563 40.4941 23.1047 38.266 24.3641L36.0379 25.6234L34.4879 24.6063C33.1316 23.7344 32.9379 23.3953 32.9379 21.4094C32.9379 19.2297 33.0832 18.9875 36.6675 15.4031L40.4457 11.625L38.8472 10.075L37.2972 8.525L35.1175 10.6562L32.9379 12.7875V11.1406C32.9379 9.78438 33.4222 9.00938 35.3597 7.02344L37.7816 4.55313L36.3285 3.14844C34.9238 1.79219 34.8754 1.79219 33.9066 2.66406C32.9379 3.53594 32.9379 3.53594 32.9379 1.79219C32.9379 0.048439 32.8894 0 31.0004 0C29.1113 0 29.0629 0.048439 29.0629 1.79219ZM32.4535 28.3359C33.7129 28.9656 33.9066 29.3531 33.9066 31C33.9066 32.6469 33.7129 33.0344 32.4535 33.6641C31.1457 34.3422 30.855 34.3422 29.5472 33.6641C28.2879 33.0344 28.0941 32.6469 28.0941 31C28.0941 29.4016 28.3363 28.9656 29.4504 28.3844C31.0972 27.4641 30.8066 27.4641 32.4535 28.3359Z"
        fill="#77BC43"
      />
    </svg>
  );
}

export function InsulationIcon(props: IconProps) {
  return (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_382_4816)">
        <path
          d="M45.4828 0.678127C42.0922 1.9375 39.8156 3.39062 37.6359 5.57031C35.3594 7.84688 32.4531 12.9328 32.4531 14.725C32.4531 15.3063 32.2594 15.9359 32.0656 16.2266C31.8719 16.5172 29.4016 16.7109 26.3984 16.7109C21.3609 16.7109 20.8766 16.8078 17.6797 18.3094C14.9672 19.6172 13.2719 20.9734 8.67031 25.575C1.11406 33.1797 0.242188 34.9234 0.242188 42.625C0.242188 47.8078 0.339063 48.3891 1.64688 51.1016C3.4875 54.8313 7.16875 58.5125 10.8984 60.3531C13.6109 61.6609 14.1922 61.7578 19.375 61.7578C27.125 61.7578 28.7719 60.9344 36.6188 53.0875C45.4828 44.2234 45.9672 42.6734 46.0156 24.1219V13.5625L53.9109 13.4656L61.7578 13.3203L61.9031 12.0125C62 11.2375 61.5641 9.78438 60.9828 8.71875L59.8688 6.73281L60.9828 4.69844C61.6125 3.58438 62 2.13125 61.9516 1.45312L61.7578 0.242188L54.4922 0.145313C49.4547 0.0968781 46.6938 0.242188 45.4828 0.678127ZM56.1875 4.31094C56.1875 4.60156 55.9938 4.94063 55.7031 5.08594C54.9766 5.52188 55.1219 7.41094 55.9938 8.62188L56.7203 9.6875H51.3438H45.9672L46.6938 8.33125C47.5656 6.68438 49.3094 5.0375 50.8594 4.40781C52.4094 3.77813 56.1875 3.72969 56.1875 4.31094ZM42.0922 8.33125C41.85 9.20312 41.6563 12.9328 41.6563 16.6141V23.3469L39.4281 21.3609C38.1688 20.2469 36.9578 19.375 36.7641 19.375C35.8922 19.375 36.3766 15.6453 37.5875 13.0781C38.5563 10.9953 41.8016 6.78125 42.4313 6.78125C42.5281 6.78125 42.3344 7.50781 42.0922 8.33125ZM32.2594 21.7484C35.3594 23.1531 38.8953 26.6406 40.3 29.7406C41.85 33.2281 41.8016 38.5078 40.2516 41.9953C38.8953 44.9984 35.2625 48.5828 32.0656 50.0359C28.9172 51.4406 23.4438 51.4406 20.2469 49.9875C17.0016 48.5344 13.8047 45.4344 12.2547 42.1891C10.5594 38.6531 10.4141 33.3734 11.9641 29.9828C13.8047 25.8172 17.6313 22.4266 21.9422 21.0219C24.6547 20.1016 29.3047 20.4406 32.2594 21.7484ZM8.57344 44.175C11.5281 50.4719 17.5344 54.5891 24.6063 55.1703L28.3359 55.4609L25.6719 56.6719C20.0047 59.1906 12.9328 57.8828 8.525 53.475C4.16563 49.0672 2.76094 41.85 5.27969 36.5703L6.44219 34.1484L6.82969 37.6359C7.02344 39.9125 7.65313 42.2375 8.57344 44.175Z"
          fill="#77BC43"
        />
        <path
          d="M22.3773 28.9173C18.7444 30.7095 17.2913 35.8923 19.3741 39.622C21.3601 43.2064 26.0585 44.611 29.8851 42.8189C35.0679 40.3485 35.4069 32.1142 30.4179 29.0626C28.4319 27.8517 24.6054 27.8032 22.3773 28.9173ZM28.6257 33.3735C30.4179 35.1657 30.4179 36.522 28.5773 38.3626C27.3663 39.5251 26.8335 39.7673 25.7679 39.4767C22.5226 38.7017 21.5054 35.1657 23.9273 33.0829C25.671 31.5814 26.8819 31.6782 28.6257 33.3735Z"
          fill="#77BC43"
        />
      </g>
      <defs>
        <clipPath id="clip0_382_4816">
          <rect width="62" height="62" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ArrowDownIcon({ color = "#FFFFFF", ...props }: IconProps) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.2513 18.1035V4.35352"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7754 12.5586L11.2534 18.1044L5.73047 12.5586"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const UserArrowDownIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 8L10 13L15 8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export function ToastWarningIcon(props: IconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="32" height="32" rx="16" fill="#FFF6B8" />
      <g clipPath="url(#clip0_879_4266)">
        <path
          d="M16 6C10.48 6 6 10.48 6 16C6 21.52 10.48 26 16 26C21.52 26 26 21.52 26 16C26 10.48 21.52 6 16 6ZM17 21H15V19H17V21ZM17 17H15V11H17V17Z"
          fill="#FFD21E"
        />
      </g>
      <defs>
        <clipPath id="clip0_879_4266">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function EnergyIcon({ color = "#000000", ...props }: IconProps) {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.5525 34.25C23.9275 34.25 27.6235 32.71 30.6405 29.63C33.6575 26.55 35.194 22.8295 35.25 18.4685V2.75H19.5368C15.1705 2.8025 11.4483 4.339 8.37 7.3595C5.29 10.3765 3.75 14.0725 3.75 18.4475C3.75 22.8225 5.2865 26.55 8.3595 29.63C11.4325 32.71 15.1626 34.25 19.5499 34.25M16.35 28.475L27.0259 18.9384L26.4064 17.1927L18.5209 16.4761L23.6659 9.4595L22.7156 8.39375L12.0896 17.9461L12.6593 19.7416L20.5448 20.4583L15.4365 27.4591L16.35 28.475ZM19.5525 36.875C17.2355 36.875 15.0533 36.4751 13.0058 35.6754C10.9583 34.8756 9.11463 33.7766 7.47488 32.3784L2.4375 37.4368L0.565876 35.5625L5.62425 30.5251C4.22425 28.8854 3.12437 27.0417 2.32463 24.9942C1.52487 22.9468 1.125 20.7654 1.125 18.4501C1.125 13.3349 2.91525 9.00187 6.49575 5.45112C10.0763 1.90037 14.425 0.125 19.542 0.125H37.875V18.4554C37.875 23.5741 36.0996 27.9229 32.5489 31.5016C28.9999 35.0839 24.6678 36.875 19.5525 36.875Z"
        fill={color}
      />
    </svg>
  );
}

export function EditCircleIcon(props: IconProps) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" fill="#fff" />
      <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#D9D9D9" />
      <path
        d="M29.5 17.5L30.5 18.5L20 29L16 30L17 26L27.5 15.5L29.5 17.5Z"
        stroke="#1976D2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27 15L30 18"
        stroke="#1976D2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 32H32"
        stroke="#1976D2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EditSquareIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.492 2.78906H7.753C4.678 2.78906 2.75 4.96606 2.75 8.04806V16.3621C2.75 19.4441 4.669 21.6211 7.753 21.6211H16.577C19.662 21.6211 21.581 19.4441 21.581 16.3621V12.3341"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.82666 10.9205L16.2997 3.4475C17.2307 2.5175 18.7397 2.5175 19.6707 3.4475L20.8877 4.6645C21.8187 5.5955 21.8187 7.1055 20.8877 8.0355L13.3787 15.5445C12.9717 15.9515 12.4197 16.1805 11.8437 16.1805H8.09766L8.19166 12.4005C8.20566 11.8445 8.43266 11.3145 8.82666 10.9205Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1641 4.60156L19.7301 9.16756"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function StarIcon({ color = "#D9D9D9", ...props }: IconProps) {
  return (
    <svg width="31" height="30" viewBox="0 0 31 30" {...props}>
      <path
        d="M15.2072 0.641955C15.2728 0.439895 15.5587 0.439895 15.6243 0.641955L19.1087 11.3659C19.1381 11.4563 19.2223 11.5174 19.3173 11.5174H30.5931C30.8056 11.5174 30.8939 11.7893 30.722 11.9142L21.5997 18.5419C21.5229 18.5978 21.4907 18.6968 21.5201 18.7871L25.0045 29.5111C25.0701 29.7131 24.8389 29.8812 24.667 29.7563L15.5447 23.1285C15.4678 23.0727 15.3637 23.0727 15.2868 23.1285L6.16451 29.7563C5.99263 29.8812 5.76136 29.7131 5.82701 29.5111L9.31143 18.7871C9.34079 18.6968 9.30863 18.5978 9.23176 18.5419L0.109437 11.9142C-0.0624453 11.7893 0.0258906 11.5174 0.238349 11.5174H11.5142C11.6092 11.5174 11.6934 11.4563 11.7227 11.3659L15.2072 0.641955Z"
        fill={color}
      />
    </svg>
  );
}

export function IncrementIcon(props: IconProps) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#DDDDDD" />
      <g clipPath="url(#clip0_1524_5375)">
        <path
          d="M14.25 21C14.25 21.1989 14.329 21.3897 14.4697 21.5303C14.6103 21.671 14.8011 21.75 15 21.75C15.1989 21.75 15.3897 21.671 15.5303 21.5303C15.671 21.3897 15.75 21.1989 15.75 21V15.75H21C21.1989 15.75 21.3897 15.671 21.5303 15.5303C21.671 15.3897 21.75 15.1989 21.75 15C21.75 14.8011 21.671 14.6103 21.5303 14.4697C21.3897 14.329 21.1989 14.25 21 14.25H15.75V9C15.75 8.80109 15.671 8.61032 15.5303 8.46967C15.3897 8.32902 15.1989 8.25 15 8.25C14.8011 8.25 14.6103 8.32902 14.4697 8.46967C14.329 8.61032 14.25 8.80109 14.25 9V14.25H9C8.80109 14.25 8.61032 14.329 8.46967 14.4697C8.32902 14.6103 8.25 14.8011 8.25 15C8.25 15.1989 8.32902 15.3897 8.46967 15.5303C8.61032 15.671 8.80109 15.75 9 15.75H14.25V21Z"
          fill="#09244B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1524_5375">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function InfoIcon({ color = "#130F26", ...props }: IconProps) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 3.4375C21.385 3.4375 26.5625 8.61375 26.5625 15C26.5625 21.385 21.385 26.5625 15 26.5625C8.61375 26.5625 3.4375 21.385 3.4375 15C3.4375 8.61375 8.61375 3.4375 15 3.4375Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9937 10.2559V15.7796"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9938 19.7441H15.0062"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function RetryIcon({ color = "#0083C3", ...props }: IconProps) {
  return (
    <svg
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.396 13C8.396 13.1989 8.31698 13.3897 8.17633 13.5303C8.03568 13.671 7.84491 13.75 7.646 13.75C3.854 13.75 0.75 10.745 0.75 7C0.75 3.255 3.854 0.25 7.646 0.25C10.751 0.25 13.395 2.265 14.251 5.051L14.854 4.031C14.9552 3.85967 15.1203 3.73555 15.313 3.68595C15.5057 3.63634 15.7102 3.66532 15.8815 3.7665C16.0528 3.86768 16.1769 4.03278 16.2266 4.22547C16.2762 4.41816 16.2472 4.62267 16.146 4.794L14.516 7.549C14.4162 7.718 14.2541 7.84115 14.0645 7.892C13.875 7.94285 13.673 7.91736 13.502 7.821L10.68 6.23C10.5942 6.18161 10.5187 6.11679 10.458 6.03924C10.3972 5.96169 10.3523 5.87293 10.3258 5.77803C10.2994 5.68312 10.2919 5.58394 10.3037 5.48613C10.3156 5.38833 10.3466 5.29382 10.395 5.208C10.4434 5.12218 10.5082 5.04673 10.5858 4.98597C10.6633 4.9252 10.7521 4.8803 10.847 4.85384C10.9419 4.82737 11.0411 4.81986 11.1389 4.83173C11.2367 4.84359 11.3312 4.87461 11.417 4.923L12.889 5.753C12.315 3.465 10.198 1.75 7.647 1.75C4.649 1.75 2.25 4.117 2.25 7C2.25 9.883 4.649 12.25 7.646 12.25C7.84491 12.25 8.03568 12.329 8.17633 12.4697C8.31698 12.6103 8.396 12.8011 8.396 13Z"
        fill={color}
      />
    </svg>
  );
}

export function WhatsappIcon({ color = "#25D366", ...props }: IconProps) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 25L1.75729 18.5802C0.672915 16.701 0.103125 14.5708 0.104166 12.3865C0.107291 5.55729 5.66457 0 12.4927 0C15.8062 0.00104167 18.9166 1.29167 21.2562 3.63333C23.5947 5.975 24.8822 9.0875 24.8812 12.3979C24.8781 19.2281 19.3208 24.7854 12.4927 24.7854C10.4198 24.7844 8.37706 24.2646 6.56769 23.2771L0 25ZM6.87186 21.0344C8.61769 22.0708 10.2844 22.6917 12.4885 22.6927C18.1635 22.6927 22.7864 18.074 22.7895 12.3958C22.7916 6.70625 18.1906 2.09375 12.4968 2.09167C6.81769 2.09167 2.19791 6.71042 2.19583 12.3875C2.19479 14.7052 2.87395 16.4406 4.01457 18.2562L2.97395 22.0562L6.87186 21.0344ZM18.7333 15.3427C18.6562 15.2135 18.45 15.1365 18.1395 14.9812C17.8302 14.826 16.3083 14.0771 16.0239 13.974C15.7406 13.8708 15.5343 13.8187 15.327 14.1292C15.1208 14.4385 14.5271 15.1365 14.3468 15.3427C14.1666 15.549 13.9854 15.575 13.676 15.4198C13.3666 15.2646 12.3687 14.9385 11.1864 13.8833C10.2666 13.0625 9.64477 12.049 9.46456 11.7385C9.28435 11.4292 9.44581 11.2615 9.59998 11.1073C9.73956 10.9688 9.90935 10.7458 10.0646 10.5646C10.2219 10.3854 10.2729 10.2563 10.3771 10.049C10.4802 9.84271 10.4291 9.66146 10.351 9.50625C10.2729 9.35208 9.65415 7.82812 9.39685 7.20833C9.14477 6.60521 8.88956 6.68646 8.69998 6.67708L8.10623 6.66667C7.89998 6.66667 7.56457 6.74375 7.28123 7.05417C6.9979 7.36458 6.1979 8.1125 6.1979 9.63646C6.1979 11.1604 7.30728 12.6323 7.46144 12.8385C7.61665 13.0448 9.64373 16.1719 12.7489 17.5125C13.4875 17.8312 14.0646 18.0219 14.5135 18.1646C15.2552 18.4 15.9302 18.3667 16.4635 18.2875C17.0583 18.199 18.2948 17.5385 18.5531 16.8156C18.8114 16.0917 18.8114 15.4719 18.7333 15.3427Z"
        fill={color}
      />
    </svg>
  );
}

export function CheckedIcon({ color = "#00953B", ...props }: IconProps) {
  return (
    <svg
      width="43"
      height="42"
      viewBox="0 0 43 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.6333 3.49902C31.2985 3.49902 39.1333 11.3338 39.1333 20.999C39.1333 30.6643 31.2985 38.499 21.6333 38.499C11.9681 38.499 4.1333 30.6643 4.1333 20.999C4.1333 11.3338 11.9681 3.49902 21.6333 3.49902ZM27.8195 14.6658L19.1571 23.3283L15.4471 19.6165C15.2846 19.4539 15.0917 19.3249 14.8793 19.2369C14.667 19.1489 14.4394 19.1035 14.2095 19.1034C13.7453 19.1033 13.3 19.2875 12.9717 19.6156C12.6433 19.9438 12.4587 20.3889 12.4586 20.8532C12.4584 21.3174 12.6427 21.7627 12.9708 22.091L17.7973 26.9175C17.9761 27.0964 18.1883 27.2382 18.4219 27.335C18.6555 27.4318 18.9059 27.4817 19.1588 27.4817C19.4117 27.4817 19.6621 27.4318 19.8957 27.335C20.1293 27.2382 20.3415 27.0964 20.5203 26.9175L30.2958 17.142C30.6242 16.8137 30.8086 16.3683 30.8086 15.9039C30.8086 15.4395 30.6242 14.9941 30.2958 14.6658C29.9674 14.3374 29.5221 14.1529 29.0577 14.1529C28.5933 14.1529 28.1479 14.3374 27.8195 14.6658Z"
        fill={color}
      />
      <path
        d="M21.6333 3.49902C31.2985 3.49902 39.1333 11.3338 39.1333 20.999C39.1333 30.6643 31.2985 38.499 21.6333 38.499C11.9681 38.499 4.1333 30.6643 4.1333 20.999C4.1333 11.3338 11.9681 3.49902 21.6333 3.49902ZM27.8195 14.6658L19.1571 23.3283L15.4471 19.6165C15.2846 19.4539 15.0917 19.3249 14.8793 19.2369C14.667 19.1489 14.4394 19.1035 14.2095 19.1034C13.7453 19.1033 13.3 19.2875 12.9717 19.6156C12.6433 19.9438 12.4587 20.3889 12.4586 20.8532C12.4584 21.3174 12.6427 21.7627 12.9708 22.091L17.7973 26.9175C17.9761 27.0964 18.1883 27.2382 18.4219 27.335C18.6555 27.4318 18.9059 27.4817 19.1588 27.4817C19.4117 27.4817 19.6621 27.4318 19.8957 27.335C20.1293 27.2382 20.3415 27.0964 20.5203 26.9175L30.2958 17.142C30.6242 16.8137 30.8086 16.3683 30.8086 15.9039C30.8086 15.4395 30.6242 14.9941 30.2958 14.6658C29.9674 14.3374 29.5221 14.1529 29.0577 14.1529C28.5933 14.1529 28.1479 14.3374 27.8195 14.6658Z"
        fill={color}
      />
    </svg>
  );
}

export function NavIcon({ color = "#08080C", ...props }: IconProps) {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 1.5C11 0.947716 10.5523 0.5 10 0.5L1 0.5C0.447715 0.5 -1.50195e-07 0.947715 -1.50195e-07 1.5C1.83919e-08 2.05229 0.447715 2.5 1 2.5H9V10.5C9 11.0523 9.44771 11.5 10 11.5C10.5523 11.5 11 11.0523 11 10.5L11 1.5ZM3.70711 9.20711L10.7071 2.20711L9.29289 0.792893L2.29289 7.79289L3.70711 9.20711Z"
        fill={color}
      />
    </svg>
  );
}

export function InvertIcon({ color = "#505050", ...props }: IconProps) {
  return (
    <svg
      width="38"
      height="46"
      viewBox="0 0 38 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M33.1992 7H37.1992"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M33.1992 13H37.1992"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M33.1992 19H37.1992"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M33.1992 25H37.1992"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M30.1992 33.81V4C30.1992 2.34 28.8592 1 27.1992 1C25.5392 1 24.1992 2.34 24.1992 4V33.81C22.4092 34.85 21.1992 36.78 21.1992 39C21.1992 42.31 23.8892 45 27.1992 45C30.5092 45 33.1992 42.31 33.1992 39C33.1992 36.78 31.9892 34.85 30.1992 33.81Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M13.1992 18V10H17.1992L10.1992 3L3.19922 10H7.19922V18"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M13.1992 20V28H17.1992L10.1992 35L3.19922 28H7.19922V20"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function ConverageIcon({ color = "#505050", ...props }: IconProps) {
  return (
    <svg
      width="44"
      height="46"
      viewBox="0 0 44 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.01562 10.5V41.5C1.01562 43.08 2.43562 44.5 4.01562 44.5C5.59563 44.5 7.01562 43.08 7.01562 41.5V10.5"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M9.01562 7.5H40.1056C41.6856 7.5 42.9756 6.08 42.9756 4.5C42.9756 2.92 41.6956 1.5 40.1056 1.5H9.01562"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M21.0156 38.5V43L12.0156 36L21.0156 29V32.5H23.0156C27.9856 32.5 32.0156 28.47 32.0156 23.5C32.0156 23.5 32.0156 21.46 32.0156 21.5H28.0156L35.0156 12.5L42.0156 21.5H38.0156V23.5C38.0156 31.78 31.2956 38.5 23.0156 38.5H21.0156Z"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function GoldFinsIcon({ color = "#505050", ...props }: IconProps) {
  return (
    <svg
      width="68"
      height="31"
      viewBox="0 0 68 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M61.9115 29.136H57.724H10.2656H6.07813L1.89062 19.5906V1.86328H66.099V19.5906L61.9115 29.136Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M8.86914 23.6816H59.1191"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M6.07812 19.5918H61.9115"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M6.07812 15.5H61.9115"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M6.07812 11.4082H61.9115"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M6.07812 7.31836H61.9115"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function WifiIcon({ color = "#505050", ...props }: IconProps) {
  return (
    <svg
      width="50"
      height="37"
      viewBox="0 0 50 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M30.4718 30.7012L26.1125 34.9996C25.4989 35.6046 24.5018 35.6046 23.8881 34.9996L19.5289 30.7012C18.8258 30.008 18.9408 28.8483 19.7846 28.3063C21.2803 27.3231 23.0828 26.7559 25.0131 26.7559C26.9435 26.7559 28.746 27.3231 30.2417 28.3063C31.0726 28.8483 31.2004 30.008 30.4973 30.7012H30.4718Z"
        stroke={color}
        strokeWidth="1.66"
        strokeMiterlimit="10"
      />
      <path
        d="M33.6802 15.8285C30.9317 14.6814 28.0042 14.1016 24.9872 14.1016C21.9703 14.1016 19.0556 14.6814 16.2943 15.8285C14.6964 16.4965 13.2007 17.3285 11.8072 18.3369C10.3371 19.3957 10.1837 21.5259 11.4876 22.799C12.5231 23.8201 14.1722 23.9587 15.3611 23.1016C16.371 22.3705 17.4704 21.7654 18.6337 21.2738C20.6408 20.4293 22.7757 20.0133 24.9872 20.0133C27.1988 20.0133 29.3337 20.4419 31.3408 21.2738C32.5041 21.7654 33.5907 22.3705 34.6134 23.1016C35.8023 23.9587 37.4514 23.8201 38.4869 22.799C39.778 21.5259 39.6374 19.4083 38.1673 18.3369C36.7866 17.3411 35.2781 16.4965 33.6802 15.8285Z"
        stroke={color}
        strokeWidth="1.66"
        strokeMiterlimit="10"
      />
      <path
        d="M38.6401 4.26956C34.3192 2.46704 29.7298 1.54688 24.9999 1.54688C20.2699 1.54688 15.6805 2.46704 11.3596 4.26956C8.18926 5.59309 5.26179 7.34519 2.64113 9.50066C1.28605 10.6099 1.19657 12.6393 2.44937 13.862C3.54877 14.946 5.30014 15.0091 6.50181 14.0385C8.67504 12.2612 11.0912 10.8116 13.7118 9.71494C17.2913 8.22755 21.1008 7.47125 25.0126 7.47125C28.9245 7.47125 32.734 8.22755 36.3134 9.71494C38.9341 10.8116 41.3502 12.2486 43.5235 14.0385C44.7251 15.0217 46.4765 14.946 47.5759 13.862C48.8159 12.6393 48.7392 10.6099 47.3841 9.50066C44.7507 7.34519 41.8232 5.59309 38.6657 4.26956H38.6401Z"
        stroke={color}
        strokeWidth="1.66"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function AntiBacticalFilterIcon({
  color = "#505050",
  ...props
}: IconProps) {
  return (
    <svg
      width="44"
      height="46"
      viewBox="0 0 44 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M42.8407 22.4456C42.4907 20.4356 41.8107 18.4656 40.8007 16.6256C38.0507 11.5656 33.1607 8.03563 27.5107 6.98563L28.3607 2.26562L16.7207 8.20562L25.5407 17.8556L26.3307 13.4956C30.0207 14.1856 33.2007 16.4956 35.0007 19.7856C35.6507 20.9856 36.1007 22.2756 36.3307 23.5856"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M17.5 43.3839C21.22 44.7339 25.31 44.9139 29.2 43.8239C32.9 42.7839 36.15 40.6639 38.58 37.7939L42.1 40.8039L42.83 27.7539L30.05 30.5139L33.55 33.5039C31.96 35.3839 29.83 36.7739 27.4 37.4539C24.86 38.1739 22.18 38.0539 19.75 37.1639"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M11.7505 11.1348C6.04055 15.9548 3.21055 24.0148 6.00055 32.0248L2.31055 33.3348L12.7805 40.1448L16.5705 28.2448L12.2305 29.7948C10.4405 24.5748 12.2905 19.3248 16.0105 16.1848"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function ZamilIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="255"
      height="47"
      viewBox="0 0 255 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 46.3363V39.2342L21.2815 11.4353H0V2.3457H35.5677V9.50079L14.2863 37.2202H35.5677V46.3098H0V46.3363Z"
        fill="#004987"
      />
      <path
        d="M70.5436 46.3374H60.5083L60.1585 43.0778C58.0062 45.6749 54.9121 46.9999 50.8765 46.9999C46.6256 46.9999 43.128 45.4629 40.3837 42.4153C37.6126 39.2883 36.2673 35.4457 36.2673 30.8082C36.2673 26.1706 37.6126 22.3281 40.3837 19.201C43.1549 16.074 46.6525 14.5635 50.8765 14.5635C55.1005 14.5635 58.0062 15.8885 60.1585 18.5385L60.5083 15.226H70.5436V46.3374ZM48.4551 25.6406C47.1636 26.9656 46.5718 28.6882 46.5718 30.8082C46.5718 32.9282 47.1906 34.6507 48.4551 35.9758C49.7465 37.3008 51.3608 37.9633 53.2979 37.9633C57.3336 37.9633 60.1585 35.0482 60.1585 30.8082C60.1585 26.5681 57.3874 23.7061 53.3517 23.6531C51.3338 23.6531 49.7196 24.3156 48.4282 25.6406H48.4551Z"
        fill="#004987"
      />
      <path
        d="M118.488 46.3374V29.0327C118.488 25.7731 116.066 23.9181 113.295 23.9181C110.389 23.9181 107.968 25.8526 107.968 29.0327V46.3374H97.6097V29.0327C97.6097 25.8526 95.1883 23.9181 92.4171 23.9181C89.6459 23.9181 87.1707 25.8526 87.1707 29.0327V46.3374H76.8125V15.226H86.3098L86.6326 18.5385C88.785 15.8885 92.4171 14.5635 96.399 14.5635C100.784 14.5635 104.739 16.4185 106.354 19.8105C108.775 16.3655 112.757 14.5635 116.981 14.5635C123.115 14.5635 128.765 18.5385 128.765 26.1176V46.3374H118.461H118.488Z"
        fill="#004987"
      />
      <path
        d="M134.306 5.6598C134.306 2.40026 136.539 0.0947266 139.956 0.0947266C143.373 0.0947266 145.687 2.42676 145.687 5.6598C145.687 8.89284 143.265 11.2249 139.956 11.2249C136.647 11.2249 134.306 8.89284 134.306 5.6598ZM145.149 15.1999V46.3113H134.79V15.1999H145.149Z"
        fill="#004987"
      />
      <path
        d="M161.775 0.755859V46.3364H151.417V0.755859H161.775Z"
        fill="#004987"
      />
      <path
        d="M201.809 37.169H179.29L175.684 46.3381H168.312L186.715 2.37402H194.275L212.705 46.3381H205.333L201.782 37.169H201.809ZM181.2 31.4979H199.737L190.536 9.97962L181.2 31.4979Z"
        fill="#00953B"
      />
      <path
        d="M255 44.0556C252.579 45.1156 248.462 46.9441 240.633 46.9441C225.459 46.9441 215.074 37.7485 215.074 24.3128C215.074 10.8771 225.405 1.70801 240.552 1.70801C246.525 1.70801 251.933 3.29803 254.462 4.49054L253.762 10.9036C251.368 9.76411 246.498 8.17409 240.552 8.17409C229.817 8.17409 222.499 14.7197 222.499 24.2863C222.499 33.8529 230.194 40.5045 241.386 40.5045C246.687 40.5045 251.368 39.047 254.005 37.5895L255 44.0291V44.0556Z"
        fill="#00953B"
      />
    </svg>
  );
}

export function ResearchIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="28"
      height="27"
      viewBox="0 0 28 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5435 20.9183L26.2918 25.6667M24.7917 12.5625C24.7917 15.6291 23.5736 18.57 21.4052 20.7384C19.2368 22.9068 16.2958 24.125 13.2292 24.125C10.1627 24.125 7.22172 22.9068 5.05333 20.7384C2.88494 18.57 1.66675 15.6291 1.66675 12.5625C1.66675 9.49594 2.88494 6.55497 5.05333 4.38658C7.22172 2.21819 10.1627 1 13.2292 1C16.2958 1 19.2368 2.21819 21.4052 4.38658C23.5736 6.55497 24.7917 9.49594 24.7917 12.5625Z"
        stroke="#080808"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CartIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.113 28.4375H9.87553C7.72553 28.4375 6.11303 27.8625 5.11303 26.725C4.11303 25.5875 3.72552 23.9375 3.98802 21.8L5.11303 12.425C5.43803 9.6625 6.13803 7.1875 11.013 7.1875H20.013C24.8755 7.1875 25.5755 9.6625 25.913 12.425L27.038 21.8C27.288 23.9375 26.913 25.6 25.913 26.725C24.8755 27.8625 23.2755 28.4375 21.113 28.4375ZM11.0005 9.0625C7.40052 9.0625 7.22553 10.4875 6.96303 12.6375L5.83803 22.0125C5.65053 23.6 5.87553 24.7625 6.51303 25.475C7.15053 26.1875 8.27553 26.55 9.87553 26.55H21.113C22.713 26.55 23.838 26.1875 24.4755 25.475C25.113 24.7625 25.338 23.6 25.1505 22.0125L24.0255 12.6375C23.763 10.475 23.6005 9.0625 19.988 9.0625H11.0005Z"
        fill="currentColor"
      />
      <path
        d="M20.5 10.9375C19.9875 10.9375 19.5625 10.5125 19.5625 10V5.625C19.5625 4.275 18.725 3.4375 17.375 3.4375H13.625C12.275 3.4375 11.4375 4.275 11.4375 5.625V10C11.4375 10.5125 11.0125 10.9375 10.5 10.9375C9.9875 10.9375 9.5625 10.5125 9.5625 10V5.625C9.5625 3.2375 11.2375 1.5625 13.625 1.5625H17.375C19.7625 1.5625 21.4375 3.2375 21.4375 5.625V10C21.4375 10.5125 21.0125 10.9375 20.5 10.9375Z"
        fill="currentColor"
      />
      <path
        d="M26.0125 22.2256H10.5C9.9875 22.2256 9.5625 21.8006 9.5625 21.2881C9.5625 20.7756 9.9875 20.3506 10.5 20.3506H26.0125C26.525 20.3506 26.95 20.7756 26.95 21.2881C26.95 21.8006 26.525 22.2256 26.0125 22.2256Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function EnjoyIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="37"
      height="38"
      viewBox="0 0 37 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 32.2083C25.3119 32.2083 30.8333 26.6869 30.8333 19.875C30.8333 13.0631 25.3119 7.54167 18.5 7.54167C11.6881 7.54167 6.16667 13.0631 6.16667 19.875C6.16667 26.6869 11.6881 32.2083 18.5 32.2083ZM18.5 33.75C26.1629 33.75 32.375 27.5379 32.375 19.875C32.375 12.2121 26.1629 6 18.5 6C10.8371 6 4.625 12.2121 4.625 19.875C4.625 27.5379 10.8371 33.75 18.5 33.75Z"
        fill="#080808"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8691 22.9587C14.0677 25.9125 16.2762 27.5837 18.5 27.5837C20.7247 27.5837 22.9323 25.9125 24.131 22.9587H12.8691ZM18.5 29.1253C15.3874 29.1253 12.6895 26.7758 11.3637 23.3441L11.3251 23.2446C10.9813 22.3266 11.7167 21.417 12.698 21.417H24.3029C25.2841 21.417 26.0203 22.3266 25.675 23.2446L25.6372 23.3441C24.3106 26.7758 21.6127 29.1253 18.5 29.1253Z"
        fill="#080808"
      />
      <path
        d="M16.4202 18.6741C16.5205 18.3982 16.4904 18.0613 16.4079 17.7545C16.3082 17.4014 16.1492 17.0677 15.9377 16.7679C15.4899 16.1289 14.7475 15.5422 13.7447 15.4991C12.7064 15.4559 11.9309 16.115 11.453 16.8141C11.2238 17.1509 11.0435 17.5183 10.9173 17.9056C10.807 18.2494 10.7485 18.6009 10.787 18.8823C10.7959 18.9464 10.8207 19.0073 10.8593 19.0593C10.8979 19.1113 10.949 19.1527 11.0079 19.1798C11.0667 19.2068 11.1314 19.2186 11.196 19.214C11.2606 19.2094 11.323 19.1887 11.3775 19.1536C11.6858 18.9563 12.0088 18.6857 12.3079 18.436C12.4435 18.3219 12.5753 18.2124 12.6971 18.1161C13.1303 17.7738 13.468 17.5788 13.747 17.5649C14.0129 17.5518 14.3197 17.7037 14.7067 17.9935C14.8454 18.0968 14.9796 18.2062 15.1183 18.3203L15.2686 18.4429C15.4567 18.5947 15.6571 18.7505 15.8591 18.8722C15.9078 18.9016 15.9624 18.9199 16.019 18.9256C16.0756 18.9314 16.1328 18.9246 16.1864 18.9056C16.2401 18.8867 16.2889 18.8561 16.3293 18.8161C16.3697 18.7761 16.4008 18.7276 16.4202 18.6741ZM20.5141 18.6741C20.4139 18.3982 20.4448 18.0613 20.5272 17.7545C20.6136 17.4339 20.7731 17.0893 20.9975 16.7679C21.4445 16.1289 22.1876 15.5422 23.1905 15.4991C24.228 15.4559 25.0042 16.115 25.4822 16.8141C25.7242 17.1687 25.9046 17.5526 26.0179 17.9056C26.1274 18.2494 26.1859 18.6009 26.1474 18.8823C26.1385 18.9463 26.1136 19.0071 26.075 19.059C26.0365 19.1108 25.9855 19.1522 25.9268 19.1792C25.868 19.2063 25.8035 19.2181 25.739 19.2136C25.6745 19.2091 25.6121 19.1885 25.5577 19.1536C25.2494 18.9563 24.9256 18.6857 24.6273 18.436C24.499 18.3276 24.3692 18.221 24.238 18.1161C23.8041 17.7738 23.4672 17.5788 23.1874 17.5649C22.9222 17.5518 22.6147 17.7037 22.2285 17.9935C22.0897 18.0968 21.9556 18.2062 21.8169 18.3203L21.6658 18.4429C21.4791 18.5991 21.2821 18.7426 21.0761 18.8722C21.0273 18.9018 20.9727 18.9201 20.916 18.926C20.8593 18.9318 20.802 18.925 20.7483 18.9061C20.6945 18.8871 20.6457 18.8565 20.6052 18.8164C20.5647 18.7763 20.5336 18.7277 20.5141 18.6741Z"
        fill="#080808"
      />
    </svg>
  );
}

export function RadioIcon({
  checked = false,
  className,
  checkedColor = "#00953b",
  uncheckedColor = "#E0E0E0",
  iconProps,
}: {
  className?: string;
  checked?: boolean;
  checkedColor?: string;
  uncheckedColor?: string;
  iconProps?: IconProps;
}) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(
        "shrink-0 cursor-pointer transition-colors duration-200",
        className,
      )}
      {...iconProps}
    >
      <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="17"
        height="17"
        rx="8.5"
        stroke={checked ? checkedColor : uncheckedColor}
        className="transition-colors duration-200"
      />
      <circle
        cx="9"
        cy="9"
        r="5"
        className="transition-colors duration-200"
        fill={checked ? checkedColor : "transparent"}
      />
    </svg>
  );
}

export function NoProductsInCartIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="212"
      height="206"
      viewBox="0 0 212 206"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_693_5059)">
        <path
          d="M140.791 79.5396C126.984 79.5396 112.93 78.9808 99.7831 75.332C86.8836 71.7653 75.0399 64.8458 64.4828 56.8414C57.5712 51.6312 51.2864 47.4728 42.3129 48.0974C33.5341 48.5707 25.1392 51.8371 18.3615 57.4167C6.94668 67.3769 8.66221 85.8346 13.2314 98.7534C20.0936 118.263 40.9768 131.856 58.7259 140.649C79.2297 150.856 101.763 156.789 124.345 160.191C144.139 163.199 169.575 165.369 186.731 152.499C202.484 140.649 206.806 113.628 202.946 95.384C202.009 89.9943 199.129 85.1313 194.846 81.7092C183.778 73.6391 167.266 79.0301 154.828 79.2931C150.21 79.3917 145.508 79.5067 140.791 79.5396Z"
          fill="#F2F2F2"
        />
        <path
          d="M107.668 192.176C141.112 192.176 168.223 190.491 168.223 188.412C168.223 186.334 141.112 184.648 107.668 184.648C74.2246 184.648 47.1133 186.334 47.1133 188.412C47.1133 190.491 74.2246 192.176 107.668 192.176Z"
          fill="#F2F2F2"
        />
        <path
          d="M22.2217 43.2978L43.6658 41.4898C46.3398 41.2565 49.0131 41.9455 51.2383 43.4415C53.4634 44.9376 55.1052 47.1498 55.8889 49.7078L76.4422 118.246L72.4173 125.429C71.3835 127.279 70.8732 129.375 70.9407 131.492C71.0082 133.609 71.6511 135.668 72.8007 137.449C73.9503 139.231 75.5637 140.668 77.4687 141.608C79.3737 142.548 81.4989 142.954 83.6177 142.785L165.93 135.816"
          stroke="#BABABA"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M58.957 60.1114L154.631 52.0249C155.573 51.9444 156.522 52.0764 157.406 52.4111C158.29 52.7457 159.088 53.2745 159.739 53.9581C160.39 54.6417 160.878 55.4626 161.168 56.36C161.457 57.2573 161.54 58.2081 161.41 59.1417L154.928 105.771C154.731 107.17 154.067 108.462 153.044 109.44C152.021 110.418 150.697 111.024 149.286 111.162L76.4422 118.246L58.957 60.1114Z"
          fill="white"
          stroke="#BABABA"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M92.7723 158.498C97.0632 158.498 100.542 155.032 100.542 150.757C100.542 146.482 97.0632 143.016 92.7723 143.016C88.4814 143.016 85.0029 146.482 85.0029 150.757C85.0029 155.032 88.4814 158.498 92.7723 158.498Z"
          fill="white"
          stroke="#BABABA"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M146.878 153.928C151.169 153.928 154.647 150.462 154.647 146.187C154.647 141.911 151.169 138.445 146.878 138.445C142.587 138.445 139.108 141.911 139.108 146.187C139.108 150.462 142.587 153.928 146.878 153.928Z"
          fill="white"
          stroke="#BABABA"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.2024 39.6397L18.9857 41.349C17.2337 41.4971 15.934 43.0323 16.0826 44.778C16.2313 46.5237 17.7721 47.8187 19.524 47.6706L39.7408 45.9614C41.4928 45.8132 42.7925 44.278 42.6438 42.5324C42.4952 40.7867 40.9544 39.4916 39.2024 39.6397Z"
          fill="#D2D2D2"
        />
        <path
          d="M99.2393 96.1225C99.6338 93.1228 101.046 90.3477 103.241 88.2573C105.435 86.167 108.282 84.8872 111.307 84.63C114.332 84.3729 117.355 85.154 119.873 86.8437C122.392 88.5335 124.255 91.0303 125.154 93.9201"
          stroke="#BABABA"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M125.368 78.3887C126.388 78.3887 127.215 77.5645 127.215 76.5479C127.215 75.5312 126.388 74.707 125.368 74.707C124.348 74.707 123.521 75.5312 123.521 76.5479C123.521 77.5645 124.348 78.3887 125.368 78.3887Z"
          fill="#BABABA"
        />
        <path
          d="M96.0887 80.8536C97.109 80.8536 97.9362 80.0294 97.9362 79.0127C97.9362 77.996 97.109 77.1719 96.0887 77.1719C95.0684 77.1719 94.2412 77.996 94.2412 79.0127C94.2412 80.0294 95.0684 80.8536 96.0887 80.8536Z"
          fill="#BABABA"
        />
        <path
          d="M44.0449 148.473V155.557"
          stroke="#BABABA"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.499 152.006H47.5921"
          stroke="#BABABA"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M157.386 16.7871V23.8546"
          stroke="#BABABA"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M153.839 20.3203H160.932"
          stroke="#BABABA"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M73.4072 37.9062V44.9738"
          stroke="#BABABA"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M69.8438 41.4414H76.9533"
          stroke="#BABABA"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M175.085 63.892C176.014 63.892 176.767 63.1414 176.767 62.2155C176.767 61.2896 176.014 60.5391 175.085 60.5391C174.156 60.5391 173.402 61.2896 173.402 62.2155C173.402 63.1414 174.156 63.892 175.085 63.892Z"
          fill="white"
          stroke="#BABABA"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M112.204 48.8211C113.097 48.8211 113.821 48.0999 113.821 47.2103C113.821 46.3208 113.097 45.5996 112.204 45.5996C111.312 45.5996 110.588 46.3208 110.588 47.2103C110.588 48.0999 111.312 48.8211 112.204 48.8211Z"
          fill="#CFCFCF"
        />
        <path
          d="M123.058 165.714C123.951 165.714 124.675 164.993 124.675 164.103C124.675 163.213 123.951 162.492 123.058 162.492C122.165 162.492 121.441 163.213 121.441 164.103C121.441 164.993 122.165 165.714 123.058 165.714Z"
          fill="#CFCFCF"
        />
      </g>
      <defs>
        <clipPath id="clip0_693_5059">
          <rect
            width="211"
            height="206"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function NoProductsFoundIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="338"
      height="286"
      viewBox="0 0 338 286"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M220.969 146.124C197.691 146.124 173.995 145.182 151.829 139.029C130.08 133.015 110.111 121.347 92.3112 107.85C80.658 99.0638 70.0616 92.0518 54.9319 93.105C40.1306 93.9031 25.9764 99.4111 14.549 108.82C-4.69686 125.615 -1.80442 156.739 5.89949 178.524C17.4693 211.422 52.6792 234.343 82.6048 249.17C117.175 266.382 155.166 276.387 193.241 282.124C226.615 287.196 269.501 290.854 298.425 269.153C324.986 249.17 332.273 203.606 325.765 172.842C324.186 163.754 319.329 155.553 312.109 149.783C293.447 136.175 265.607 145.265 244.637 145.709C236.85 145.875 228.923 146.069 220.969 146.124Z"
        fill="#E4E4E4"
      />
      <g filter="url(#filter0_f_703_5199)">
        <rect
          x="82.0327"
          y="235.32"
          width="163.371"
          height="15.84"
          fill="#1B3554"
        />
      </g>
      <rect
        x="83.3502"
        y="18.8418"
        width="163.371"
        height="104.28"
        fill="#E4E4E4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.3502 18.8418V177.242H57V81.4582L70.1772 61.1959L83.3502 18.8418Z"
        fill="#CACBCB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M245.404 18.8418V177.242H271.754V81.4582L258.577 61.1959L245.404 18.8418Z"
        fill="#CACBCB"
      />
      <path
        d="M57 80.8809H271.754V262.001C271.754 264.763 269.515 267.001 266.754 267.001H62C59.2386 267.001 57 264.763 57 262.001V80.8809Z"
        fill="white"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.558 153.667C121.558 154.589 122.031 155.447 122.85 155.871C124.673 156.815 128.157 158.348 131.542 158.348C134.925 158.348 138.309 156.816 140.072 155.872C140.867 155.447 141.32 154.606 141.32 153.705C141.32 151.58 138.872 150.187 136.872 150.907C135.271 151.484 133.389 151.951 131.492 151.951C129.557 151.951 127.622 151.465 125.981 150.873C123.985 150.152 121.558 151.545 121.558 153.667Z"
        fill="#828282"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M188.751 153.667C188.751 154.589 189.224 155.447 190.043 155.871C191.866 156.815 195.349 158.348 198.735 158.348C202.118 158.348 205.502 156.816 207.265 155.872C208.06 155.447 208.513 154.606 208.513 153.705C208.513 151.58 206.064 150.187 204.065 150.907C202.464 151.484 200.582 151.951 198.685 151.951C196.75 151.951 194.815 151.465 193.174 150.873C191.178 150.152 188.751 151.545 188.751 153.667Z"
        fill="#828282"
      />
      <ellipse
        opacity="0.5"
        cx="165.036"
        cy="181.203"
        rx="21.0801"
        ry="9.24402"
        fill="#828282"
      />
      <ellipse
        opacity="0.149343"
        cx="116.288"
        cy="100.68"
        rx="7.90504"
        ry="7.92001"
        fill="#1B3554"
      />
      <ellipse
        opacity="0.149343"
        cx="212.466"
        cy="100.68"
        rx="7.90504"
        ry="7.92001"
        fill="#1B3554"
      />
      <path
        d="M116.288 100.274V51.1801C116.288 24.571 137.818 3 164.377 3C190.936 3 212.466 24.571 212.466 51.1801V100.274"
        stroke="#939393"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M333.235 213.143V221.468"
        stroke="#CFCFCF"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M329.07 217.305H337.4"
        stroke="#CFCFCF"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M273.898 55.7948C274.947 55.7948 275.797 54.9453 275.797 53.8974C275.797 52.8495 274.947 52 273.898 52C272.85 52 272 52.8495 272 53.8974C272 54.9453 272.85 55.7948 273.898 55.7948Z"
        fill="#CFCFCF"
      />
      <defs>
        <filter
          id="filter0_f_703_5199"
          x="57.8457"
          y="211.133"
          width="211.745"
          height="64.2137"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="12.0935"
            result="effect1_foregroundBlur_703_5199"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function CheckBadgeIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.37988 12.0001L10.7899 14.4201L15.6199 9.58008"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7499 2.45031C11.4399 1.86031 12.5699 1.86031 13.2699 2.45031L14.8499 3.81031C15.1499 4.07031 15.7099 4.28031 16.1099 4.28031H17.8099C18.8699 4.28031 19.7399 5.15031 19.7399 6.21031V7.91031C19.7399 8.30031 19.9499 8.87031 20.2099 9.17031L21.5699 10.7503C22.1599 11.4403 22.1599 12.5703 21.5699 13.2703L20.2099 14.8503C19.9499 15.1503 19.7399 15.7103 19.7399 16.1103V17.8103C19.7399 18.8703 18.8699 19.7403 17.8099 19.7403H16.1099C15.7199 19.7403 15.1499 19.9503 14.8499 20.2103L13.2699 21.5703C12.5799 22.1603 11.4499 22.1603 10.7499 21.5703L9.16988 20.2103C8.86988 19.9503 8.30988 19.7403 7.90988 19.7403H6.17988C5.11988 19.7403 4.24988 18.8703 4.24988 17.8103V16.1003C4.24988 15.7103 4.03988 15.1503 3.78988 14.8503L2.43988 13.2603C1.85988 12.5703 1.85988 11.4503 2.43988 10.7603L3.78988 9.17031C4.03988 8.87031 4.24988 8.31031 4.24988 7.92031V6.20031C4.24988 5.14031 5.11988 4.27031 6.17988 4.27031H7.90988C8.29988 4.27031 8.86988 4.06031 9.16988 3.80031L10.7499 2.45031Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function GreyPlusIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 8.49805H8V14.498H6V8.49805H0V6.49805H6V0.498047H8V6.49805H14V8.49805Z"
        fill="black"
      />
    </svg>
  );
}

export function ColoredDoneIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4998 0.989258C31.3157 0.989258 40.0832 9.75672 40.0832 20.5726C40.0832 31.3885 31.3157 40.1559 20.4998 40.1559C9.68396 40.1559 0.916504 31.3885 0.916504 20.5726C0.916504 9.75672 9.68396 0.989258 20.4998 0.989258ZM27.4225 13.4854L17.7288 23.1791L13.5771 19.0255C13.3953 18.8436 13.1794 18.6992 12.9418 18.6007C12.7042 18.5022 12.4495 18.4514 12.1923 18.4513C11.6728 18.4511 11.1745 18.6573 10.8071 19.0245C10.4396 19.3917 10.2331 19.8899 10.2329 20.4094C10.2327 20.9288 10.4389 21.4271 10.8061 21.7946L16.2072 27.1957C16.4072 27.3958 16.6447 27.5546 16.9062 27.6629C17.1676 27.7712 17.4478 27.827 17.7308 27.827C18.0137 27.827 18.2939 27.7712 18.5554 27.6629C18.8168 27.5546 19.0543 27.3958 19.2543 27.1957L30.1936 16.2564C30.5611 15.889 30.7675 15.3906 30.7675 14.8709C30.7675 14.3512 30.5611 13.8528 30.1936 13.4854C29.8261 13.1179 29.3277 12.9115 28.8081 12.9115C28.2884 12.9115 27.79 13.1179 27.4225 13.4854Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CheckCircleIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="43"
      height="42"
      viewBox="0 0 43 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.1"
        cx="21.6328"
        cy="20.999"
        r="19.432"
        fill="#F9CB6F"
        stroke="#F9CB6F"
        strokeWidth="3.13606"
      />
      <path
        d="M21.6333 3.49902C31.2985 3.49902 39.1333 11.3338 39.1333 20.999C39.1333 30.6643 31.2985 38.499 21.6333 38.499C11.9681 38.499 4.1333 30.6643 4.1333 20.999C4.1333 11.3338 11.9681 3.49902 21.6333 3.49902ZM27.8195 14.6658L19.1571 23.3283L15.4471 19.6165C15.2846 19.4539 15.0917 19.3249 14.8793 19.2369C14.667 19.1489 14.4394 19.1035 14.2095 19.1034C13.7453 19.1033 13.3 19.2875 12.9717 19.6156C12.6433 19.9438 12.4587 20.3889 12.4586 20.8532C12.4584 21.3174 12.6427 21.7627 12.9708 22.091L17.7973 26.9175C17.9761 27.0964 18.1883 27.2382 18.4219 27.335C18.6555 27.4318 18.9059 27.4817 19.1588 27.4817C19.4117 27.4817 19.6621 27.4318 19.8957 27.335C20.1293 27.2382 20.3415 27.0964 20.5203 26.9175L30.2958 17.142C30.6242 16.8137 30.8086 16.3683 30.8086 15.9039C30.8086 15.4395 30.6242 14.9941 30.2958 14.6658C29.9674 14.3374 29.5221 14.1529 29.0577 14.1529C28.5933 14.1529 28.1479 14.3374 27.8195 14.6658Z"
        fill="#F9CB6F"
      />
      <path
        d="M21.6333 3.49902C31.2985 3.49902 39.1333 11.3338 39.1333 20.999C39.1333 30.6643 31.2985 38.499 21.6333 38.499C11.9681 38.499 4.1333 30.6643 4.1333 20.999C4.1333 11.3338 11.9681 3.49902 21.6333 3.49902ZM27.8195 14.6658L19.1571 23.3283L15.4471 19.6165C15.2846 19.4539 15.0917 19.3249 14.8793 19.2369C14.667 19.1489 14.4394 19.1035 14.2095 19.1034C13.7453 19.1033 13.3 19.2875 12.9717 19.6156C12.6433 19.9438 12.4587 20.3889 12.4586 20.8532C12.4584 21.3174 12.6427 21.7627 12.9708 22.091L17.7973 26.9175C17.9761 27.0964 18.1883 27.2382 18.4219 27.335C18.6555 27.4318 18.9059 27.4817 19.1588 27.4817C19.4117 27.4817 19.6621 27.4318 19.8957 27.335C20.1293 27.2382 20.3415 27.0964 20.5203 26.9175L30.2958 17.142C30.6242 16.8137 30.8086 16.3683 30.8086 15.9039C30.8086 15.4395 30.6242 14.9941 30.2958 14.6658C29.9674 14.3374 29.5221 14.1529 29.0577 14.1529C28.5933 14.1529 28.1479 14.3374 27.8195 14.6658Z"
        fill="#F9CB6F"
      />
    </svg>
  );
}

export function CircleIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="43"
      height="42"
      viewBox="0 0 43 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.1"
        cx="21.2964"
        cy="21"
        r="19.432"
        stroke="#151518"
        strokeWidth="3.13606"
      />
    </svg>
  );
}

export function AddNewAddressPlusIcon(props: IconProps) {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="41" height="41" rx="20.5" fill="white" />
      <rect x="0.5" y="0.5" width="41" height="41" rx="20.5" stroke="#CECECE" />
      <g clipPath="url(#clip0_3854_5902)">
        <path
          d="M20.0833 28.6702C20.0833 28.9134 20.1799 29.1465 20.3518 29.3184C20.5237 29.4903 20.7569 29.5869 21 29.5869C21.2431 29.5869 21.4763 29.4903 21.6482 29.3184C21.8201 29.1465 21.9167 28.9134 21.9167 28.6702V22.2536H28.3333C28.5764 22.2536 28.8096 22.157 28.9815 21.9851C29.1534 21.8132 29.25 21.58 29.25 21.3369C29.25 21.0938 29.1534 20.8606 28.9815 20.6887C28.8096 20.5168 28.5764 20.4202 28.3333 20.4202H21.9167V14.0036C21.9167 13.7605 21.8201 13.5273 21.6482 13.3554C21.4763 13.1835 21.2431 13.0869 21 13.0869C20.7569 13.0869 20.5237 13.1835 20.3518 13.3554C20.1799 13.5273 20.0833 13.7605 20.0833 14.0036V20.4202H13.6667C13.4236 20.4202 13.1904 20.5168 13.0185 20.6887C12.8466 20.8606 12.75 21.0938 12.75 21.3369C12.75 21.58 12.8466 21.8132 13.0185 21.9851C13.1904 22.157 13.4236 22.2536 13.6667 22.2536H20.0833V28.6702Z"
          fill="#09244B"
        />
      </g>
      <defs>
        <clipPath id="clip0_3854_5902">
          <rect
            width="22"
            height="22"
            fill="white"
            transform="translate(10 10.3369)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ChevronIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.78 6.71985C6.92069 6.57934 6.99982 6.3887 7 6.18985V5.80985C6.9977 5.61144 6.91888 5.42157 6.78 5.27985L1.64 0.149852C1.54612 0.055196 1.41832 0.00195312 1.285 0.00195312C1.15168 0.00195312 1.02388 0.055196 0.93 0.149852L0.22 0.859852C0.125936 0.952016 0.0729284 1.07816 0.0729284 1.20985C0.0729284 1.34154 0.125936 1.46769 0.22 1.55985L4.67 5.99985L0.22 10.4399C0.125343 10.5337 0.0721006 10.6615 0.0721006 10.7949C0.0721006 10.9282 0.125343 11.056 0.22 11.1499L0.93 11.8499C1.02388 11.9445 1.15168 11.9978 1.285 11.9978C1.41832 11.9978 1.54612 11.9445 1.64 11.8499L6.78 6.71985Z"
        fill="#004987"
      />
    </svg>
  );
}

export function CircleMinusIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <rect
          x="0.5"
          y="0.5"
          width="29"
          height="29"
          rx="14.5"
          stroke="#DDDDDD"
        />
        <g clipPath="url(#clip0_382_14662)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.25 15C8.25 14.8011 8.32902 14.6103 8.46967 14.4697C8.61032 14.329 8.80109 14.25 9 14.25H21C21.1989 14.25 21.3897 14.329 21.5303 14.4697C21.671 14.6103 21.75 14.8011 21.75 15C21.75 15.1989 21.671 15.3897 21.5303 15.5303C21.3897 15.671 21.1989 15.75 21 15.75H9C8.80109 15.75 8.61032 15.671 8.46967 15.5303C8.32902 15.3897 8.25 15.1989 8.25 15Z"
            fill="#09244B"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_382_14662">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CirclePlusIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#DDDDDD" />
      <g clipPath="url(#clip0_382_14656)">
        <path
          d="M14.25 21C14.25 21.1989 14.329 21.3897 14.4697 21.5303C14.6103 21.671 14.8011 21.75 15 21.75C15.1989 21.75 15.3897 21.671 15.5303 21.5303C15.671 21.3897 15.75 21.1989 15.75 21V15.75H21C21.1989 15.75 21.3897 15.671 21.5303 15.5303C21.671 15.3897 21.75 15.1989 21.75 15C21.75 14.8011 21.671 14.6103 21.5303 14.4697C21.3897 14.329 21.1989 14.25 21 14.25H15.75V9C15.75 8.80109 15.671 8.61032 15.5303 8.46967C15.3897 8.32902 15.1989 8.25 15 8.25C14.8011 8.25 14.6103 8.32902 14.4697 8.46967C14.329 8.61032 14.25 8.80109 14.25 9V14.25H9C8.80109 14.25 8.61032 14.329 8.46967 14.4697C8.32902 14.6103 8.25 14.8011 8.25 15C8.25 15.1989 8.32902 15.3897 8.46967 15.5303C8.61032 15.671 8.80109 15.75 9 15.75H14.25V21Z"
          fill="#09244B"
        />
      </g>
      <defs>
        <clipPath id="clip0_382_14656">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ColoredXIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="15"
      height="15"
      viewBox="0 0 15 15"
      xmlns="http://www.w3.org/2000/svg"
      fill="#0083C3"
    >
      <path
        d="M0.662238 12.3517C0.468856 12.5439 0.360213 12.8055 0.360214 13.079C0.360214 13.3525 0.468855 13.6154 0.662239 13.81C0.855622 14.0047 1.11791 14.115 1.39139 14.1167C1.66487 14.1184 1.92716 14.0114 2.12054 13.8193L7.22461 8.7474L12.3287 13.8839C12.5221 14.0785 12.7843 14.1888 13.0578 14.1905C13.3313 14.1922 13.5936 14.0852 13.787 13.8931C13.9804 13.7009 14.089 13.4393 14.089 13.1658C14.089 12.8923 13.9804 12.6294 13.787 12.4347L8.68291 7.29829L13.787 2.22641C13.9804 2.03425 14.089 1.77265 14.089 1.49916C14.089 1.22567 13.9804 0.96269 13.787 0.76808C13.5936 0.573469 13.3313 0.463167 13.0578 0.461437C12.7843 0.459706 12.5221 0.56669 12.3287 0.758854L7.22461 5.83073L2.12054 0.694271C1.92716 0.499661 1.66488 0.389358 1.39139 0.387628C1.11791 0.385898 0.855623 0.492882 0.66224 0.685045C0.468857 0.877209 0.360215 1.13881 0.360215 1.4123C0.360215 1.68579 0.468857 1.94877 0.66224 2.14338L5.7663 7.27984L0.662238 12.3517Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ColoredDeleteIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="44"
      height="45"
      viewBox="0 0 44 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="1" width="43" height="43" rx="21.5" fill="white" />
      <rect x="0.5" y="1" width="43" height="43" rx="21.5" stroke="#E6E6E6" />
      <g clipPath="url(#clip0_528_7677)">
        <path
          d="M15.6603 26.8517C15.4669 27.0439 15.3583 27.3055 15.3583 27.579C15.3583 27.8525 15.4669 28.1154 15.6603 28.31C15.8537 28.5047 16.116 28.615 16.3894 28.6167C16.6629 28.6184 16.9252 28.5114 17.1186 28.3193L22.2227 23.2474L27.3267 28.3839C27.5201 28.5785 27.7824 28.6888 28.0559 28.6905C28.3294 28.6922 28.5916 28.5852 28.785 28.3931C28.9784 28.2009 29.087 27.9393 29.087 27.6658C29.087 27.3923 28.9784 27.1294 28.785 26.9347L23.681 21.7983L28.785 16.7264C28.9784 16.5343 29.087 16.2726 29.087 15.9992C29.087 15.7257 28.9784 15.4627 28.785 15.2681C28.5916 15.0735 28.3294 14.9632 28.0559 14.9614C27.7824 14.9597 27.5201 15.0667 27.3267 15.2589L22.2227 20.3307L17.1186 15.1943C16.9252 14.9997 16.6629 14.8894 16.3894 14.8876C16.116 14.8859 15.8537 14.9929 15.6603 15.185C15.4669 15.3772 15.3583 15.6388 15.3583 15.9123C15.3583 16.1858 15.4669 16.4488 15.6603 16.6434L20.7644 21.7798L15.6603 26.8517Z"
          fill="#0083C3"
        />
      </g>
      <defs>
        <clipPath id="clip0_528_7677">
          <rect
            width="26.9549"
            height="20.6027"
            fill="white"
            transform="translate(20 5.5) rotate(45.1812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function NoProductsInCompareIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="285"
      height="276"
      viewBox="0 0 285 276"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M135.876 275.761C209.632 275.761 269.424 215.97 269.424 142.214C269.424 68.4574 209.632 8.66602 135.876 8.66602C62.1195 8.66602 2.32812 68.4574 2.32812 142.214C2.32812 215.97 62.1195 275.761 135.876 275.761Z"
        fill="#ECECEC"
      />
      <path
        d="M207.924 39.7441H59.9816C50.7601 39.7441 43.2847 47.2196 43.2847 56.4411H224.621C224.621 47.2196 217.146 39.7441 207.924 39.7441Z"
        fill="#D6D6D6"
      />
      <path
        d="M43.2847 55.9824H224.621V194.091C224.621 200.232 222.182 206.121 217.84 210.463C213.498 214.805 207.609 217.244 201.469 217.244H66.4371C60.2967 217.244 54.4078 214.805 50.0659 210.463C45.7239 206.121 43.2847 200.232 43.2847 194.091V55.9824Z"
        fill="white"
      />
      <path
        d="M193.45 73.4258H74.5137C72.0368 73.4258 70.0288 75.4316 70.0288 77.9058C70.0288 80.3801 72.0368 82.3858 74.5137 82.3858H193.45C195.927 82.3858 197.935 80.3801 197.935 77.9058C197.935 75.4316 195.927 73.4258 193.45 73.4258Z"
        fill="#EBECEC"
      />
      <path
        d="M193.45 111.496H74.5137C72.0368 111.496 70.0288 113.502 70.0288 115.976C70.0288 118.45 72.0368 120.456 74.5137 120.456H193.45C195.927 120.456 197.935 118.45 197.935 115.976C197.935 113.502 195.927 111.496 193.45 111.496Z"
        fill="#EBECEC"
      />
      <path
        d="M193.45 149.562H74.5137C72.0368 149.562 70.0288 151.568 70.0288 154.043C70.0288 156.517 72.0368 158.523 74.5137 158.523H193.45C195.927 158.523 197.935 156.517 197.935 154.043C197.935 151.568 195.927 149.562 193.45 149.562Z"
        fill="#EBECEC"
      />
      <path
        d="M193.45 187.633H74.5137C72.0368 187.633 70.0288 189.639 70.0288 192.113C70.0288 194.587 72.0368 196.593 74.5137 196.593H193.45C195.927 196.593 197.935 194.587 197.935 192.113C197.935 189.639 195.927 187.633 193.45 187.633Z"
        fill="#EBECEC"
      />
      <path
        d="M10.377 141.698H73.7089C78.6311 141.698 82.6214 145.689 82.6214 150.611V241.134C82.6214 246.056 78.6311 250.046 73.7089 250.046H10.377C5.45479 250.046 1.46455 246.056 1.46455 241.134V150.611C1.46455 145.689 5.45479 141.698 10.377 141.698Z"
        fill="white"
        stroke="#CDCDCD"
        strokeWidth="0.6"
      />
      <path
        d="M184.042 0.35H253.994C257.061 0.35 259.546 2.83579 259.546 5.90218V38.7816C259.546 41.848 257.061 44.3338 253.994 44.3338H184.042C180.975 44.3338 178.49 41.848 178.49 38.7816V5.90218C178.49 2.83579 180.975 0.35 184.042 0.35Z"
        fill="white"
        stroke="#CDCDCD"
        strokeWidth="0.7"
      />
      <path
        d="M66.6412 186.684H17.4435C15.7868 186.684 14.4438 188.027 14.4438 189.683V189.693C14.4438 191.35 15.7868 192.693 17.4435 192.693H66.6412C68.2979 192.693 69.6409 191.35 69.6409 189.693V189.683C69.6409 188.027 68.2979 186.684 66.6412 186.684Z"
        fill="#E0E0E0"
      />
      <path
        d="M66.6692 228.967H17.8943C16.2518 228.967 14.9204 230.268 14.9204 231.873V231.882C14.9204 233.487 16.2518 234.788 17.8943 234.788H66.6692C68.3116 234.788 69.6431 233.487 69.6431 231.882V231.873C69.6431 230.268 68.3116 228.967 66.6692 228.967Z"
        fill="#E0E0E0"
      />
      <path
        d="M66.6692 206.844H17.8943C16.2518 206.844 14.9204 208.145 14.9204 209.75V209.759C14.9204 211.364 16.2518 212.665 17.8943 212.665H66.6692C68.3116 212.665 69.6431 211.364 69.6431 209.759V209.75C69.6431 208.145 68.3116 206.844 66.6692 206.844Z"
        fill="#E0E0E0"
      />
      <path
        d="M35.4322 155.377H21.0553C17.8707 155.377 15.2891 157.959 15.2891 161.143V165.133C15.2891 168.318 17.8707 170.899 21.0553 170.899H35.4322C38.6168 170.899 41.1985 168.318 41.1985 165.133V161.143C41.1985 157.959 38.6168 155.377 35.4322 155.377Z"
        fill="#E5E5E5"
      />
      <path
        d="M195.404 29.1239C199.151 29.1239 202.189 26.0859 202.189 22.3383C202.189 18.5907 199.151 15.5527 195.404 15.5527C191.656 15.5527 188.618 18.5907 188.618 22.3383C188.618 26.0859 191.656 29.1239 195.404 29.1239Z"
        fill="#E7E7E7"
      />
      <path
        d="M219.653 29.1239C223.4 29.1239 226.438 26.0859 226.438 22.3383C226.438 18.5907 223.4 15.5527 219.653 15.5527C215.905 15.5527 212.867 18.5907 212.867 22.3383C212.867 26.0859 215.905 29.1239 219.653 29.1239Z"
        fill="#E7E7E7"
      />
      <path
        d="M243.902 29.1239C247.65 29.1239 250.688 26.0859 250.688 22.3383C250.688 18.5907 247.65 15.5527 243.902 15.5527C240.155 15.5527 237.117 18.5907 237.117 22.3383C237.117 26.0859 240.155 29.1239 243.902 29.1239Z"
        fill="#E7E7E7"
      />
      <path
        d="M256.725 253.147L209.025 209.88L225.539 191.674L273.239 234.941L256.725 253.147Z"
        fill="#D6D6D6"
        stroke="#CDCDCD"
      />
      <mask id="path-18-inside-1_704_5778" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M243.666 159.606C243.666 199.242 211.535 231.373 171.899 231.373C132.262 231.373 100.131 199.242 100.131 159.606C100.131 119.969 132.262 87.8379 171.899 87.8379C211.535 87.8379 243.666 119.969 243.666 159.606ZM232.658 159.607C232.658 193.164 205.456 220.366 171.899 220.366C138.343 220.366 111.14 193.164 111.14 159.607C111.14 126.051 138.343 98.8477 171.899 98.8477C205.456 98.8477 232.658 126.051 232.658 159.607Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M243.666 159.606C243.666 199.242 211.535 231.373 171.899 231.373C132.262 231.373 100.131 199.242 100.131 159.606C100.131 119.969 132.262 87.8379 171.899 87.8379C211.535 87.8379 243.666 119.969 243.666 159.606ZM232.658 159.607C232.658 193.164 205.456 220.366 171.899 220.366C138.343 220.366 111.14 193.164 111.14 159.607C111.14 126.051 138.343 98.8477 171.899 98.8477C205.456 98.8477 232.658 126.051 232.658 159.607Z"
        fill="#D6D6D6"
      />
      <path
        d="M171.899 232.373C212.087 232.373 244.666 199.794 244.666 159.606H242.666C242.666 198.69 210.983 230.373 171.899 230.373V232.373ZM99.1309 159.606C99.1309 199.794 131.71 232.373 171.899 232.373V230.373C132.815 230.373 101.131 198.69 101.131 159.606H99.1309ZM171.899 86.8379C131.71 86.8379 99.1309 119.417 99.1309 159.606H101.131C101.131 120.522 132.815 88.8379 171.899 88.8379V86.8379ZM244.666 159.606C244.666 119.417 212.087 86.8379 171.899 86.8379V88.8379C210.983 88.8379 242.666 120.522 242.666 159.606H244.666ZM171.899 221.366C206.008 221.366 233.658 193.716 233.658 159.607H231.658C231.658 192.611 204.903 219.366 171.899 219.366V221.366ZM110.14 159.607C110.14 193.716 137.79 221.366 171.899 221.366V219.366C138.895 219.366 112.14 192.611 112.14 159.607H110.14ZM171.899 97.8477C137.79 97.8477 110.14 125.498 110.14 159.607H112.14C112.14 126.603 138.895 99.8477 171.899 99.8477V97.8477ZM233.658 159.607C233.658 125.498 206.008 97.8477 171.899 97.8477V99.8477C204.903 99.8477 231.658 126.603 231.658 159.607H233.658Z"
        fill="#C9C6C6"
        mask="url(#path-18-inside-1_704_5778)"
      />
      <path
        d="M171.899 220.366C205.455 220.366 232.658 193.164 232.658 159.607C232.658 126.051 205.455 98.8477 171.899 98.8477C138.342 98.8477 111.139 126.051 111.139 159.607C111.139 193.164 138.342 220.366 171.899 220.366Z"
        fill="white"
      />
      <path
        d="M171.899 220.366C205.455 220.366 232.658 193.164 232.658 159.607C232.658 126.051 205.455 98.8477 171.899 98.8477C138.342 98.8477 111.139 126.051 111.139 159.607C111.139 193.164 138.342 220.366 171.899 220.366Z"
        stroke="#CDCDCD"
      />
      <path
        d="M183.158 159.646L182.803 160L183.158 160.354L198.447 175.584C199.709 177.005 200.38 178.85 200.324 180.744C200.268 182.643 199.485 184.45 198.135 185.797C196.784 187.143 194.967 187.927 193.054 187.989C191.146 188.051 189.286 187.389 187.852 186.138L172.53 170.91L172.178 170.559L171.825 170.91L156.492 186.15L156.487 186.155L156.482 186.16C155.792 186.886 154.962 187.467 154.042 187.869C153.121 188.271 152.129 188.485 151.124 188.499C150.118 188.513 149.12 188.327 148.189 187.951C147.257 187.575 146.411 187.018 145.701 186.312C144.99 185.605 144.429 184.765 144.052 183.84C143.674 182.915 143.487 181.924 143.501 180.926C143.515 179.928 143.73 178.943 144.134 178.029C144.538 177.115 145.123 176.29 145.853 175.604L145.859 175.6L145.864 175.594L161.188 160.355L161.545 160L161.188 159.645L145.864 144.406L145.859 144.4L145.853 144.396C145.123 143.71 144.538 142.885 144.134 141.971C143.73 141.057 143.515 140.072 143.501 139.074C143.487 138.076 143.674 137.085 144.052 136.16C144.429 135.235 144.99 134.395 145.701 133.688C146.411 132.982 147.257 132.425 148.189 132.049C149.12 131.673 150.118 131.487 151.124 131.501C152.129 131.515 153.121 131.729 154.042 132.131C154.962 132.533 155.792 133.114 156.482 133.84L156.482 133.84L156.491 133.85L171.791 149.09L172.143 149.441L172.496 149.09L187.824 133.855C189.246 132.523 191.134 131.792 193.089 131.82C195.047 131.848 196.916 132.633 198.299 134.008C199.683 135.383 200.472 137.239 200.499 139.182C200.527 141.122 199.793 142.998 198.452 144.411L183.158 159.646Z"
        fill="#D2D2D2"
        stroke="#CDCDCD"
      />
      <path
        d="M124.879 233.689C125.397 231.545 128.446 231.545 128.964 233.689L131.377 243.686C131.562 244.452 132.16 245.051 132.927 245.236L142.924 247.649C145.068 248.166 145.068 251.216 142.924 251.734L132.927 254.147C132.16 254.332 131.562 254.93 131.377 255.696L128.964 265.693C128.446 267.837 125.397 267.837 124.879 265.693L122.466 255.696C122.281 254.93 121.683 254.332 120.917 254.147L110.92 251.734C108.776 251.216 108.776 248.166 110.92 247.649L120.917 245.236C121.683 245.051 122.281 244.452 122.466 243.686L124.879 233.689Z"
        fill="#D6D6D6"
      />
      <path
        d="M28.2415 10.1404C28.7591 7.99638 31.8087 7.99639 32.3263 10.1404L34.7395 20.1374C34.9245 20.9036 35.5227 21.5018 36.2889 21.6867L46.2858 24.0999C48.4298 24.6175 48.4298 27.6671 46.2858 28.1847L36.2889 30.5979C35.5227 30.7829 34.9245 31.3811 34.7395 32.1473L32.3263 42.1442C31.8087 44.2882 28.7591 44.2882 28.2415 42.1442L25.8283 32.1473C25.6434 31.3811 25.0452 30.7829 24.279 30.5979L14.282 28.1847C12.138 27.6671 12.138 24.6175 14.282 24.0999L24.279 21.6867C25.0452 21.5018 25.6434 20.9036 25.8283 20.1374L28.2415 10.1404Z"
        fill="#D6D6D6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M130.551 12.8917C132.803 12.8917 134.629 11.0663 134.629 8.81462C134.629 6.5629 132.803 4.73752 130.551 4.73752C128.3 4.73752 126.474 6.5629 126.474 8.81462C126.474 11.0663 128.3 12.8917 130.551 12.8917ZM130.551 15.9496C134.492 15.9496 137.686 12.7551 137.686 8.81462C137.686 4.87411 134.492 1.67969 130.551 1.67969C126.611 1.67969 123.417 4.87411 123.417 8.81462C123.417 12.7551 126.611 15.9496 130.551 15.9496Z"
        fill="#D6D6D6"
      />
      <path
        d="M257.206 124.677C256.873 123.371 258.079 122.194 259.377 122.559L270.534 125.694C271.831 126.059 272.247 127.691 271.283 128.632L262.989 136.727C262.024 137.668 260.403 137.213 260.07 135.907L257.206 124.677Z"
        fill="#D6D6D6"
      />
      <path
        d="M18.7777 107.533C20.0842 107.202 21.2594 108.409 20.893 109.706L17.7433 120.859C17.377 122.156 15.7439 122.571 14.8038 121.605L6.71988 113.301C5.77973 112.335 6.23762 110.713 7.54408 110.382L18.7777 107.533Z"
        fill="#D6D6D6"
      />
      <path
        d="M213.218 248.412C214.524 248.081 215.699 249.288 215.333 250.585L212.183 261.738C211.817 263.035 210.184 263.45 209.244 262.484L201.16 254.18C200.22 253.214 200.678 251.592 201.984 251.261L213.218 248.412Z"
        fill="#D6D6D6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M266.776 72.2726C269.028 72.2726 270.853 70.4472 270.853 68.1955C270.853 65.9438 269.028 64.1184 266.776 64.1184C264.524 64.1184 262.699 65.9438 262.699 68.1955C262.699 70.4472 264.524 72.2726 266.776 72.2726ZM266.776 75.3304C270.717 75.3304 273.911 72.136 273.911 68.1955C273.911 64.255 270.717 61.0605 266.776 61.0605C262.836 61.0605 259.641 64.255 259.641 68.1955C259.641 72.136 262.836 75.3304 266.776 75.3304Z"
        fill="#D6D6D6"
      />
      <path
        d="M256.469 252.812L272.976 234.613L275.194 236.625C277.608 238.814 279.053 241.872 279.211 245.127C279.37 248.381 278.229 251.565 276.04 253.978C273.851 256.391 270.793 257.836 267.539 257.995C264.285 258.154 261.101 257.013 258.687 254.824L256.469 252.812Z"
        fill="#E0E0E0"
        stroke="#CDCDCD"
      />
    </svg>
  );
}

export function DeliveryVanIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9998 14H12.9998C14.0998 14 14.9998 13.1 14.9998 12V2H5.99976C4.49976 2 3.18977 2.82999 2.50977 4.04999"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 17C2 18.66 3.34 20 5 20H6C6 18.9 6.9 18 8 18C9.1 18 10 18.9 10 20H14C14 18.9 14.9 18 16 18C17.1 18 18 18.9 18 20H19C20.66 20 22 18.66 22 17V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L18.58 6.01001C18.22 5.39001 17.56 5 16.84 5H15V12C15 13.1 14.1 14 13 14H12"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 12V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L22 12Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 8H8"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 11H6"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 14H4"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EyeIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.1609 12.0526C15.1609 13.7986 13.7449 15.2136 11.9989 15.2136C10.2529 15.2136 8.83789 13.7986 8.83789 12.0526C8.83789 10.3056 10.2529 8.89062 11.9989 8.89062C13.7449 8.89062 15.1609 10.3056 15.1609 12.0526Z"
          stroke="#404040"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.998 19.354C15.806 19.354 19.289 16.616 21.25 12.052C19.289 7.488 15.806 4.75 11.998 4.75H12.002C8.194 4.75 4.711 7.488 2.75 12.052C4.711 16.616 8.194 19.354 12.002 19.354H11.998Z"
          stroke="#404040"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export function MinusIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="18"
      height="2"
      viewBox="0 0 18 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H17C17.2652 0 17.5196 0.105357 17.7071 0.292893C17.8946 0.48043 18 0.734784 18 1C18 1.26522 17.8946 1.51957 17.7071 1.70711C17.5196 1.89464 17.2652 2 17 2H1C0.734784 2 0.48043 1.89464 0.292893 1.70711C0.105357 1.51957 0 1.26522 0 1Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function FiltersIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.15859 13.6187C6.11896 11.3453 3.95076 8.8446 2.76643 7.43901C2.39977 7.00389 2.28 6.68488 2.20788 6.12387C1.961 4.20249 1.83755 3.24181 2.40099 2.6209C2.96443 2 3.96053 2 5.95274 2H20.0473C22.0395 2 23.0356 2 23.599 2.61968C24.1624 3.24058 24.039 4.20127 23.7921 6.12265C23.7188 6.68366 23.599 7.00267 23.2336 7.43779C22.048 8.84582 19.8762 11.3514 16.8292 13.6285C16.6883 13.7381 16.5718 13.876 16.4872 14.0332C16.4026 14.1904 16.3517 14.3635 16.3379 14.5415C16.036 17.8795 15.7573 19.708 15.5838 20.632C15.3039 22.1256 13.1882 23.0239 12.054 23.8245C11.3793 24.3012 10.5605 23.734 10.4737 22.9958C10.1492 20.1828 9.87453 17.3643 9.64992 14.5415C9.63737 14.3618 9.58713 14.1868 9.50248 14.0278C9.41783 13.8688 9.30066 13.7294 9.15859 13.6187Z"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TermsSearchIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0003 5.80785C9.53494 5.80785 9.13661 5.64219 8.80528 5.31085C8.47394 4.97952 8.30828 4.58119 8.30828 4.11585C8.30828 3.65052 8.47394 3.25185 8.80528 2.91985C9.13661 2.58785 9.53494 2.42219 10.0003 2.42285C10.4656 2.42352 10.8639 2.58919 11.1953 2.91985C11.5266 3.25052 11.6923 3.64919 11.6923 4.11585C11.6923 4.58119 11.5266 4.97952 11.1953 5.31085C10.8639 5.64219 10.4656 5.80785 10.0003 5.80785ZM16.5003 18.3079C17.2776 18.3079 17.9399 18.0342 18.4873 17.4869C19.0339 16.9395 19.3073 16.2772 19.3073 15.4999C19.3073 14.7225 19.0339 14.0605 18.4873 13.5139C17.9399 12.9659 17.2776 12.6919 16.5003 12.6919C15.7229 12.6919 15.0609 12.9659 14.5143 13.5139C13.9676 14.0619 13.6936 14.7239 13.6923 15.4999C13.6909 16.2759 13.9649 16.9382 14.5143 17.4869C15.0609 18.0335 15.7229 18.3069 16.5003 18.3069M18.8233 18.5119C18.4819 18.7705 18.1156 18.9679 17.7243 19.1039C17.3329 19.2399 16.9249 19.3079 16.5003 19.3079C15.4429 19.3079 14.5439 18.9375 13.8033 18.1969C13.0626 17.4562 12.6926 16.5572 12.6933 15.4999C12.6939 14.4425 13.0639 13.5435 13.8033 12.8029C14.5426 12.0622 15.4416 11.6922 16.5003 11.6929C17.5589 11.6935 18.4579 12.0635 19.1973 12.8029C19.9366 13.5422 20.3066 14.4412 20.3073 15.4999C20.3073 15.9245 20.2396 16.3325 20.1043 16.7239C19.9683 17.1159 19.7706 17.4822 19.5113 17.8229L21.9543 20.2459C22.0476 20.3385 22.0943 20.4562 22.0943 20.5989C22.0943 20.7422 22.0479 20.8605 21.9553 20.9539C21.8626 21.0472 21.7446 21.0939 21.6013 21.0939C21.4586 21.0939 21.3403 21.0472 21.2463 20.9539L18.8233 18.5119ZM11.1933 18.6869C11.3273 18.9202 11.4786 19.1362 11.6473 19.3349C11.8159 19.5335 11.9976 19.7212 12.1923 19.8979V20.9999C12.1923 21.1419 12.1443 21.2605 12.0483 21.3559C11.9523 21.4519 11.8336 21.4999 11.6923 21.4999C11.5503 21.4999 11.4313 21.4519 11.3353 21.3559C11.2393 21.2599 11.1916 21.1412 11.1923 20.9999L11.1933 18.6869ZM8.80828 15.2689V20.9999C8.80828 21.1419 8.76028 21.2605 8.66428 21.3559C8.56828 21.4512 8.44928 21.4992 8.30728 21.4999C8.16528 21.5005 8.04661 21.4525 7.95128 21.3559C7.85594 21.2592 7.80828 21.1405 7.80828 20.9999V8.42585C6.92694 8.35519 6.05428 8.25885 5.19028 8.13685C4.32628 8.01485 3.46094 7.86252 2.59428 7.67985C2.43894 7.63852 2.30894 7.56019 2.20428 7.44485C2.09961 7.32952 2.06994 7.19752 2.11528 7.04885C2.16061 6.90019 2.25128 6.79119 2.38728 6.72185C2.52394 6.65252 2.66994 6.63852 2.82528 6.67985C4.00328 6.94985 5.19194 7.14152 6.39128 7.25485C7.59061 7.36819 8.79361 7.42419 10.0003 7.42285C11.2069 7.42152 12.4103 7.36485 13.6103 7.25285C14.8103 7.14085 15.9986 6.94952 17.1753 6.67885C17.3306 6.63752 17.4766 6.65085 17.6133 6.71885C17.7506 6.78685 17.8413 6.89352 17.8853 7.03885C17.9299 7.19352 17.8999 7.32852 17.7953 7.44385C17.6906 7.55919 17.5606 7.63752 17.4053 7.67885C16.5413 7.86685 15.6769 8.02085 14.8123 8.14085C13.9476 8.26085 13.0743 8.35485 12.1923 8.42285V11.1019C11.6516 11.6085 11.2149 12.2095 10.8823 12.9049C10.5503 13.6002 10.3653 14.3499 10.3273 15.1539V15.2119C10.3273 15.2312 10.3293 15.2502 10.3333 15.2689H8.80828Z"
        fill="black"
      />
    </svg>
  );
}

export function BlackCompareIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 21.2295V18.9995H1.616C1.15533 18.9995 0.771 18.8455 0.463 18.5375C0.155 18.2295 0.000666667 17.8449 0 17.3835V4.61553C0 4.15486 0.154333 3.77053 0.463 3.46253C0.771667 3.15453 1.156 3.0002 1.616 2.99953H7V0.769531H8V21.2295H7ZM1 16.9995H7V9.80753L1 16.9995ZM10 18.9995V10.9995L15 16.9995V4.61553C15 4.46153 14.936 4.3202 14.808 4.19153C14.68 4.06286 14.5387 3.99886 14.384 3.99953H10V2.99953H14.385C14.845 2.99953 15.229 3.15386 15.537 3.46253C15.845 3.7712 15.9993 4.15553 16 4.61553V17.3845C16 17.8445 15.8457 18.2289 15.537 18.5375C15.2283 18.8462 14.8443 19.0002 14.385 18.9995H10Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CircleQuestionMarkIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="black"
        strokeWidth="2"
      />
      <path
        d="M10 8.484C10.5 7.494 11 7 12 7C13.246 7 14 7.989 14 8.978C14 9.967 13.5 10.461 12 11.451V13M12 16.5V17"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function ShareIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <g id="share_forward_line" fill="none">
        <path d="M24 0v24H0V0zM12.593 23.258l-.011.002-.071.035-.02.004-.014-.004-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113-.013.002-.185.093-.01.01-.003.011.018.43.005.012.008.007.201.093c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.004-.011.017-.43-.003-.012-.01-.01z" />
        <path
          fill="currentColor"
          d="M10.114 4.491c.076-.795.906-1.45 1.743-.972 1.74 1.019 3.382 2.18 4.97 3.421 1.96 1.548 3.533 3.007 4.647 4.172.483.507.438 1.308-.024 1.792a42.072 42.072 0 0 1-3.495 3.228c-1.938 1.587-3.945 3.125-6.13 4.358-.741.418-1.544-.06-1.687-.801l-.017-.113-.227-3.574c-1.816.038-3.574.662-4.98 1.823l-.265.222-.128.104-.247.192c-.04.03-.08.06-.12.088l-.23.16a4.72 4.72 0 0 1-.218.135l-.206.111C2.534 19.314 2 18.892 2 17c0-4.404 3.245-8.323 7.632-8.917l.259-.031zm1.909 1.474-.192 3.472a.5.5 0 0 1-.447.47l-1.361.142c-3.065.366-5.497 2.762-5.948 5.894a9.952 9.952 0 0 1 5.135-1.912l.397-.023 1.704-.036a.5.5 0 0 1 .51.472l.197 3.596c1.603-1.021 3.131-2.196 4.664-3.45a43.717 43.717 0 0 0 2.857-2.595l-.258-.256-.556-.533a48.15 48.15 0 0 0-3.134-2.693 46.172 46.172 0 0 0-3.568-2.548"
        />
      </g>
    </svg>
  );
}

export function UserIcon(props: IconProps) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      height="36"
      viewBox="0 0 24 24"
      width="36"
    >
      <path
        clipRule="evenodd"
        d="m22 12c0 3.0134-1.3328 5.7154-3.4412 7.5488-1.7557 1.5268-4.0493 2.4512-6.5588 2.4512-2.50948 0-4.80306-.9244-6.55883-2.4512-2.10832-1.8334-3.44117-4.5354-3.44117-7.5488 0-5.52285 4.47715-10 10-10 5.5228 0 10 4.47715 10 10zm-10 7c1.7567 0 3.3622-.6471 4.5912-1.7158.1415-.1231.278-.2517.4091-.3856-1.0809-1.7483-2.917-2.8986-5.0003-2.8986-2.08325 0-3.9194 1.1503-5.00031 2.8986.13117.1339.26766.2625.40915.3856 1.22904 1.0687 2.83456 1.7158 4.59116 1.7158zm0-7c1.6569 0 3-1.3431 3-3 0-1.65685-1.3431-3-3-3s-3 1.34315-3 3c0 1.6569 1.3431 3 3 3z"
        fill="#28303f"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function ActiveRatingIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4353 1.16298C13.5542 0.796923 14.0721 0.796924 14.191 1.16298L17.1753 10.3478C17.2285 10.5115 17.3811 10.6223 17.5532 10.6223H27.2107C27.5956 10.6223 27.7556 11.1148 27.4442 11.3411L19.6312 17.0176C19.4919 17.1187 19.4336 17.2981 19.4868 17.4618L22.4711 26.6465C22.5901 27.0126 22.1711 27.317 21.8597 27.0908L14.0467 21.4143C13.9074 21.3131 13.7189 21.3131 13.5796 21.4143L5.76658 27.0908C5.4552 27.317 5.03623 27.0126 5.15517 26.6465L8.13948 17.4618C8.19267 17.2981 8.1344 17.1187 7.99515 17.0176L0.182114 11.3411C-0.129272 11.1148 0.0307596 10.6223 0.415654 10.6223H10.0731C10.2452 10.6223 10.3978 10.5115 10.451 10.3478L13.4353 1.16298Z"
        fill="#FFD325"
      />
    </svg>
  );
}

export function RatingIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2497 1.16298C14.3687 0.796923 14.8865 0.796924 15.0055 1.16298L17.9898 10.3478C18.043 10.5115 18.1955 10.6223 18.3677 10.6223H28.0251C28.41 10.6223 28.57 11.1148 28.2587 11.3411L20.4456 17.0176C20.3064 17.1187 20.2481 17.2981 20.3013 17.4618L23.2856 26.6465C23.4045 27.0126 22.9856 27.317 22.6742 27.0908L14.8611 21.4143C14.7219 21.3131 14.5333 21.3131 14.3941 21.4143L6.58104 27.0908C6.26965 27.317 5.85068 27.0126 5.96962 26.6465L8.95394 17.4618C9.00713 17.2981 8.94886 17.1187 8.8096 17.0176L0.996567 11.3411C0.685181 11.1148 0.845213 10.6223 1.23011 10.6223H10.8875C11.0597 10.6223 11.2122 10.5115 11.2654 10.3478L14.2497 1.16298Z"
        fill="#D9D9D9"
      />
    </svg>
  );
}

export function NoReviewsIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="309"
      height="268"
      viewBox="0 0 309 268"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M308 1H1V268H308V1Z" fill="white" />
      <path
        d="M191.719 117.857C176.494 117.857 161.032 117.24 146.551 113.215C132.343 109.262 119.298 101.647 107.67 92.8167C100.039 87.0507 93.1344 82.4815 83.2323 83.1705C73.5742 83.6747 64.3332 87.2593 56.8691 93.3969C44.278 104.385 46.1858 124.711 51.2004 138.999C58.7769 160.521 81.7607 175.48 101.329 185.217C123.913 196.477 148.713 203.077 173.605 206.703C195.408 210.022 223.406 212.415 242.302 198.2C259.671 185.145 264.432 155.336 260.18 135.209C259.147 129.26 255.967 123.893 251.241 120.123C239.05 111.221 220.862 117.168 207.163 117.458C202.076 117.639 196.916 117.857 191.719 117.857Z"
        fill="#F2F2F2"
      />
      <path
        d="M154.491 242.062C191.328 242.062 221.19 240.203 221.19 237.91C221.19 235.617 191.328 233.758 154.491 233.758C117.655 233.758 87.793 235.617 87.793 237.91C87.793 240.203 117.655 242.062 154.491 242.062Z"
        fill="#F2F2F2"
      />
      <path
        d="M249.824 92.1828C250.807 92.1828 251.604 91.3872 251.604 90.4058C251.604 89.4245 250.807 88.6289 249.824 88.6289C248.84 88.6289 248.043 89.4245 248.043 90.4058C248.043 91.3872 248.84 92.1828 249.824 92.1828Z"
        fill="#CFCFCF"
      />
      <path
        d="M173.042 79.5265C174.026 79.5265 174.823 78.731 174.823 77.7496C174.823 76.7682 174.026 75.9727 173.042 75.9727C172.059 75.9727 171.262 76.7682 171.262 77.7496C171.262 78.731 172.059 79.5265 173.042 79.5265Z"
        fill="#CFCFCF"
      />
      <path
        d="M101.928 194.736V202.533"
        stroke="#BABABA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M98.0215 198.635H105.834"
        stroke="#BABABA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.2754 46.3262V54.1229"
        stroke="#BABABA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69.3516 50.2246H77.1824"
        stroke="#BABABA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M214.902 86.4902V94.3051"
        stroke="#BABABA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M210.996 90.4062H218.809"
        stroke="#BABABA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M144.189 190.893C152.583 202.604 165.286 210.516 179.516 212.895C193.745 215.274 208.339 211.926 220.099 203.585C221.553 202.556 222.953 201.454 224.296 200.285L245.972 206.831L237.669 182.625C241.813 173.966 243.589 164.367 242.816 154.803C242.043 145.238 238.748 136.048 233.266 128.164C227.784 120.281 220.309 113.985 211.602 109.915C202.894 105.846 193.262 104.147 183.684 104.993C174.106 105.838 164.922 109.197 157.065 114.728C149.208 120.26 142.957 127.767 138.946 136.488C134.936 145.209 133.308 154.834 134.229 164.386C135.15 173.938 138.586 183.076 144.189 190.875V190.893Z"
        fill="white"
        stroke="#BABABA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.363 162.934C209.35 162.934 210.961 161.327 210.961 159.344C210.961 157.361 209.35 155.754 207.363 155.754C205.376 155.754 203.766 157.361 203.766 159.344C203.766 161.327 205.376 162.934 207.363 162.934Z"
        fill="#BABABA"
      />
      <path
        d="M190.012 162.934C191.998 162.934 193.609 161.327 193.609 159.344C193.609 157.361 191.998 155.754 190.012 155.754C188.025 155.754 186.414 157.361 186.414 159.344C186.414 161.327 188.025 162.934 190.012 162.934Z"
        fill="#BABABA"
      />
      <path
        d="M172.678 162.934C174.664 162.934 176.275 161.327 176.275 159.344C176.275 157.361 174.664 155.754 172.678 155.754C170.691 155.754 169.08 157.361 169.08 159.344C169.08 161.327 170.691 162.934 172.678 162.934Z"
        fill="#BABABA"
      />
      <path
        d="M161.958 153.886C153.565 165.597 140.861 173.509 126.632 175.888C112.403 178.268 97.8085 174.92 86.0484 166.579C84.5908 165.555 83.1897 164.453 81.8514 163.279L60.1758 169.861L68.479 145.636C64.3343 136.978 62.5584 127.379 63.3317 117.814C64.1049 108.25 67.3998 99.0592 72.8819 91.1758C78.364 83.2924 85.8382 76.9964 94.5461 72.9269C103.254 68.8574 112.886 67.1591 122.464 68.0045C132.042 68.8498 141.225 72.2086 149.082 77.74C156.939 83.2715 163.191 90.7787 167.201 99.5C171.212 108.221 172.839 117.846 171.919 127.398C170.998 136.949 167.562 146.088 161.958 153.886Z"
        fill="white"
        stroke="#BABABA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M102.146 132.871C103.759 130.153 106.047 127.897 108.789 126.32C111.531 124.743 114.634 123.899 117.799 123.87C120.963 123.841 124.082 124.627 126.853 126.153C129.624 127.679 131.953 129.893 133.615 132.581"
        stroke="#BABABA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M138.247 116.934C139.662 116.934 140.809 115.789 140.809 114.377C140.809 112.965 139.662 111.82 138.247 111.82C136.833 111.82 135.686 112.965 135.686 114.377C135.686 115.789 136.833 116.934 138.247 116.934Z"
        fill="#BABABA"
      />
      <path
        d="M97.6575 116.934C99.0724 116.934 100.219 115.789 100.219 114.377C100.219 112.965 99.0724 111.82 97.6575 111.82C96.2427 111.82 95.0957 112.965 95.0957 114.377C95.0957 115.789 96.2427 116.934 97.6575 116.934Z"
        fill="#BABABA"
      />
    </svg>
  );
}

export function ColoredAlertIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.00039 17.5376C13.6629 17.5376 17.5382 13.6705 17.5382 8.99977C17.5382 4.33727 13.6543 0.461914 8.99182 0.461914C4.32146 0.461914 0.462891 4.33727 0.462891 8.99977C0.462891 13.6705 4.32968 17.5376 9.00039 17.5376ZM9.00075 16.1148C5.04932 16.1148 1.89325 12.9505 1.89325 8.99977C1.89325 5.05691 5.04075 1.88477 8.99182 1.88477C12.9343 1.88477 16.1065 5.05727 16.115 8.99977C16.1232 12.9508 12.9425 16.1148 9.00003 16.1148M8.99182 10.5148C9.39325 10.5148 9.61932 10.2887 9.62753 9.8537L9.75325 5.43406C9.76182 5.00691 9.42682 4.68906 8.98325 4.68906C8.5311 4.68906 8.21325 4.9987 8.22146 5.42549L8.33039 9.8537C8.3386 10.2805 8.57325 10.5148 8.99182 10.5148ZM8.99182 13.2351C9.46861 13.2351 9.89539 12.8501 9.89539 12.3648C9.89539 11.8708 9.47718 11.4941 8.99182 11.4941C8.49789 11.4941 8.08753 11.8791 8.08753 12.3648C8.08753 12.8419 8.5061 13.2351 8.99182 13.2351Z"
        fill="#F37E31"
      />
    </svg>
  );
}

export function WhiteMinusIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="24" height="24" rx="12" stroke="#DDDDDD" />
      <g clipPath="url(#clip0_3323_4064)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 13C7 12.8232 7.07024 12.6536 7.19526 12.5286C7.32029 12.4036 7.48986 12.3333 7.66667 12.3333H18.3333C18.5101 12.3333 18.6797 12.4036 18.8047 12.5286C18.9298 12.6536 19 12.8232 19 13C19 13.1768 18.9298 13.3464 18.8047 13.4714C18.6797 13.5964 18.5101 13.6666 18.3333 13.6666H7.66667C7.48986 13.6666 7.32029 13.5964 7.19526 13.4714C7.07024 13.3464 7 13.1768 7 13Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3323_4064">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(5 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function WhitePlusIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="24" height="24" rx="12" stroke="#DDDDDD" />
      <g clipPath="url(#clip0_3323_4070)">
        <path
          d="M12.3333 18.3333C12.3333 18.5101 12.4036 18.6797 12.5286 18.8047C12.6536 18.9298 12.8232 19 13 19C13.1768 19 13.3464 18.9298 13.4714 18.8047C13.5964 18.6797 13.6667 18.5101 13.6667 18.3333V13.6667H18.3333C18.5101 13.6667 18.6797 13.5964 18.8047 13.4714C18.9298 13.3464 19 13.1768 19 13C19 12.8232 18.9298 12.6536 18.8047 12.5286C18.6797 12.4036 18.5101 12.3333 18.3333 12.3333H13.6667V7.66667C13.6667 7.48986 13.5964 7.32029 13.4714 7.19526C13.3464 7.07024 13.1768 7 13 7C12.8232 7 12.6536 7.07024 12.5286 7.19526C12.4036 7.32029 12.3333 7.48986 12.3333 7.66667V12.3333H7.66667C7.48986 12.3333 7.32029 12.4036 7.19526 12.5286C7.07024 12.6536 7 12.8232 7 13C7 13.1768 7.07024 13.3464 7.19526 13.4714C7.32029 13.5964 7.48986 13.6667 7.66667 13.6667H12.3333V18.3333Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3323_4070">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(5 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BurgerMenuIcon(props: IconProps) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="36" height="36" rx="18" fill="white" />
      <g clipPath="url(#clip0_4868_14043)">
        <path
          d="M6 13H30M6 23H30"
          stroke="#004987"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4868_14043">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function MenuCloseIcon(props: IconProps) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" fill="white" />
      <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" stroke="#F3F3F3" />
      <path
        d="M11 11L24.5 24.5M11 24.5L24.5 11.2058"
        stroke="#004987"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// export function DeleteIcon(props: IconProps) {
//   return (
//     <svg
//       {...props}
//       width="45"
//       height="45"
//       viewBox="0 0 30 30"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#F7F7F7" />
//       <path
//         d="M20.4938 13.1016C20.4938 13.1016 20.0866 18.1528 19.8503 20.2806C19.7378 21.2968 19.1101 21.8923 18.0818 21.9111C16.1251 21.9463 14.1661 21.9486 12.2101 21.9073C11.2208 21.8871 10.6036 21.2841 10.4933 20.2858C10.2556 18.1393 9.85059 13.1016 9.85059 13.1016"
//         stroke="#FF7C7C"
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <path
//         d="M21.531 10.6807H8.8125"
//         stroke="#FF7C7C"
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <path
//         d="M19.0799 10.6802C18.4912 10.6802 17.9842 10.264 17.8687 9.68723L17.6864 8.77523C17.5739 8.35448 17.1929 8.06348 16.7587 8.06348H13.5839C13.1497 8.06348 12.7687 8.35448 12.6562 8.77523L12.4739 9.68723C12.3584 10.264 11.8514 10.6802 11.2627 10.6802"
//         stroke="#FF7C7C"
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   );
// }

// export function CopyIcon(props: IconProps) {
//   return (
//     <svg
//       {...props}
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
//       <g
//         id="SVGRepo_tracerCarrier"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         stroke="#CCCCCC"
//         strokeWidth="0.624"
//       ></g>
//       <g id="SVGRepo_iconCarrier">
//         <path
//           d="M17.5 14H19C20.1046 14 21 13.1046 21 12V5C21 3.89543 20.1046 3 19 3H12C10.8954 3 10 3.89543 10 5V6.5M5 10H12C13.1046 10 14 10.8954 14 12V19C14 20.1046 13.1046 21 12 21H5C3.89543 21 3 20.1046 3 19V12C3 10.8954 3.89543 10 5 10Z"
//           stroke="#000000"
//           strokeWidth="1.5"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         ></path>
//       </g>
//     </svg>
//   );
// }

// export function PlusIcon(props: IconProps) {
//   return (
//     <svg
//       {...props}
//       width="24"
//       height="24"
//       viewBox="0 0 24 24"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M11 20C11 20.2652 11.1054 20.5196 11.2929 20.7071C11.4804 20.8946 11.7348 21 12 21C12.2652 21 12.5196 20.8946 12.7071 20.7071C12.8946 20.5196 13 20.2652 13 20V13H20C20.2652 13 20.5196 12.8946 20.7071 12.7071C20.8946 12.5196 21 12.2652 21 12C21 11.7348 20.8946 11.4804 20.7071 11.2929C20.5196 11.1054 20.2652 11 20 11H13V4C13 3.73478 12.8946 3.48043 12.7071 3.29289C12.5196 3.10536 12.2652 3 12 3C11.7348 3 11.4804 3.10536 11.2929 3.29289C11.1054 3.48043 11 3.73478 11 4V11H4C3.73478 11 3.48043 11.1054 3.29289 11.2929C3.10536 11.4804 3 11.7348 3 12C3 12.2652 3.10536 12.5196 3.29289 12.7071C3.48043 12.8946 3.73478 13 4 13H11V20Z"
//         fill="#09244B"
//       />
//     </svg>
//   );
// }

// export function CompareIcon({
//   color = "#FEFEFE",
//   ...props
// }: IconProps) {
//   return (
//     <svg
//       {...props}
//       width="24"
//       height="25"
//       viewBox="0 0 24 25"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M13 4.5H6C5.46957 4.5 4.96086 4.71071 4.58579 5.08579C4.21071 5.46086 4 5.96957 4 6.5V18.5C4 19.0304 4.21071 19.5391 4.58579 19.9142C4.96086 20.2893 5.46957 20.5 6 20.5H13M17 4.5H18C18.5304 4.5 19.0391 4.71071 19.4142 5.08579C19.7893 5.46086 20 5.96957 20 6.5V7.5M20 17.5V18.5C20 19.0304 19.7893 19.5391 19.4142 19.9142C19.0391 20.2893 18.5304 20.5 18 20.5H17M20 11.5V13.5M12 2.5V22.5"
//         stroke={color}
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   );
// }

// export function CompareIcon(props: IconProps) {
//   return (
//     <svg
//       {...props}
//       width="38"
//       height="38"
//       viewBox="0 0 38 38"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M20.5417 7.08333H9.75008C8.93233 7.08333 8.14807 7.40818 7.56984 7.98642C6.9916 8.56466 6.66675 9.34892 6.66675 10.1667V28.6667C6.66675 29.4844 6.9916 30.2687 7.56984 30.8469C8.14807 31.4252 8.93233 31.75 9.75008 31.75H20.5417M26.7084 7.08333H28.2501C29.0678 7.08333 29.8521 7.40818 30.4303 7.98642C31.0086 8.56466 31.3334 9.34892 31.3334 10.1667V11.7083M31.3334 27.125V28.6667C31.3334 29.4844 31.0086 30.2687 30.4303 30.8469C29.8521 31.4252 29.0678 31.75 28.2501 31.75H26.7084M31.3334 17.875V20.9583M19.0001 4V34.8333"
//         stroke="#080808"
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   );
// }

export function GridIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.27 22.75H4.23C2.22 22.75 1.25 21.82 1.25 19.9V4.1C1.25 2.18 2.23 1.25 4.23 1.25H8.27C10.28 1.25 11.25 2.18 11.25 4.1V19.9C11.25 21.82 10.27 22.75 8.27 22.75ZM4.23 2.75C2.96 2.75 2.75 3.09 2.75 4.1V19.9C2.75 20.91 2.96 21.25 4.23 21.25H8.27C9.54 21.25 9.75 20.91 9.75 19.9V4.1C9.75 3.09 9.54 2.75 8.27 2.75H4.23Z"
        fill="#292D32"
      />
      <path
        d="M19.77 22.75H15.73C13.72 22.75 12.75 21.82 12.75 19.9V4.1C12.75 2.18 13.73 1.25 15.73 1.25H19.77C21.78 1.25 22.75 2.18 22.75 4.1V19.9C22.75 21.82 21.77 22.75 19.77 22.75ZM15.73 2.75C14.46 2.75 14.25 3.09 14.25 4.1V19.9C14.25 20.91 14.46 21.25 15.73 21.25H19.77C21.04 21.25 21.25 20.91 21.25 19.9V4.1C21.25 3.09 21.04 2.75 19.77 2.75H15.73Z"
        fill="#292D32"
      />
    </svg>
  );
}

export function ListIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.9 22.75H4.1C2.18 22.75 1.25 21.77 1.25 19.77V15.73C1.25 13.72 2.18 12.75 4.1 12.75H19.9C21.82 12.75 22.75 13.73 22.75 15.73V19.77C22.75 21.77 21.82 22.75 19.9 22.75ZM4.1 14.25C3.09 14.25 2.75 14.46 2.75 15.73V19.77C2.75 21.04 3.09 21.25 4.1 21.25H19.9C20.91 21.25 21.25 21.04 21.25 19.77V15.73C21.25 14.46 20.91 14.25 19.9 14.25H4.1Z"
        fill="#292D32"
      />
      <path
        d="M19.9 11.25H4.1C2.18 11.25 1.25 10.27 1.25 8.27V4.23C1.25 2.22 2.18 1.25 4.1 1.25H19.9C21.82 1.25 22.75 2.23 22.75 4.23V8.27C22.75 10.27 21.82 11.25 19.9 11.25ZM4.1 2.75C3.09 2.75 2.75 2.96 2.75 4.23V8.27C2.75 9.54 3.09 9.75 4.1 9.75H19.9C20.91 9.75 21.25 9.54 21.25 8.27V4.23C21.25 2.96 20.91 2.75 19.9 2.75H4.1Z"
        fill="#292D32"
      />
    </svg>
  );
}

export function SwapIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.4219 14.3599V3.01172"
        stroke="#08080C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8197 10.9473L12.4216 14.3612L9.02344 10.9473"
        stroke="#08080C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.14851 0.75V12.0981"
        stroke="#08080C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 4.16389L4.14815 0.75L7.5463 4.16389"
        stroke="#08080C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ToTopIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.75 7.75L7.75 0.75M7.75 0.75L14.75 7.75M7.75 0.75L7.75 18.75"
        stroke="#292B22"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NavigationIcon(props: IconProps) {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="55" height="55" rx="27.5" fill="white" />
      <rect x="0.5" y="0.5" width="55" height="55" rx="27.5" stroke="#00953B" />
      <path
        d="M24.5 21L31.5 28L24.5 35"
        stroke="#08080C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NavigationV2Icon(props: IconProps) {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="41" height="41" rx="20.5" fill="white" />
      <rect x="0.5" y="0.5" width="41" height="41" rx="20.5" stroke="#E1E1E1" />
      <path
        d="M18 14L25 21L18 28"
        stroke="#08080C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function HomeIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.40002 13.713C2.40002 8.082 3.01402 8.475 6.31902 5.41C7.76502 4.246 10.015 2 11.958 2C13.9 2 16.195 4.235 17.654 5.41C20.959 8.475 21.572 8.082 21.572 13.713C21.572 22 19.613 22 11.986 22C4.35903 22 2.40002 22 2.40002 13.713Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.07874 16.1357H14.8937"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ShopIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.875 7.125H4.125V21.375H19.875V7.125Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.625 11.625C8.625 13.875 10.125 15.375 12 15.375C13.875 15.375 15.375 13.875 15.375 11.625M4.125 7.125L6.375 2.625H17.625L19.875 7.125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AccountIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8445 21.6618C8.15273 21.6618 5 21.0873 5 18.7865C5 16.4858 8.13273 14.3618 11.8445 14.3618C15.5364 14.3618 18.6891 16.4652 18.6891 18.766C18.6891 21.0658 15.5564 21.6618 11.8445 21.6618Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8373 11.1735C14.26 11.1735 16.2237 9.2099 16.2237 6.78718C16.2237 4.36445 14.26 2.3999 11.8373 2.3999C9.41457 2.3999 7.45002 4.36445 7.45002 6.78718C7.44184 9.20172 9.39184 11.1654 11.8064 11.1735C11.8173 11.1735 11.8273 11.1735 11.8373 11.1735Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NavigatorCartIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.42786 5.70482C4.41544 5.5673 4.43179 5.4287 4.47589 5.29785C4.51999 5.167 4.59086 5.04677 4.68399 4.94482C4.77712 4.84287 4.89046 4.76144 5.0168 4.70572C5.14314 4.65 5.2797 4.6212 5.41778 4.62117H17.47C17.6189 4.62123 17.7658 4.65472 17.9 4.71917C18.0342 4.78361 18.1522 4.87737 18.2453 4.99351C18.3384 5.10966 18.4043 5.24523 18.438 5.39022C18.4717 5.53521 18.4724 5.68592 18.4401 5.83122L17.4217 10.4215C17.2466 11.2103 16.8075 11.9158 16.1772 12.4214C15.5469 12.927 14.763 13.2025 13.9549 13.2023H8.34918C7.46278 13.2024 6.60841 12.8709 5.95402 12.273C5.29962 11.6751 4.89253 10.8541 4.81275 9.97126L4.42786 5.70482ZM5.88362 6.04142L6.22732 9.84343C6.27521 10.3734 6.51967 10.8662 6.9126 11.225C7.30554 11.5837 7.81851 11.7825 8.3506 11.7821H13.9563C14.4411 11.782 14.9112 11.6165 15.2893 11.3131C15.6673 11.0097 15.9306 10.5865 16.0356 10.1133L16.9403 6.04142H5.88362Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.49089 2.23763C1.49089 2.04929 1.56571 1.86867 1.69888 1.7355C1.83206 1.60232 2.01268 1.5275 2.20102 1.5275H4.69214C4.86584 1.52768 5.03345 1.59152 5.16327 1.70693C5.29308 1.82235 5.37609 1.98135 5.39658 2.15383L5.96752 6.98411C5.98956 7.17132 5.93632 7.35961 5.81953 7.50757C5.70274 7.65552 5.53195 7.75102 5.34474 7.77306C5.15754 7.79509 4.96924 7.74186 4.82129 7.62507C4.67333 7.50827 4.57783 7.33749 4.55579 7.15028L4.06013 2.94634H2.20102C2.01268 2.94634 1.83206 2.87152 1.69888 2.73834C1.56571 2.60517 1.49089 2.42597 1.49089 2.23763ZM7.88202 16.9131C8.07036 16.9131 8.25098 16.8383 8.38416 16.7051C8.51733 16.5719 8.59215 16.3913 8.59215 16.203C8.59215 16.0146 8.51733 15.834 8.38416 15.7008C8.25098 15.5677 8.07036 15.4928 7.88202 15.4928C7.69368 15.4928 7.51306 15.5677 7.37989 15.7008C7.24671 15.834 7.1719 16.0146 7.1719 16.203C7.1719 16.3913 7.24671 16.5719 7.37989 16.7051C7.51306 16.8383 7.69368 16.9131 7.88202 16.9131ZM7.88202 18.3333C8.16179 18.3333 8.43881 18.2782 8.69728 18.1712C8.95575 18.0641 9.1906 17.9072 9.38843 17.7094C9.58625 17.5115 9.74317 17.2767 9.85023 17.0182C9.9573 16.7598 10.0124 16.4827 10.0124 16.203C10.0124 15.9232 9.9573 15.6462 9.85023 15.3877C9.74317 15.1292 9.58625 14.8944 9.38843 14.6966C9.1906 14.4987 8.95575 14.3418 8.69728 14.2347C8.43881 14.1277 8.16179 14.0726 7.88202 14.0726C7.31701 14.0726 6.77514 14.297 6.37562 14.6966C5.97609 15.0961 5.75164 15.6379 5.75164 16.203C5.75164 16.768 5.97609 17.3098 6.37562 17.7094C6.77514 18.1089 7.31701 18.3333 7.88202 18.3333ZM14.3612 16.9131C14.5495 16.9131 14.7302 16.8383 14.8633 16.7051C14.9965 16.5719 15.0713 16.3913 15.0713 16.203C15.0713 16.0146 14.9965 15.834 14.8633 15.7008C14.7302 15.5677 14.5495 15.4928 14.3612 15.4928C14.1729 15.4928 13.9922 15.5677 13.8591 15.7008C13.7259 15.834 13.6511 16.0146 13.6511 16.203C13.6511 16.3913 13.7259 16.5719 13.8591 16.7051C13.9922 16.8383 14.1729 16.9131 14.3612 16.9131ZM14.3612 18.3333C14.641 18.3333 14.918 18.2782 15.1765 18.1712C15.4349 18.0641 15.6698 17.9072 15.8676 17.7094C16.0654 17.5115 16.2224 17.2767 16.3294 17.0182C16.4365 16.7598 16.4916 16.4827 16.4916 16.203C16.4916 15.9232 16.4365 15.6462 16.3294 15.3877C16.2224 15.1292 16.0654 14.8944 15.8676 14.6966C15.6698 14.4987 15.4349 14.3418 15.1765 14.2347C14.918 14.1277 14.641 14.0726 14.3612 14.0726C13.7962 14.0726 13.2543 14.297 12.8548 14.6966C12.4553 15.0961 12.2308 15.6379 12.2308 16.203C12.2308 16.768 12.4553 17.3098 12.8548 17.7094C13.2543 18.1089 13.7962 18.3333 14.3612 18.3333Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function NavigatorSearchIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.893 16.92L19.973 20M19 11.5C19 13.4891 18.2098 15.3968 16.8033 16.8033C15.3968 18.2098 13.4891 19 11.5 19C9.51088 19 7.60322 18.2098 6.1967 16.8033C4.79018 15.3968 4 13.4891 4 11.5C4 9.51088 4.79018 7.60322 6.1967 6.1967C7.60322 4.79018 9.51088 4 11.5 4C13.4891 4 15.3968 4.79018 16.8033 6.1967C18.2098 7.60322 19 9.51088 19 11.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SortIcon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99991 11.9048L13.8094 15.8162L17.619 11.9048M9.99991 8.09523L6.19038 4.28571M6.19038 4.28571L2.38086 8.09237M6.19038 4.28571V15.7143M13.8094 4.28571V15.7143"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MobileFiltersIcon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.25 5.625H18.75M4.375 10H15.625M8.125 14.375H11.875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ZoomIcon(props: IconProps) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.3902 7.00935C11.6225 7.0093 11.8454 6.91695 12.0096 6.75263L15.771 2.99124V5.25701C15.771 5.48938 15.8633 5.71224 16.0276 5.87655C16.192 6.04087 16.4148 6.13318 16.6472 6.13318C16.8796 6.13318 17.1024 6.04087 17.2667 5.87655C17.4311 5.71224 17.5234 5.48938 17.5234 5.25701V0.876168C17.5234 0.643794 17.4311 0.420937 17.2667 0.256624C17.1024 0.0923103 16.8796 0 16.6472 0H12.2664C12.034 0 11.8111 0.0923103 11.6468 0.256624C11.4825 0.420937 11.3902 0.643794 11.3902 0.876168C11.3902 1.10854 11.4825 1.3314 11.6468 1.49571C11.8111 1.66003 12.034 1.75234 12.2664 1.75234H14.5321L10.7707 5.51373C10.6482 5.63626 10.5648 5.79236 10.531 5.9623C10.4972 6.13223 10.5146 6.30837 10.5809 6.46845C10.6472 6.62852 10.7595 6.76535 10.9035 6.86162C11.0476 6.9579 11.2169 7.00931 11.3902 7.00935ZM0.876168 17.5234H5.25701C5.48938 17.5234 5.71224 17.4311 5.87655 17.2667C6.04087 17.1024 6.13318 16.8796 6.13318 16.6472C6.13318 16.4148 6.04087 16.192 5.87655 16.0276C5.71224 15.8633 5.48938 15.771 5.25701 15.771H2.99124L6.75263 12.0096C6.91223 11.8444 7.00054 11.6231 6.99855 11.3933C6.99655 11.1636 6.9044 10.9439 6.74195 10.7814C6.57951 10.619 6.35975 10.5268 6.13002 10.5248C5.90029 10.5228 5.67897 10.6111 5.51373 10.7707L1.75234 14.5321V12.2664C1.75234 12.034 1.66003 11.8111 1.49571 11.6468C1.3314 11.4825 1.10854 11.3902 0.876168 11.3902C0.643794 11.3902 0.420937 11.4825 0.256624 11.6468C0.0923103 11.8111 0 12.034 0 12.2664V16.6472C0 16.8796 0.0923103 17.1024 0.256624 17.2667C0.420937 17.4311 0.643794 17.5234 0.876168 17.5234Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function DeleteIcon2(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.8892 9.55414C18.8892 17.5732 20.0435 21.1979 12.2797 21.1979C4.5149 21.1979 5.693 17.5732 5.693 9.55414"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.3651 6.47985H4.2146"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7148 6.47983C15.7148 6.47983 16.2434 2.71411 12.2891 2.71411C8.33578 2.71411 8.86435 6.47983 8.86435 6.47983"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AddToCartIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5 11.25H11.5M14 8.75V13.75M1.50347 2.764C1.52697 2.031 2.16197 1.5 2.89547 1.5H4.99047C5.52121 1.49989 6.03821 1.66869 6.46663 1.98196C6.89505 2.29523 7.21266 2.73671 7.37347 3.2425L8.24997 6H20.24C21.441 6 22.3715 7.052 22.1545 8.233C21.748 10.447 21.141 12.796 20.4595 14.7315C20.169 15.555 19.486 16.1545 18.6195 16.2645C17.6865 16.3835 16.208 16.5 13.9995 16.5C11.8565 16.5 10.3545 16.39 9.36847 16.275C8.39347 16.1615 7.63347 15.4625 7.33747 14.526C6.24747 11.085 5.52497 8.03 4.49997 4.5H2.89497C2.16197 4.5 1.52697 3.969 1.50347 3.236C1.49852 3.07871 1.49852 2.92129 1.50347 2.764ZM17 20.5C17 21.0304 17.2107 21.5391 17.5858 21.9142C17.9608 22.2893 18.4695 22.5 19 22.5C19.5304 22.5 20.0391 22.2893 20.4142 21.9142C20.7893 21.5391 21 21.0304 21 20.5C21 19.9696 20.7893 19.4609 20.4142 19.0858C20.0391 18.7107 19.5304 18.5 19 18.5C18.4695 18.5 17.9608 18.7107 17.5858 19.0858C17.2107 19.4609 17 19.9696 17 20.5ZM6.99997 20.5C6.99997 21.0304 7.21068 21.5391 7.58576 21.9142C7.96083 22.2893 8.46954 22.5 8.99997 22.5C9.5304 22.5 10.0391 22.2893 10.4142 21.9142C10.7893 21.5391 11 21.0304 11 20.5C11 19.9696 10.7893 19.4609 10.4142 19.0858C10.0391 18.7107 9.5304 18.5 8.99997 18.5C8.46954 18.5 7.96083 18.7107 7.58576 19.0858C7.21068 19.4609 6.99997 19.9696 6.99997 20.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LoginIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 13c2.396 0 4.575.694 6.178 1.672.8.488 1.484 1.064 1.978 1.69.486.615.844 1.351.844 2.138 0 .845-.411 1.511-1.003 1.986-.56.45-1.299.748-2.084.956-1.578.417-3.684.558-5.913.558s-4.335-.14-5.913-.558c-.785-.208-1.524-.506-2.084-.956C3.41 20.01 3 19.345 3 18.5c0-.787.358-1.523.844-2.139.494-.625 1.177-1.2 1.978-1.69C7.425 13.695 9.605 13 12 13m0 2c-2.023 0-3.843.59-5.136 1.379-.647.394-1.135.822-1.45 1.222-.324.41-.414.72-.414.899 0 .122.037.251.255.426.249.2.682.407 1.344.582C7.917 19.858 9.811 20 12 20c2.19 0 4.083-.143 5.4-.492.663-.175 1.096-.382 1.345-.582.218-.175.255-.304.255-.426 0-.18-.09-.489-.413-.899-.316-.4-.804-.828-1.451-1.222C15.843 15.589 14.023 15 12 15m0-13a5 5 0 1 1 0 10 5 5 0 0 1 0-10m0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
      />
    </svg>
  );
}

export function RegisterIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 3a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 0 1 1-1"
      />
    </svg>
  );
}

export function ErrorIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2M9.879 8.464a1 1 0 0 0-1.498 1.32l.084.095 2.12 2.12-2.12 2.122a1 1 0 0 0 1.32 1.498l.094-.083L12 13.414l2.121 2.122a1 1 0 0 0 1.498-1.32l-.083-.095L13.414 12l2.122-2.121a1 1 0 0 0-1.32-1.498l-.095.083L12 10.586z"
      />
    </svg>
  );
}

export function WarningIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-9a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1"
      />
    </svg>
  );
}

export function HelpIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.00065 14.6654C4.31865 14.6654 1.33398 11.6807 1.33398 7.9987C1.33398 4.3167 4.31865 1.33203 8.00065 1.33203C11.6827 1.33203 14.6673 4.3167 14.6673 7.9987C14.6673 11.6807 11.6827 14.6654 8.00065 14.6654ZM8.00065 13.332C9.41514 13.332 10.7717 12.7701 11.7719 11.7699C12.7721 10.7697 13.334 9.41319 13.334 7.9987C13.334 6.58421 12.7721 5.22766 11.7719 4.22746C10.7717 3.22727 9.41514 2.66536 8.00065 2.66536C6.58616 2.66536 5.22961 3.22727 4.22941 4.22746C3.22922 5.22766 2.66732 6.58421 2.66732 7.9987C2.66732 9.41319 3.22922 10.7697 4.22941 11.7699C5.22961 12.7701 6.58616 13.332 8.00065 13.332ZM7.33398 9.9987H8.66732V11.332H7.33398V9.9987ZM8.66732 8.90203V9.33203H7.33398V8.33203C7.33398 8.15522 7.40422 7.98565 7.52925 7.86063C7.65427 7.7356 7.82384 7.66536 8.00065 7.66536C8.19004 7.66535 8.37552 7.61156 8.53553 7.51025C8.69554 7.40894 8.82349 7.26427 8.9045 7.09309C8.9855 6.9219 9.01623 6.73123 8.9931 6.54326C8.96998 6.35529 8.89395 6.17775 8.77387 6.0313C8.65379 5.88486 8.49459 5.77552 8.3148 5.71601C8.135 5.6565 7.94201 5.64928 7.75827 5.69517C7.57453 5.74106 7.40759 5.83818 7.2769 5.97524C7.1462 6.1123 7.0571 6.28365 7.01998 6.46936L5.71198 6.20736C5.79307 5.80209 5.98032 5.42561 6.2546 5.11642C6.52887 4.80723 6.88033 4.57642 7.27304 4.44758C7.66576 4.31874 8.08564 4.29649 8.48977 4.38311C8.8939 4.46973 9.26778 4.66211 9.5732 4.94058C9.87861 5.21905 10.1046 5.57364 10.2281 5.96807C10.3515 6.36251 10.368 6.78266 10.2759 7.18557C10.1838 7.58848 9.98629 7.9597 9.70366 8.26127C9.42104 8.56285 9.06341 8.78397 8.66732 8.90203Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function WindIcon(props: IconProps) {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.5 17.3994C3.5 10.6899 8.84187 5.25 15.4315 5.25C20.9414 5.25 25.5798 9.05275 26.9518 14.2214C28.0623 13.6466 29.2949 13.3476 30.5454 13.3499C34.9379 13.3499 38.5 16.9759 38.5 21.4497C38.5 24.6365 36.6923 27.3936 34.0638 28.7158C33.845 28.826 33.6 28.875 33.355 28.875H13.125H10.5C9.57174 28.875 8.6815 29.2437 8.02513 29.9001C7.36875 30.5565 7 31.4467 7 32.375C7 33.3033 7.36875 34.1935 8.02513 34.8499C8.6815 35.5063 9.57174 35.875 10.5 35.875H13.125"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.25 15.75H16.625C15.6967 15.75 14.8065 16.1187 14.1501 16.7751C13.4937 17.4315 13.125 18.3217 13.125 19.25C13.125 20.1783 13.4937 21.0685 14.1501 21.7249C14.8065 22.3813 15.6967 22.75 16.625 22.75M16.625 22.75H19.25M16.625 22.75H28"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SunIcon(props: IconProps) {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 5.25V8.75M21 33.257V36.757M8.75 21H5.25M36.75 21H33.25M33.25 8.75L29.75 12.25M8.75 8.75L12.25 12.25M12.25 29.75L8.75 33.25M33.25 33.25L29.75 29.75M28 21C28 22.8565 27.2625 24.637 25.9497 25.9497C24.637 27.2625 22.8565 28 21 28C19.1435 28 17.363 27.2625 16.0503 25.9497C14.7375 24.637 14 22.8565 14 21C14 19.1435 14.7375 17.363 16.0503 16.0503C17.363 14.7375 19.1435 14 21 14C22.8565 14 24.637 14.7375 25.9497 16.0503C27.2625 17.363 28 19.1435 28 21Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CloudIcon(props: IconProps) {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.375 35C8.715 35 6.44583 34.0842 4.5675 32.2525C2.68917 30.4092 1.75 28.1633 1.75 25.515C1.75 23.24 2.4325 21.21 3.7975 19.425C5.17417 17.64 6.97083 16.5025 9.1875 16.0125C9.9225 13.3292 11.3808 11.1592 13.5625 9.5025C15.7558 7.83417 18.235 7 21 7C24.4183 7 27.3117 8.19 29.68 10.57C32.06 12.9383 33.25 15.8317 33.25 19.25C35.2683 19.4833 36.9367 20.3583 38.255 21.875C39.585 23.3683 40.25 25.1183 40.25 27.125C40.25 29.3183 39.4858 31.1792 37.9575 32.7075C36.4292 34.2358 34.5683 35 32.375 35M11.375 31.5H32.375C33.6 31.5 34.6325 31.0742 35.4725 30.2225C36.3242 29.3825 36.75 28.35 36.75 27.125C36.75 25.9 36.3242 24.8675 35.4725 24.0275C34.6325 23.1758 33.6 22.75 32.375 22.75H29.75V19.25C29.75 16.835 28.8983 14.77 27.195 13.055C25.4917 11.3517 23.4267 10.5 21 10.5C18.585 10.5 16.52 11.3517 14.805 13.055C13.1017 14.77 12.25 16.835 12.25 19.25H11.375C9.68333 19.25 8.2425 19.8508 7.0525 21.0525C5.85083 22.2425 5.25 23.6833 5.25 25.375C5.25 27.0667 5.85083 28.525 7.0525 29.75C8.2425 30.9167 9.68333 31.5 11.375 31.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function RepeatIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M20 9a1 1 0 0 1 .993.883L21 10v5a4 4 0 0 1-3.8 3.995L17 19H8.107l-.02.415-.034.519c-.027.346-.352.557-.631.41l-.306-.164-.36-.203-.198-.117-.43-.263a20.62 20.62 0 0 1-.229-.147l-.463-.31-.21-.147-.377-.273-.315-.24a16.254 16.254 0 0 1-.133-.104c-.236-.188-.225-.566.023-.762l.28-.217.34-.252.4-.282.456-.305.462-.291.416-.249.365-.205.307-.165c.275-.143.571.036.598.36l.025.347.024.415.01.23H17a2 2 0 0 0 1.995-1.85L19 15v-5a1 1 0 0 1 1-1m-3.422-5.345.306.165.36.203.198.117.43.263.229.147.463.31.21.147.377.273.315.24.133.104c.236.188.225.566-.023.762l-.28.217-.34.252-.4.282-.456.305-.462.291-.416.249-.365.205-.307.165c-.275.143-.572-.036-.598-.36l-.025-.347-.024-.415a24.926 24.926 0 0 1-.01-.23H7a2 2 0 0 0-2 2v5a1 1 0 1 1-2 0V9a4 4 0 0 1 4-4h8.893l.02-.415.022-.36.012-.159c.027-.346.352-.557.631-.41Z"
      />
    </svg>
  );
}

export function WhatsappIcon2(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <title>whatsapp_line</title>
      <g id="whatsapp_line" fill="none">
        <path d="M24 0v24H0V0zM12.593 23.258l-.011.002-.071.035-.02.004-.014-.004-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113-.013.002-.185.093-.01.01-.003.011.018.43.005.012.008.007.201.093c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.004-.011.017-.43-.003-.012-.01-.01z" />
        <path
          fill="currentColor"
          d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.958 9.958 0 0 1-4.863-1.26l-.305-.178-3.032.892a1.01 1.01 0 0 1-1.28-1.145l.026-.109.892-3.032A9.958 9.958 0 0 1 2 12C2 6.477 6.477 2 12 2m0 2a8 8 0 0 0-6.759 12.282c.198.312.283.696.216 1.077l-.039.163-.441 1.501 1.501-.441c.433-.128.883-.05 1.24.177A8 8 0 1 0 12 4M9.102 7.184a.695.695 0 0 1 .684.075c.504.368.904.862 1.248 1.344l.327.474.153.225a.712.712 0 0 1-.046.864l-.075.076-.924.686a.227.227 0 0 0-.067.291c.21.38.581.947 1.007 1.373.427.426 1.02.822 1.426 1.055.088.05.194.034.266-.031l.038-.045.601-.915a.711.711 0 0 1 .973-.158l.543.379c.54.385 1.059.799 1.47 1.324a.696.696 0 0 1 .089.703c-.396.924-1.399 1.711-2.441 1.673l-.159-.01-.191-.018a4.966 4.966 0 0 1-.108-.014l-.238-.04c-.924-.174-2.405-.698-3.94-2.232-1.534-1.535-2.058-3.016-2.232-3.94l-.04-.238-.025-.208-.013-.175a3.76 3.76 0 0 1-.004-.075c-.038-1.044.753-2.047 1.678-2.443"
        />
      </g>
    </svg>
  );
}

export function HomeIconError(props: IconProps) {
  return (
    <svg
      className={cn("h-5 w-5", props.className)}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
      />
    </svg>
  );
}

export function ArrowLeftIconError(props: IconProps) {
  return (
    <svg
      className={cn("h-5 w-5", props.className)}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10 19l-7-7m0 0l7-7m-7 7h18"
      />
    </svg>
  );
}

export function CalendarIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        id="Line_200"
        d="M2.19141 7.16133H14.8167"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line_201"
        d="M11.6471 9.92695H11.6536"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line_202"
        d="M8.50255 9.92695H8.50912"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line_203"
        d="M5.35412 9.92695H5.36068"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line_204"
        d="M11.6471 12.6799H11.6536"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line_205"
        d="M8.50255 12.6799H8.50912"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line_206"
        d="M5.35412 12.6799H5.36068"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line_207"
        d="M11.3652 1.91626V4.24723"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line_208"
        d="M5.64255 1.91626V4.24723"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Path"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5021 3.03442H5.50443C3.42428 3.03442 2.125 4.19321 2.125 6.32323V12.7334C2.125 14.8969 3.42428 16.0825 5.50443 16.0825H11.4955C13.5823 16.0825 14.875 14.917 14.875 12.787V6.32323C14.8815 4.19321 13.5888 3.03442 11.5021 3.03442Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
